/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Currency: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  EmailAddress: { input: string; output: string; }
  HexColorCode: { input: string; output: string; }
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  Latitude: { input: number; output: number; }
  Longitude: { input: number; output: number; }
  ObjectID: { input: string; output: string; }
  TimeZone: { input: string; output: string; }
  URL: { input: string; output: string; }
  Void: { input: void; output: void; }
};

export type ACCOUNTING_JOURNAL_TRANSACTION_TYPE =
  | 'payable'
  | 'receivable';

export type ADMIN_PAYWAY_CHECKOUT_KIND =
  | 'existing_order'
  | 'new_order';

export type ADMIN_STAFF_STATUS =
  | 'active'
  | 'all'
  | 'deleted';

export type ADMIN_VENUE_SORT =
  | 'created_at_desc'
  | 'name_asc';

export type AccountingJournal = {
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  created_at: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  transactions: Array<AccountingJournalTransaction>;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type AccountingJournalInput = {
  date: Scalars['DateTime']['input'];
  transactions: Array<AccountingJournalTransactionInput>;
};

export type AccountingJournalTransaction = {
  amount: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  type: ACCOUNTING_JOURNAL_TRANSACTION_TYPE;
};

export type AccountingJournalTransactionInput = {
  amount: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  type: ACCOUNTING_JOURNAL_TRANSACTION_TYPE;
};

export type ActiveMenuItemsQrResults = {
  items: Array<Item>;
  total: Scalars['Int']['output'];
};

export type AdminLoginPayload = {
  admin: AdminUser;
  expires_at: Scalars['DateTime']['output'];
  /** Send as `Authorization: Admin <token>`; it is sudo and expires at `expires_at`. */
  token: Scalars['String']['output'];
};

export type AdminPaywayCheckout = {
  amount: Scalars['Float']['output'];
  /** When the cached order expires and the checkout stops being processed. */
  expires_at: Scalars['DateTime']['output'];
  kind: ADMIN_PAYWAY_CHECKOUT_KIND;
  payway_ref: Scalars['String']['output'];
  started_at: Scalars['DateTime']['output'];
  tran_id: Scalars['String']['output'];
  venue_id: Scalars['ObjectID']['output'];
  venue_name?: Maybe<Scalars['String']['output']>;
};

export type AdminStaff = {
  _id: Scalars['ObjectID']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  type: ROLE_TYPE;
  username: Scalars['String']['output'];
  venue_id: Scalars['ObjectID']['output'];
  venue_name?: Maybe<Scalars['String']['output']>;
};

export type AdminStaffFilter = {
  status?: InputMaybe<ADMIN_STAFF_STATUS>;
  type?: InputMaybe<ROLE_TYPE>;
  username_prefix?: InputMaybe<Scalars['String']['input']>;
  venue_id?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type AdminStaffPage = {
  items: Array<AdminStaff>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  /** Staff matching the filter, across all pages. */
  total: Scalars['Int']['output'];
};

export type AdminTempOrder = {
  temp_order: TempOrder;
  tran_id?: Maybe<Scalars['String']['output']>;
  venue_id?: Maybe<Scalars['ObjectID']['output']>;
  venue_name?: Maybe<Scalars['String']['output']>;
};

export type AdminTempOrderPage = {
  items: Array<AdminTempOrder>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminUser = {
  _id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type AdminVenue = {
  _id: Scalars['ObjectID']['output'];
  address: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  is_payway_integration_enabled: Scalars['Boolean']['output'];
  /** Only set by `adminVenues`. */
  last_order_at?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type AdminVenueCounts = {
  active_staff: Scalars['Int']['output'];
  categories: Scalars['Int']['output'];
  deleted_staff: Scalars['Int']['output'];
  items: Scalars['Int']['output'];
  locations: Scalars['Int']['output'];
  menus: Scalars['Int']['output'];
  orders_last_7_days: Scalars['Int']['output'];
  orders_last_24_hours: Scalars['Int']['output'];
};

export type AdminVenueDetail = {
  counts: AdminVenueCounts;
  /** The venue's `is_*_enabled` flags. */
  features: Array<AdminVenueFeature>;
  super_admins: Array<AdminStaff>;
  venue: AdminVenue;
};

export type AdminVenueFeature = {
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

export type AdminVenuePage = {
  items: Array<AdminVenue>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  /** Venues matching the search, across all pages. */
  total: Scalars['Int']['output'];
};

export type AiConfig = {
  /** Last four characters of the stored API key; the key itself is never returned. */
  api_key_last4?: Maybe<Scalars['String']['output']>;
  base_url?: Maybe<Scalars['String']['output']>;
  model_text?: Maybe<Scalars['String']['output']>;
  model_vision?: Maybe<Scalars['String']['output']>;
};

export type ApiKey = {
  _created_by: Role;
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['ObjectID']['output'];
  key_prefix: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type Availability = {
  days?: Maybe<Array<Scalars['Int']['output']>>;
  times?: Maybe<Array<AvailabilityTimeWindow>>;
};

export type AvailabilityInput = {
  days?: InputMaybe<Array<Scalars['Int']['input']>>;
  times?: InputMaybe<Array<AvailabilityTimeWindowInput>>;
};

export type AvailabilityTimeWindow = {
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type AvailabilityTimeWindowInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type BulkUpdateCategoriesInput = {
  id: Scalars['ObjectID']['input'];
  input: UpdateCategoryInput;
};

export type BulkUpdateItemsInput = {
  id: Scalars['ObjectID']['input'];
  input: UpdateItemInput;
};

export type CREATE_PRE_SIGNED_URL_TYPE =
  | 'item'
  | 'menu'
  | 'venue_banner'
  | 'venue_logo';

export type CUSTOM_REPORT_DISPLAY_TYPE =
  | 'doughnut'
  | 'table';

export type CUSTOM_REPORT_VALUE_FIELD =
  | 'adjustment'
  | 'cancelledValue'
  | 'count'
  | 'discount'
  | 'grossSales'
  | 'netSales'
  | 'offer'
  | 'serviceCharge'
  | 'subtotal'
  | 'unitPrice'
  | 'vat';

export type CUSTOM_REPORT_VALUE_TYPE =
  | 'category'
  | 'item'
  | 'itemType'
  | 'location'
  | 'locationGroupTag'
  | 'offer'
  | 'option'
  | 'paymentType';

export type CacheControlScope =
  | 'PRIVATE'
  | 'PUBLIC';

export type Category = {
  _clone_from?: Maybe<Category>;
  _id: Scalars['ObjectID']['output'];
  _menu: Menu;
  _pos_items_count: Scalars['Int']['output'];
  _qr_items_count: Scalars['Int']['output'];
  _venue: Venue;
  availability?: Maybe<Availability>;
  clone_from?: Maybe<Scalars['ObjectID']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  is_template: Scalars['Boolean']['output'];
  menu: Scalars['ObjectID']['output'];
  ordering_index: Scalars['Int']['output'];
  till_card_color?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  title_localized?: Maybe<ItemLocalizedText>;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type CheckoutWithPayWayInput = {
  orderData?: InputMaybe<CreateQrOrderInput>;
  orderId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type CheckoutWithPayWayResult = {
  /** ABA Mobile payment link (abamobilebank://). */
  abapay_deeplink?: Maybe<Scalars['String']['output']>;
  /** HTTPS page displaying the payment QR. */
  checkout_qr_url?: Maybe<Scalars['String']['output']>;
  payway_ref: Scalars['String']['output'];
  /** KHQR payload for rendering a QR that participating banking apps can scan. */
  qr_string?: Maybe<Scalars['String']['output']>;
};

export type CloudbedsIntegrationInfo = {
  api_key: Scalars['String']['output'];
  property_id: Scalars['String']['output'];
};

export type CloudbedsPaymentInput = {
  reservation_id: Scalars['String']['input'];
};

export type CloudbedsReservationItem = {
  guestID: Scalars['String']['output'];
  guestName: Scalars['String']['output'];
  reservationID: Scalars['String']['output'];
  roomsNames: Array<Scalars['String']['output']>;
};

export type CloudbedsReservationResponse = {
  items: Array<CloudbedsReservationItem>;
  total: Scalars['Int']['output'];
};

export type ConsumedRecipeRawMaterialUsed = {
  _raw_material: RawMaterial;
  _unit_of_measurement: Scalars['ObjectID']['output'];
  consumed_quantity: Scalars['Float']['output'];
  consumed_unit_of_measurement: Scalars['ObjectID']['output'];
  raw_material: Scalars['ObjectID']['output'];
  unit_of_measurement: Scalars['ObjectID']['output'];
  unit_of_measurement_metadata: Scalars['JSON']['output'];
};

export type Counter = {
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  seq: Scalars['Int']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type CreateApiKeyInput = {
  name: Scalars['String']['input'];
};

export type CreateApiKeyPayload = {
  apiKey: ApiKey;
  rawKey: Scalars['String']['output'];
};

export type CreateCategoryInput = {
  availability?: InputMaybe<AvailabilityInput>;
  clone_from?: InputMaybe<Scalars['ObjectID']['input']>;
  is_template: Scalars['Boolean']['input'];
  menu: Scalars['ObjectID']['input'];
  ordering_index: Scalars['Int']['input'];
  till_card_color?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  title_localized?: InputMaybe<ItemLocalizedTextInput>;
};

export type CreateCustomReportInput = {
  display_type: CUSTOM_REPORT_DISPLAY_TYPE;
  doughnut_configs?: InputMaybe<CustomReportDoughnutInput>;
  table_configs?: InputMaybe<CustomReportTableConfigInput>;
};

export type CreateItemInput = {
  availability?: InputMaybe<AvailabilityInput>;
  banner_img?: InputMaybe<Scalars['URL']['input']>;
  category: Scalars['ObjectID']['input'];
  clone_from?: InputMaybe<Scalars['ObjectID']['input']>;
  cost: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  description_localized?: InputMaybe<ItemLocalizedTextInput>;
  extra_quantity: Scalars['Int']['input'];
  is_cost_automatically_calculated?: InputMaybe<Scalars['Boolean']['input']>;
  is_hide_from_receipt: Scalars['Boolean']['input'];
  is_master?: InputMaybe<Scalars['Boolean']['input']>;
  is_open_item: Scalars['Boolean']['input'];
  is_pos_enabled: Scalars['Boolean']['input'];
  is_qr_enabled: Scalars['Boolean']['input'];
  is_template: Scalars['Boolean']['input'];
  item_id: Scalars['String']['input'];
  item_tags?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  listed_price: Scalars['Float']['input'];
  master_items?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  menu: Scalars['ObjectID']['input'];
  minimum_required_price: Scalars['Float']['input'];
  no_service_charge: Scalars['Boolean']['input'];
  no_vat: Scalars['Boolean']['input'];
  option_groups: Array<ItemOptionGroupInput>;
  options: Array<ItemOptionInput>;
  ordering_index: Scalars['Int']['input'];
  original_price: Scalars['Float']['input'];
  original_price_addons: OriginalPriceAddonsInput;
  prep_time: Scalars['Float']['input'];
  printer_tag?: InputMaybe<Scalars['ObjectID']['input']>;
  recipe: Array<RecipeRawMaterialUsedInput>;
  report_tags?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  till_card_color?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  title_localized?: InputMaybe<ItemLocalizedTextInput>;
  type: Scalars['String']['input'];
};

export type CreateMenuInput = {
  banner_img?: InputMaybe<Scalars['URL']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateOptionGroupInput = {
  clone_from?: InputMaybe<Scalars['ObjectID']['input']>;
  menu: Scalars['ObjectID']['input'];
  options: Array<OptionGroupOptionInput>;
  title: Scalars['String']['input'];
};

export type CreateOptionInput = {
  clone_from?: InputMaybe<Scalars['ObjectID']['input']>;
  cost: Scalars['Float']['input'];
  deleted_at?: InputMaybe<Scalars['DateTime']['input']>;
  is_template: Scalars['Boolean']['input'];
  listed_price: Scalars['Float']['input'];
  menu: Scalars['ObjectID']['input'];
  option_id: Scalars['String']['input'];
  original_price: Scalars['Float']['input'];
  original_price_addons: OriginalPriceAddonsInput;
  recipe: Array<RecipeRawMaterialUsedInput>;
  title: Scalars['String']['input'];
  title_localized?: InputMaybe<ItemLocalizedTextInput>;
};

export type CreateOrderItemInput = {
  _id: Scalars['ObjectID']['input'];
  cancelled_amount: Scalars['Float']['input'];
  cancelled_reason?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['ObjectID']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  cost: Scalars['Float']['input'];
  course_index?: InputMaybe<Scalars['Int']['input']>;
  extra_quantity: Scalars['Int']['input'];
  gross_amount: Scalars['Float']['input'];
  is_hide_from_receipt: Scalars['Boolean']['input'];
  is_master?: InputMaybe<Scalars['Boolean']['input']>;
  is_open_item: Scalars['Boolean']['input'];
  item: Scalars['ObjectID']['input'];
  item_id: Scalars['String']['input'];
  listed_price: Scalars['Float']['input'];
  master_parent?: InputMaybe<Scalars['ObjectID']['input']>;
  minimum_required_price: Scalars['Float']['input'];
  net_amount: Scalars['Float']['input'];
  no_service_charge: Scalars['Boolean']['input'];
  no_vat: Scalars['Boolean']['input'];
  non_sales_credit_amount?: InputMaybe<Scalars['Float']['input']>;
  options: Array<CreateOrderItemOptionInput>;
  original_price: Scalars['Float']['input'];
  original_price_addons: OriginalPriceAddonsInput;
  prep_time: Scalars['Float']['input'];
  printer_tag?: InputMaybe<Scalars['ObjectID']['input']>;
  quantity: Scalars['Int']['input'];
  recipe: Array<OrderRecipeRawMaterialUsedInput>;
  serving_quantity: Scalars['Int']['input'];
  subtotal: Scalars['Float']['input'];
  subtotal_addons: SubtotalAddOnsInput;
  title: Scalars['String']['input'];
  title_localized?: InputMaybe<ItemLocalizedTextInput>;
  type: Scalars['String']['input'];
  unit_price: Scalars['Float']['input'];
};

export type CreateOrderItemOptionInput = {
  _id: Scalars['ObjectID']['input'];
  cancelled_amount: Scalars['Float']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  cost: Scalars['Float']['input'];
  gross_amount: Scalars['Float']['input'];
  is_hide_from_receipt: Scalars['Boolean']['input'];
  listed_price: Scalars['Float']['input'];
  net_amount: Scalars['Float']['input'];
  non_sales_credit_amount?: InputMaybe<Scalars['Float']['input']>;
  option: Scalars['ObjectID']['input'];
  option_id: Scalars['String']['input'];
  original_price: Scalars['Float']['input'];
  original_price_addons: OriginalPriceAddonsInput;
  quantity: Scalars['Int']['input'];
  recipe: Array<OrderRecipeRawMaterialUsedInput>;
  serving_quantity: Scalars['Int']['input'];
  subtotal: Scalars['Float']['input'];
  subtotal_addons: SubtotalAddOnsInput;
  title: Scalars['String']['input'];
  title_localized?: InputMaybe<ItemLocalizedTextInput>;
  uid: Scalars['String']['input'];
};

export type CreateOrderItemSubtotalAddOnsAdjustmentInput = {
  amount: Scalars['Float']['input'];
};

export type CreateOrderItemSubtotalAddOnsCardSurchargeInput = {
  amount: Scalars['Float']['input'];
  percentage: Scalars['Float']['input'];
};

export type CreateOrderItemSubtotalAddOnsDiscountInput = {
  amount: Scalars['Float']['input'];
  is_divided: Scalars['Boolean']['input'];
  type: DISCOUNT_TYPE;
  value: Scalars['Float']['input'];
};

export type CreateOrderItemSubtotalAddOnsNonSalesCreditOffsetInput = {
  amount: Scalars['Float']['input'];
};

export type CreateOrderItemSubtotalAddOnsOfferInput = {
  amount: Scalars['Float']['input'];
  is_custom_value?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateOrderItemSubtotalAddOnsServiceChargeInput = {
  amount: Scalars['Float']['input'];
  is_included: Scalars['Boolean']['input'];
  percentage: Scalars['Float']['input'];
};

export type CreateOrderItemSubtotalAddOnsVatInput = {
  amount: Scalars['Float']['input'];
  is_included: Scalars['Boolean']['input'];
  percentage: Scalars['Float']['input'];
};

export type CreateOrderPaymentCashRecordInput = {
  amount: Scalars['Float']['input'];
  code: Scalars['String']['input'];
};

export type CreateOrderPaymentRecordInput = {
  amount: Scalars['Float']['input'];
  code: Scalars['String']['input'];
  kpay_data?: InputMaybe<Scalars['JSON']['input']>;
  payment_type: Scalars['String']['input'];
  payway_data?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateOrderPaymentRoomMasterInput = {
  folio_id: Scalars['String']['input'];
  folio_number: Scalars['String']['input'];
  room_number: Scalars['String']['input'];
};

export type CreatePosOrderInput = {
  customer?: InputMaybe<Scalars['ObjectID']['input']>;
  idempotency_key: Scalars['String']['input'];
  items: Array<CreateOrderItemInput>;
  location: Scalars['ObjectID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  ticket_linebreaks?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreatePosOrderOfflineInput = {
  _id: Scalars['ObjectID']['input'];
  created_at: Scalars['DateTime']['input'];
  customer?: InputMaybe<Scalars['ObjectID']['input']>;
  idempotency_key: Scalars['String']['input'];
  items: Array<CreateOrderItemInput>;
  location: Scalars['ObjectID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  temp_index?: InputMaybe<Scalars['String']['input']>;
  ticket_linebreaks?: InputMaybe<Array<Scalars['Int']['input']>>;
  updated_at: Scalars['DateTime']['input'];
};

export type CreatePreSignedUrlInput = {
  contentType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  type: CREATE_PRE_SIGNED_URL_TYPE;
};

export type CreateQrNotificationInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQrOrderInput = {
  customer?: InputMaybe<Scalars['ObjectID']['input']>;
  idempotency_key: Scalars['String']['input'];
  items: Array<CreateOrderItemInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  payment_types: Array<CreateOrderPaymentRecordInput>;
};

export type CreateRawMaterialCategoryInput = {
  name: Scalars['String']['input'];
};

export type CreateRawMaterialInput = {
  category: Scalars['ObjectID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiration_notification_threshold: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  raw_price: Scalars['Float']['input'];
  replenishment_tolerance: Scalars['Float']['input'];
  required_in_stock_amount: Scalars['Float']['input'];
  shelf_life: Scalars['Float']['input'];
  storage_location?: InputMaybe<Scalars['String']['input']>;
  supplier: Scalars['ObjectID']['input'];
  unit_of_measurement: Scalars['ObjectID']['input'];
};

export type CreateRawMaterialReceivedInput = {
  adjustment_quantity: Scalars['Float']['input'];
  defect_quantity: Scalars['Float']['input'];
  expired_quantity: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  raw_material: Scalars['ObjectID']['input'];
  raw_price: Scalars['Float']['input'];
  received_unit_of_measurement: Scalars['String']['input'];
  starting_quantity?: InputMaybe<Scalars['Float']['input']>;
  supplier: Scalars['ObjectID']['input'];
  transaction_date: Scalars['DateTime']['input'];
  transfer_out_quantity?: InputMaybe<Scalars['Float']['input']>;
  transfer_out_receiver?: InputMaybe<Scalars['ObjectID']['input']>;
  unit_of_measurement_metadata: RawMaterialUnitOfMeasurementInput;
  wastage_quantity: Scalars['Float']['input'];
};

export type CreateRawMaterialReceiverInput = {
  code: Scalars['String']['input'];
  contact_person: Scalars['String']['input'];
  country_of_origin: Scalars['String']['input'];
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
};

export type CreateRawMaterialSupplierInput = {
  code: Scalars['String']['input'];
  contact_person: Scalars['String']['input'];
  country_of_origin: Scalars['String']['input'];
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
};

export type CreateRawMaterialUnitOfMeasurementInput = {
  sub_units: Array<RawMaterialUnitOfMeasurementSubUnitInput>;
  title: Scalars['String']['input'];
};

export type CreateUserInput = {
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  type: ROLE_TYPE;
  username: Scalars['String']['input'];
  venue_issued_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVenueInput = {
  address: Scalars['String']['input'];
  /** Primary currency code, e.g. USD. */
  currency: Scalars['Currency']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** The Served super_admin's 4-digit PIN, as entered on the Staff app keypad. */
  super_admin_password: Scalars['String']['input'];
  /** Username of the Served super_admin role; unique within the venue. */
  super_admin_username: Scalars['String']['input'];
  timezone: Scalars['TimeZone']['input'];
  user_limit: Scalars['Int']['input'];
};

export type CreateVenueResult = {
  super_admin: AdminStaff;
  venue: AdminVenue;
};

export type CreateWalletInput = {
  is_sales_credit: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreditToWalletInput = {
  amount: Scalars['Float']['input'];
  payment_type?: InputMaybe<Scalars['String']['input']>;
};

export type CustomReport = {
  _id: Scalars['ObjectID']['output'];
  created_at: Scalars['DateTime']['output'];
  display_type: CUSTOM_REPORT_DISPLAY_TYPE;
  doughnut_configs?: Maybe<DoughnutConfigs>;
  is_deleted: Scalars['Boolean']['output'];
  table_configs?: Maybe<TableConfigs>;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type CustomReportDoughnutInput = {
  title: Scalars['String']['input'];
  values: Array<CustomReportDoughnutValuesInput>;
};

export type CustomReportDoughnutValuesInput = {
  field: CUSTOM_REPORT_VALUE_FIELD;
  item: Scalars['String']['input'];
  label: Scalars['String']['input'];
  type: CUSTOM_REPORT_VALUE_TYPE;
};

export type CustomReportTableConfigInput = {
  title: Scalars['String']['input'];
  values: Array<TableConfigValuesInput>;
};

export type Customer = {
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  address?: Maybe<CustomerAddress>;
  birthday?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['EmailAddress']['output']>;
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  linked_socials: CustomerLinkedSocials;
  /** Optional ISO 3166-1 alpha-2 country code. */
  nationality?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  /** Digital menu login name. */
  username?: Maybe<Scalars['String']['output']>;
  venue: Scalars['ObjectID']['output'];
};

export type CustomerAddress = {
  area?: Maybe<Scalars['String']['output']>;
  building?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type CustomerAddressInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  building?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerInput = {
  address?: InputMaybe<CustomerAddressInput>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  linked_socials: CustomerLinkedSocialsInput;
  /** Optional ISO 3166-1 alpha-2 country code. */
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  /** Digital menu login name. Empty defaults to the email, else the phone number. */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerLinkedSocials = {
  telegram: Scalars['Boolean']['output'];
  wechat: Scalars['Boolean']['output'];
  whatsapp: Scalars['Boolean']['output'];
};

export type CustomerLinkedSocialsInput = {
  telegram: Scalars['Boolean']['input'];
  wechat: Scalars['Boolean']['input'];
  whatsapp: Scalars['Boolean']['input'];
};

export type CustomerQrCode = {
  expires_at: Scalars['DateTime']['output'];
  image: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type CustomerReceiptsSummary = {
  averageSpendPerReceipt: Scalars['Float']['output'];
  receiptSales: Scalars['Float']['output'];
  receiptsCount: Scalars['Int']['output'];
};

export type CustomerSession = {
  customer: Customer;
  token: Scalars['String']['output'];
};

export type CustomerSignUpInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type DATA_EVENT_TYPE =
  | 'create'
  | 'delete'
  | 'update';

export type DEFAULT_SERVICE_CHARGE_TYPE =
  | 'ad'
  | 'bd';

export type DEVICE_ORDER_EVENT_TYPE =
  | 'CANCELLED'
  | 'MOVED_TO_PREPARING'
  | 'PAID'
  | 'PAYMENT_ACCEPTED'
  | 'PLACED'
  | 'PREP_TIME_CONFIRMATION_REQUIRED'
  | 'PREP_TIME_UPDATED'
  | 'PROCESSED';

export type DIGITAL_MENU_LANGUAGE =
  | 'cn'
  | 'kh';

export type DISCOUNT_TYPE =
  | 'amount'
  | 'percentage';

export type DateInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type DeleteRawMaterialReceivedInput = {
  _id: Scalars['ObjectID']['input'];
  adjustment_quantity: Scalars['Float']['input'];
  defect_quantity: Scalars['Float']['input'];
  expired_quantity: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  raw_material: Scalars['ObjectID']['input'];
  starting_quantity?: InputMaybe<Scalars['Float']['input']>;
  transfer_out_quantity?: InputMaybe<Scalars['Float']['input']>;
  wastage_quantity: Scalars['Float']['input'];
};

export type Device = {
  _active_orders: Array<Order>;
  _id: Scalars['ObjectID']['output'];
  created_at: Scalars['DateTime']['output'];
  fcm_tokens: Array<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type DeviceEvent = {
  id: Scalars['ObjectID']['output'];
  type: DATA_EVENT_TYPE;
};

export type DeviceOrderEvent = {
  id: Scalars['ObjectID']['output'];
  payload?: Maybe<Order>;
  type: DEVICE_ORDER_EVENT_TYPE;
};

export type DoughnutConfigValues = {
  field: CUSTOM_REPORT_VALUE_FIELD;
  item: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: CUSTOM_REPORT_VALUE_TYPE;
};

export type DoughnutConfigs = {
  title: Scalars['String']['output'];
  values: Array<DoughnutConfigValues>;
};

export type EditOrderCompositionContextInput = {
  browser_storage_quota_bytes?: InputMaybe<Scalars['Float']['input']>;
  browser_storage_usage_bytes?: InputMaybe<Scalars['Float']['input']>;
  order_snapshot_updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  till_location_id?: InputMaybe<Scalars['ObjectID']['input']>;
  till_order_id?: InputMaybe<Scalars['ObjectID']['input']>;
  time_since_last_refresh_ms?: InputMaybe<Scalars['Float']['input']>;
  url_location_id?: InputMaybe<Scalars['ObjectID']['input']>;
  url_order_id?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type EditOrderCompositionInput = {
  action_id?: InputMaybe<Scalars['String']['input']>;
  cancelled_items?: InputMaybe<Array<UpdateOrderItemInput>>;
  context?: InputMaybe<EditOrderCompositionContextInput>;
  customer?: InputMaybe<Scalars['ObjectID']['input']>;
  new_items?: InputMaybe<Array<CreateOrderItemInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  prev_items?: InputMaybe<Array<UpdateOrderItemInput>>;
  ticket_linebreaks?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FolioList = {
  Balance: Scalars['String']['output'];
  ChargeLimit: Scalars['String']['output'];
  CurrencyCode: Scalars['String']['output'];
  FolioId: Scalars['String']['output'];
  GuestName: Scalars['String']['output'];
};

export type GEOLOCATION_SHAPE_TYPE =
  | 'circle'
  | 'diamond'
  | 'ellipse'
  | 'octagon'
  | 'rectangle'
  | 'square';

export type GEOLOCATION_TYPE =
  | 'custom'
  | 'location';

export type Geolocation = {
  _id: Scalars['ObjectID']['output'];
  _location?: Maybe<Location>;
  _locations_groups_tag?: Maybe<Tag>;
  _venue: Venue;
  created_at: Scalars['DateTime']['output'];
  location?: Maybe<Scalars['ObjectID']['output']>;
  locations_groups_tag?: Maybe<Scalars['ObjectID']['output']>;
  shape: GeolocationShape;
  type: GEOLOCATION_TYPE;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type GeolocationInput = {
  location?: InputMaybe<Scalars['ObjectID']['input']>;
  locations_groups_tag?: InputMaybe<Scalars['ObjectID']['input']>;
  shape: GeolocationShapeInput;
  type: GEOLOCATION_TYPE;
};

export type GeolocationShape = {
  center: Array<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  type: GEOLOCATION_SHAPE_TYPE;
  width?: Maybe<Scalars['Float']['output']>;
};

export type GeolocationShapeInput = {
  center: Array<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type: GEOLOCATION_SHAPE_TYPE;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type GetCustomersResponse = {
  items: Array<Customer>;
  total: Scalars['Int']['output'];
};

export type GetItemsResults = {
  items: Array<Item>;
  total: Scalars['Int']['output'];
};

export type GetOptionsResults = {
  options: Array<Option>;
  total: Scalars['Int']['output'];
};

export type GetWalletStatsResponse = {
  total_credited_amount: Scalars['Float']['output'];
  total_debited_amount: Scalars['Float']['output'];
};

export type GetWalletTransactionsResponse = {
  items: Array<WalletTransaction>;
  total: Scalars['Int']['output'];
};

export type GetWalletsResponse = {
  items: Array<Wallet>;
  total: Scalars['Int']['output'];
};

export type GraphQLOperationsHealthChecks = {
  mongo: ServiceStatus;
  redis_rate_limit: ServiceStatus;
};

export type GraphQLOperationsHealthStatus = {
  checks: GraphQLOperationsHealthChecks;
  ok: Scalars['Boolean']['output'];
};

export type GraphQLSubscriptionsHealthChecks = {
  redis_pubsub_publish: ServiceStatus;
  redis_pubsub_subscribe: ServiceStatus;
};

export type GraphQLSubscriptionsHealthStatus = {
  checks: GraphQLSubscriptionsHealthChecks;
  ok: Scalars['Boolean']['output'];
};

export type INVENTORY_DEDUCTION_CATEGORY =
  | 'DEFECT'
  | 'EXPIRED'
  | 'NO_DEDUCTION'
  | 'WASTAGE';

export type InventoryTransactionsSummary = {
  byRawMaterials: Array<InventoryTransactionsSummaryByRawMaterial>;
};

export type InventoryTransactionsSummaryByRawMaterial = {
  _raw_material: RawMaterial;
  avg_cost_per_uom: Scalars['Float']['output'];
  raw_material: Scalars['ObjectID']['output'];
  total_adjustment_quantity: Scalars['Float']['output'];
  total_balance_quantity: Scalars['Float']['output'];
  total_consumed_quantity: Scalars['Float']['output'];
  total_cost: Scalars['Float']['output'];
  total_defect_quantity: Scalars['Float']['output'];
  total_expired_quantity: Scalars['Float']['output'];
  total_received_quantity: Scalars['Float']['output'];
  total_starting_quantity?: Maybe<Scalars['Float']['output']>;
  total_transfer_out_quantity?: Maybe<Scalars['Float']['output']>;
  total_wastage_quantity: Scalars['Float']['output'];
  transfer_out_receivers?: Maybe<Array<Scalars['String']['output']>>;
};

export type Item = {
  _category: Category;
  _clone_from?: Maybe<Item>;
  _id: Scalars['ObjectID']['output'];
  _item_tags?: Maybe<Array<Tag>>;
  _master_items?: Maybe<Array<Item>>;
  _menu: Menu;
  _printer_tag?: Maybe<Tag>;
  _report_tags?: Maybe<Array<Tag>>;
  _venue: Venue;
  availability?: Maybe<Availability>;
  banner_img?: Maybe<Scalars['URL']['output']>;
  category: Scalars['ObjectID']['output'];
  clone_from?: Maybe<Scalars['ObjectID']['output']>;
  controlled_quantity?: Maybe<Scalars['Int']['output']>;
  cost: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  description_localized?: Maybe<ItemLocalizedText>;
  extra_quantity: Scalars['Int']['output'];
  /** Whether cost is maintained from the item's recipe. Missing values are manual. */
  is_cost_automatically_calculated?: Maybe<Scalars['Boolean']['output']>;
  is_hide_from_receipt: Scalars['Boolean']['output'];
  is_master?: Maybe<Scalars['Boolean']['output']>;
  is_open_item: Scalars['Boolean']['output'];
  is_pos_enabled: Scalars['Boolean']['output'];
  is_qr_enabled: Scalars['Boolean']['output'];
  is_quantity_controlled?: Maybe<Scalars['Boolean']['output']>;
  is_template: Scalars['Boolean']['output'];
  item_id: Scalars['String']['output'];
  item_tags?: Maybe<Array<Scalars['ObjectID']['output']>>;
  listed_price: Scalars['Float']['output'];
  master_items?: Maybe<Array<Scalars['ObjectID']['output']>>;
  menu: Scalars['ObjectID']['output'];
  minimum_required_price: Scalars['Float']['output'];
  no_service_charge: Scalars['Boolean']['output'];
  no_vat: Scalars['Boolean']['output'];
  option_groups: Array<ItemOptionGroup>;
  options: Array<ItemOption>;
  ordering_index: Scalars['Int']['output'];
  original_price: Scalars['Float']['output'];
  original_price_addons: OriginalPriceAddons;
  prep_time: Scalars['Float']['output'];
  printer_tag?: Maybe<Scalars['ObjectID']['output']>;
  recipe: Array<RecipeRawMaterialUsed>;
  report_tags?: Maybe<Array<Scalars['ObjectID']['output']>>;
  till_card_color?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  title_localized?: Maybe<ItemLocalizedText>;
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type ItemLocalizedText = {
  cn?: Maybe<Scalars['String']['output']>;
  kh?: Maybe<Scalars['String']['output']>;
};

export type ItemLocalizedTextInput = {
  cn?: InputMaybe<Scalars['String']['input']>;
  kh?: InputMaybe<Scalars['String']['input']>;
};

export type ItemOption = {
  _option: Option;
  is_hide_from_receipt: Scalars['Boolean']['output'];
  option: Scalars['ObjectID']['output'];
  ordering_index: Scalars['Float']['output'];
};

export type ItemOptionGroup = {
  _option_group: OptionGroup;
  is_required: Scalars['Boolean']['output'];
  maximum_select: Scalars['Float']['output'];
  minimum_select: Scalars['Float']['output'];
  option_group: Scalars['ObjectID']['output'];
  options: Array<ItemOptionGroupOption>;
  ordering_index: Scalars['Float']['output'];
};

export type ItemOptionGroupInput = {
  is_required: Scalars['Boolean']['input'];
  maximum_select: Scalars['Float']['input'];
  minimum_select: Scalars['Float']['input'];
  option_group: Scalars['ObjectID']['input'];
  options: Array<ItemOptionGroupOptionInput>;
  ordering_index: Scalars['Float']['input'];
};

export type ItemOptionGroupOption = {
  _option: Option;
  is_auto_select: Scalars['Boolean']['output'];
  is_hide_from_receipt: Scalars['Boolean']['output'];
  option: Scalars['ObjectID']['output'];
  ordering_index: Scalars['Float']['output'];
};

export type ItemOptionGroupOptionInput = {
  is_auto_select: Scalars['Boolean']['input'];
  is_hide_from_receipt: Scalars['Boolean']['input'];
  option: Scalars['ObjectID']['input'];
  ordering_index: Scalars['Float']['input'];
};

export type ItemOptionInput = {
  is_hide_from_receipt: Scalars['Boolean']['input'];
  option: Scalars['ObjectID']['input'];
  ordering_index: Scalars['Float']['input'];
};

/** Kitchen item actions. Sending does not change the overall order status. */
export type KdsItemAction =
  | 'accept'
  | 'hold'
  | 'resume'
  | 'send';

export type LOCATION_LOCK_ACTION_REASON =
  | 'acquired'
  | 'already_owned'
  | 'disabled'
  | 'locked_by_other_user'
  | 'not_locked'
  | 'not_owned'
  | 'refreshed'
  | 'released';

export type LOCATION_LOCK_EVENT_TYPE =
  | 'acquired'
  | 'expired'
  | 'refreshed'
  | 'released';

export type LOCATION_STATUS =
  | 'occupied'
  | 'open';

export type LOCATION_TYPE =
  | 'pick_up_point'
  | 'table';

export type Location = {
  _current_orders: Array<Order>;
  _id: Scalars['ObjectID']['output'];
  _locations_groups_tags: Array<Tag>;
  _venue: Venue;
  created_at: Scalars['DateTime']['output'];
  current_headcount: Scalars['Float']['output'];
  default_order_note?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  hash: Scalars['String']['output'];
  hidden_items_configs: LocationHiddenItemsConfigs;
  is_pay_later_allowed: Scalars['Boolean']['output'];
  is_pay_now_allowed: Scalars['Boolean']['output'];
  locations_groups_tags: Array<Scalars['ObjectID']['output']>;
  name: Scalars['String']['output'];
  no_service_charge: Scalars['Boolean']['output'];
  no_vat: Scalars['Boolean']['output'];
  payment_types: Array<Scalars['String']['output']>;
  room_number?: Maybe<Scalars['String']['output']>;
  status: LOCATION_STATUS;
  type: LOCATION_TYPE;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type LocationEvent = {
  id: Scalars['ObjectID']['output'];
  payload?: Maybe<Location>;
  type: DATA_EVENT_TYPE;
};

export type LocationHiddenItemsConfigs = {
  _categories: Array<Category>;
  _items: Array<Item>;
  categories: Array<Scalars['ObjectID']['output']>;
  is_categories_hide_on_pos: Scalars['Boolean']['output'];
  is_categories_hide_on_qr: Scalars['Boolean']['output'];
  is_item_types_hide_on_pos: Scalars['Boolean']['output'];
  is_item_types_hide_on_qr: Scalars['Boolean']['output'];
  is_items_hide_on_pos: Scalars['Boolean']['output'];
  is_items_hide_on_qr: Scalars['Boolean']['output'];
  item_types: Array<Scalars['String']['output']>;
  items: Array<Scalars['ObjectID']['output']>;
};

export type LocationInput = {
  default_order_note?: InputMaybe<Scalars['String']['input']>;
  is_pay_later_allowed: Scalars['Boolean']['input'];
  is_pay_now_allowed: Scalars['Boolean']['input'];
  locations_groups_tags: Array<Scalars['ObjectID']['input']>;
  name: Scalars['String']['input'];
  no_service_charge: Scalars['Boolean']['input'];
  no_vat: Scalars['Boolean']['input'];
  payment_types: Array<Scalars['String']['input']>;
  room_number?: InputMaybe<Scalars['String']['input']>;
  type: LOCATION_TYPE;
};

export type LocationLockActionResult = {
  lock: LocationLockState;
  ok: Scalars['Boolean']['output'];
  reason: LOCATION_LOCK_ACTION_REASON;
};

export type LocationLockEvent = {
  lock: LocationLockState;
  type: LOCATION_LOCK_EVENT_TYPE;
};

export type LocationLockState = {
  expiresAt?: Maybe<Scalars['Float']['output']>;
  isLocked: Scalars['Boolean']['output'];
  locationId: Scalars['ObjectID']['output'];
  ownerRoleId?: Maybe<Scalars['ObjectID']['output']>;
};

export type LoginInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  venue_issued_id?: InputMaybe<Scalars['String']['input']>;
};

export type LoginPayload = {
  refreshToken: Scalars['String']['output'];
  role: Role;
  token: Scalars['String']['output'];
};

export type LoginSilentPayload = {
  role: Role;
  token: Scalars['String']['output'];
};

export type MaintenanceMode = {
  enabled: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Menu = {
  _categories: Array<Category>;
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  banner_img?: Maybe<Scalars['URL']['output']>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type MenuEvent = {
  id: Scalars['ObjectID']['output'];
  payload: MenuEventPayload;
  type: DATA_EVENT_TYPE;
};

export type MenuEventPayload = {
  category?: Maybe<Category>;
  item?: Maybe<Item>;
  menu?: Maybe<Menu>;
};

export type MovedOrderIdInput = {
  _id: Scalars['ObjectID']['input'];
  itemIds?: InputMaybe<Array<MovedOrderItemIdInput>>;
  status: ORDER_STATUS;
};

export type MovedOrderItemIdInput = {
  _id: Scalars['ObjectID']['input'];
  sourceId: Scalars['ObjectID']['input'];
};

export type Mutation = {
  acquireLocationLock: LocationLockActionResult;
  adminLogin: AdminLoginPayload;
  bulkUpdateCategories: Array<Category>;
  bulkUpdateItems: Array<Item>;
  cancelOrder: Order;
  checkLocationLock: LocationLockState;
  checkoutWithPayWay: CheckoutWithPayWayResult;
  clearLocation: Location;
  confirmPaymentTypeForOrder: Order;
  confirmPrepTimeForOrder: Order;
  connectCloudbedsIntegration?: Maybe<Scalars['Void']['output']>;
  createAccountingJournal: AccountingJournal;
  createApiKey: CreateApiKeyPayload;
  createCategory: Category;
  createCustomReport: CustomReport;
  /**
   * `password` sets the customer's digital menu login password; it can only be
   * changed afterwards through `resetCustomerPassword`.
   */
  createCustomer: Customer;
  createGeolocation: Geolocation;
  createItem: Item;
  createLocation: Location;
  createMenu: Menu;
  createNewDevice: Device;
  createOffer: Offer;
  createOption: Option;
  createOptionGroup: OptionGroup;
  createPosOrder: Order;
  createPreSignedUrl: PreSignedUrlResponse;
  createQrNotification: Notification;
  createQrOrder: Order;
  createRawMaterial: RawMaterial;
  createRawMaterialCategory: RawMaterialCategory;
  createRawMaterialReceived: RawMaterialReceived;
  createRawMaterialReceiver: RawMaterialReceiver;
  createRawMaterialSupplier: RawMaterialSupplier;
  createRawMaterialUnitOfMeasurement: RawMaterialUnitOfMeasurement;
  createReservation: Reservation;
  createTag: Tag;
  createUser: Role;
  /** Creates a venue and its Served super_admin role together. */
  createVenue: CreateVenueResult;
  createWallet: Wallet;
  creditToWallet: WalletTransaction;
  customerLogin: CustomerSession;
  customerSignUp: CustomerSession;
  deleteApiKey: Scalars['Boolean']['output'];
  deleteCategory: Category;
  deleteCustomReport: CustomReport;
  deleteGeolocation: Geolocation;
  deleteItem: Item;
  deleteLocation: Location;
  deleteOption: Option;
  deleteOptionGroup: OptionGroup;
  deleteRawMaterialReceived: RawMaterialReceived;
  deleteReservation: Reservation;
  deleteUser: Role;
  disconnectCloudbedsIntegration?: Maybe<Scalars['Void']['output']>;
  dismissPrepTimeUpdateForOrder: Order;
  editOrdersComposition: Array<Order>;
  folioInquiry: RoomMasterResponse;
  login: LoginPayload;
  loginSilent: LoginSilentPayload;
  moveItemsFromOldLocationToNewLocation?: Maybe<Scalars['Void']['output']>;
  payForLocation: PayForLocationResult;
  payForOrder: PayForOrderResult;
  printBillByLocation?: Maybe<Scalars['Void']['output']>;
  printBillByOrder?: Maybe<Scalars['Void']['output']>;
  printCancelledTicketsByOrder?: Maybe<Scalars['Void']['output']>;
  printChecklistByAllOrders?: Maybe<Scalars['Void']['output']>;
  printChecklistByOrder?: Maybe<Scalars['Void']['output']>;
  printKitchenMessageByLocation?: Maybe<Scalars['Void']['output']>;
  printKitchenMessageByOrder?: Maybe<Scalars['Void']['output']>;
  printPrintLog?: Maybe<Scalars['Void']['output']>;
  printTicketsByOrder?: Maybe<Scalars['Void']['output']>;
  publishPaymentTypeAcceptedForOrder?: Maybe<Scalars['Void']['output']>;
  publishPrepTimeUpdatedForOrder?: Maybe<Scalars['Void']['output']>;
  publishPrintEvent?: Maybe<Scalars['Void']['output']>;
  publishSystemHealthEvent?: Maybe<Scalars['Void']['output']>;
  refreshLocationLock: LocationLockActionResult;
  refreshToken: RefreshTokenPayload;
  releaseLocationLock: LocationLockActionResult;
  repostReceiptToCloudbeds: RepostReceiptToCloudbedsResult;
  repostReceiptToRoomMaster: RepostReceiptToRoomMasterResult;
  resetCustomerPassword?: Maybe<Scalars['Void']['output']>;
  resetUserPassword?: Maybe<Scalars['Void']['output']>;
  /** Sets an active venue super_admin's password to a new 4-digit PIN. */
  resetVenueSuperAdminPassword?: Maybe<Scalars['Void']['output']>;
  resolveAssistance: Notification;
  /**
   * Deactivates (like the Staff app's delete: sets `deleted_at`) or reactivates
   * a venue's staff member; not a super_admin. Reactivating fails when another
   * active staff member of the venue now has the same username or staff ID.
   */
  setAdminStaffActive: AdminStaff;
  setMaintenanceMode: MaintenanceMode;
  splitItemsIntoNewOrder: Order;
  /**
   * Replays queued offline actions in order and stops at the first failure.
   * Actions already applied by an earlier sync are skipped.
   */
  syncOfflineMutations: Array<OfflineMutationResult>;
  updateAccountingJournal: AccountingJournal;
  updateAiConfig: AiConfig;
  updateApiKey: ApiKey;
  updateCategory: Category;
  updateCurrentDevice: Device;
  updateCurrentVenue: Venue;
  updateCurrentVenueAddOns: Venue;
  updateCustomReport: CustomReport;
  updateCustomer: Customer;
  updateGeolocation: Geolocation;
  updateItem: Item;
  /** Accept, hold, resume or send the explicitly selected kitchen items. */
  updateKdsItems: Order;
  updateLocation: Location;
  updateMenu: Menu;
  updateOffer: Offer;
  updateOption: Option;
  updateOptionGroup: OptionGroup;
  updateOrderItemFields: Order;
  updateOrderMetadata: Order;
  updateOrderStatus: Order;
  updatePrintLog: PrintLog;
  updateRawMaterial: RawMaterial;
  updateRawMaterialCategory: RawMaterialCategory;
  updateRawMaterialReceived: RawMaterialReceived;
  updateRawMaterialReceiver: RawMaterialReceiver;
  updateRawMaterialStatus: RawMaterial;
  updateRawMaterialSupplier: RawMaterialSupplier;
  updateRawMaterialUnitOfMeasurement: RawMaterialUnitOfMeasurement;
  updateReservation: Reservation;
  updateRole: Role;
  updateTag: Tag;
  updateUser: Role;
  updateWallet: Wallet;
  uploadRawMaterialReceived: Array<RawMaterialReceived>;
  voidReceipt: VoidReceiptResult;
};


export type MutationacquireLocationLockArgs = {
  locationId: Scalars['ObjectID']['input'];
};


export type MutationadminLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationbulkUpdateCategoriesArgs = {
  inputs: Array<BulkUpdateCategoriesInput>;
};


export type MutationbulkUpdateItemsArgs = {
  inputs: Array<BulkUpdateItemsInput>;
};


export type MutationcancelOrderArgs = {
  id: Scalars['ObjectID']['input'];
  inventory_deduction_category?: InputMaybe<INVENTORY_DEDUCTION_CATEGORY>;
  message: Scalars['String']['input'];
};


export type MutationcheckLocationLockArgs = {
  locationId: Scalars['ObjectID']['input'];
};


export type MutationcheckoutWithPayWayArgs = {
  input: CheckoutWithPayWayInput;
};


export type MutationclearLocationArgs = {
  id: Scalars['ObjectID']['input'];
  isOffline?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationconfirmPaymentTypeForOrderArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationconfirmPrepTimeForOrderArgs = {
  id: Scalars['ObjectID']['input'];
  isAccepted: Scalars['Boolean']['input'];
};


export type MutationconnectCloudbedsIntegrationArgs = {
  code: Scalars['String']['input'];
};


export type MutationcreateAccountingJournalArgs = {
  input: AccountingJournalInput;
};


export type MutationcreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationcreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationcreateCustomReportArgs = {
  input: CreateCustomReportInput;
};


export type MutationcreateCustomerArgs = {
  input: CustomerInput;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateGeolocationArgs = {
  input: GeolocationInput;
};


export type MutationcreateItemArgs = {
  input: CreateItemInput;
};


export type MutationcreateLocationArgs = {
  input: LocationInput;
};


export type MutationcreateMenuArgs = {
  input: CreateMenuInput;
};


export type MutationcreateOfferArgs = {
  input: OfferInput;
};


export type MutationcreateOptionArgs = {
  input: CreateOptionInput;
};


export type MutationcreateOptionGroupArgs = {
  input: CreateOptionGroupInput;
};


export type MutationcreatePosOrderArgs = {
  input?: InputMaybe<CreatePosOrderInput>;
  offlineInput?: InputMaybe<CreatePosOrderOfflineInput>;
};


export type MutationcreatePreSignedUrlArgs = {
  input: CreatePreSignedUrlInput;
};


export type MutationcreateQrNotificationArgs = {
  input: CreateQrNotificationInput;
};


export type MutationcreateQrOrderArgs = {
  input: CreateQrOrderInput;
};


export type MutationcreateRawMaterialArgs = {
  input: CreateRawMaterialInput;
};


export type MutationcreateRawMaterialCategoryArgs = {
  input: CreateRawMaterialCategoryInput;
};


export type MutationcreateRawMaterialReceivedArgs = {
  input: CreateRawMaterialReceivedInput;
};


export type MutationcreateRawMaterialReceiverArgs = {
  input: CreateRawMaterialReceiverInput;
};


export type MutationcreateRawMaterialSupplierArgs = {
  input: CreateRawMaterialSupplierInput;
};


export type MutationcreateRawMaterialUnitOfMeasurementArgs = {
  input: CreateRawMaterialUnitOfMeasurementInput;
};


export type MutationcreateReservationArgs = {
  input: ReservationInput;
};


export type MutationcreateTagArgs = {
  input: TagInput;
};


export type MutationcreateUserArgs = {
  input: CreateUserInput;
};


export type MutationcreateVenueArgs = {
  input: CreateVenueInput;
};


export type MutationcreateWalletArgs = {
  input: CreateWalletInput;
};


export type MutationcreditToWalletArgs = {
  id: Scalars['ObjectID']['input'];
  input: CreditToWalletInput;
};


export type MutationcustomerLoginArgs = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationcustomerSignUpArgs = {
  input: CustomerSignUpInput;
};


export type MutationdeleteApiKeyArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationdeleteCategoryArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationdeleteCustomReportArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationdeleteGeolocationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationdeleteItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationdeleteLocationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationdeleteOptionArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationdeleteOptionGroupArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationdeleteRawMaterialReceivedArgs = {
  input: DeleteRawMaterialReceivedInput;
};


export type MutationdeleteReservationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationdeleteUserArgs = {
  role_id: Scalars['ObjectID']['input'];
};


export type MutationdismissPrepTimeUpdateForOrderArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationeditOrdersCompositionArgs = {
  orders: Array<OrderCompositionInput>;
};


export type MutationfolioInquiryArgs = {
  roomNumber: Scalars['String']['input'];
};


export type MutationloginArgs = {
  input: LoginInput;
};


export type MutationloginSilentArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationmoveItemsFromOldLocationToNewLocationArgs = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  newLocationId: Scalars['ObjectID']['input'];
  oldLocationId: Scalars['ObjectID']['input'];
  partialOrders: Array<OrderWithSplittedItemsInput>;
  wholeOrders: Array<Scalars['ObjectID']['input']>;
};


export type MutationpayForLocationArgs = {
  id: Scalars['ObjectID']['input'];
  input?: InputMaybe<PaymentInput>;
  offlineInput?: InputMaybe<PaymentInput>;
  orderSnapshots?: InputMaybe<Array<OrderSnapshotInput>>;
  printerName?: InputMaybe<Scalars['String']['input']>;
  walletTransactionInput?: InputMaybe<WalletTransactionInput>;
};


export type MutationpayForOrderArgs = {
  id: Scalars['ObjectID']['input'];
  input: PaymentInput;
  orderSnapshot?: InputMaybe<OrderSnapshotInput>;
  printerName?: InputMaybe<Scalars['String']['input']>;
  walletTransactionInput?: InputMaybe<WalletTransactionInput>;
};


export type MutationprintBillByLocationArgs = {
  id: Scalars['ObjectID']['input'];
  printerName?: InputMaybe<Scalars['String']['input']>;
  splitCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationprintBillByOrderArgs = {
  id: Scalars['ObjectID']['input'];
  printerName?: InputMaybe<Scalars['String']['input']>;
  splitCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationprintCancelledTicketsByOrderArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationprintChecklistByAllOrdersArgs = {
  ids: Array<Scalars['ObjectID']['input']>;
};


export type MutationprintChecklistByOrderArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationprintKitchenMessageByLocationArgs = {
  id: Scalars['ObjectID']['input'];
  message: Scalars['String']['input'];
};


export type MutationprintKitchenMessageByOrderArgs = {
  id: Scalars['ObjectID']['input'];
  item_id?: InputMaybe<Scalars['ObjectID']['input']>;
  message: Scalars['String']['input'];
  option_id?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type MutationprintPrintLogArgs = {
  id: Scalars['ObjectID']['input'];
  printerName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationprintTicketsByOrderArgs = {
  id: Scalars['ObjectID']['input'];
  item_id?: InputMaybe<Scalars['ObjectID']['input']>;
  option_id?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type MutationpublishPaymentTypeAcceptedForOrderArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationpublishPrepTimeUpdatedForOrderArgs = {
  id: Scalars['ObjectID']['input'];
  prepTime: Scalars['Float']['input'];
};


export type MutationpublishPrintEventArgs = {
  input: PublishPrintEventInput;
};


export type MutationpublishSystemHealthEventArgs = {
  type: SYSTEM_HEALTH_SUBSCRIPTION_EVENT_TYPE;
};


export type MutationrefreshLocationLockArgs = {
  locationId: Scalars['ObjectID']['input'];
};


export type MutationrefreshTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationreleaseLocationLockArgs = {
  locationId: Scalars['ObjectID']['input'];
};


export type MutationrepostReceiptToCloudbedsArgs = {
  id: Scalars['ObjectID']['input'];
  input: CloudbedsPaymentInput;
};


export type MutationrepostReceiptToRoomMasterArgs = {
  id: Scalars['ObjectID']['input'];
  input: CreateOrderPaymentRoomMasterInput;
};


export type MutationresetCustomerPasswordArgs = {
  id: Scalars['ObjectID']['input'];
  password: Scalars['String']['input'];
};


export type MutationresetUserPasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  role_id: Scalars['ObjectID']['input'];
};


export type MutationresetVenueSuperAdminPasswordArgs = {
  password: Scalars['String']['input'];
  role_id: Scalars['ObjectID']['input'];
};


export type MutationresolveAssistanceArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationsetAdminStaffActiveArgs = {
  active: Scalars['Boolean']['input'];
  role_id: Scalars['ObjectID']['input'];
};


export type MutationsetMaintenanceModeArgs = {
  enabled: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsplitItemsIntoNewOrderArgs = {
  location: Scalars['ObjectID']['input'];
  partialOrders: Array<OrderWithSplittedItemsInput>;
  wholeOrders: Array<Scalars['ObjectID']['input']>;
};


export type MutationsyncOfflineMutationsArgs = {
  mutations: Array<OfflineMutationInput>;
};


export type MutationupdateAccountingJournalArgs = {
  id: Scalars['ObjectID']['input'];
  input: AccountingJournalInput;
};


export type MutationupdateAiConfigArgs = {
  input: UpdateAiConfigInput;
};


export type MutationupdateApiKeyArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateApiKeyInput;
};


export type MutationupdateCategoryArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateCategoryInput;
};


export type MutationupdateCurrentDeviceArgs = {
  input: UpdateCurrentDeviceInput;
};


export type MutationupdateCurrentVenueArgs = {
  input: UpdateCurrentVenueInput;
};


export type MutationupdateCurrentVenueAddOnsArgs = {
  input: UpdateCurrentVenueAddOnsInput;
};


export type MutationupdateCustomReportArgs = {
  input: UpdateCustomReportInput;
};


export type MutationupdateCustomerArgs = {
  id: Scalars['ObjectID']['input'];
  input: CustomerInput;
};


export type MutationupdateGeolocationArgs = {
  id: Scalars['ObjectID']['input'];
  input: GeolocationInput;
};


export type MutationupdateItemArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateItemInput;
};


export type MutationupdateKdsItemsArgs = {
  action: KdsItemAction;
  expected_updated_at: Scalars['DateTime']['input'];
  id: Scalars['ObjectID']['input'];
  itemIds: Array<Scalars['ObjectID']['input']>;
};


export type MutationupdateLocationArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateLocationInput;
};


export type MutationupdateMenuArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateMenuInput;
};


export type MutationupdateOfferArgs = {
  id: Scalars['ObjectID']['input'];
  input: OfferInput;
};


export type MutationupdateOptionArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateOptionInput;
};


export type MutationupdateOptionGroupArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateOptionGroupInput;
};


export type MutationupdateOrderItemFieldsArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateOrderItemFieldsInput;
};


export type MutationupdateOrderMetadataArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateOrderMetadataInput;
};


export type MutationupdateOrderStatusArgs = {
  id: Scalars['ObjectID']['input'];
  status: ORDER_STATUS;
};


export type MutationupdatePrintLogArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdatePrintLogInput;
};


export type MutationupdateRawMaterialArgs = {
  input: UpdateRawMaterialInput;
};


export type MutationupdateRawMaterialCategoryArgs = {
  input: UpdateRawMaterialCategoryInput;
};


export type MutationupdateRawMaterialReceivedArgs = {
  input: UpdateRawMaterialReceivedInput;
};


export type MutationupdateRawMaterialReceiverArgs = {
  input: UpdateRawMaterialReceiverInput;
};


export type MutationupdateRawMaterialStatusArgs = {
  input: UpdateRawMaterialStatusInput;
};


export type MutationupdateRawMaterialSupplierArgs = {
  input: UpdateRawMaterialSupplierInput;
};


export type MutationupdateRawMaterialUnitOfMeasurementArgs = {
  input: UpdateRawMaterialUnitOfMeasurementInput;
};


export type MutationupdateReservationArgs = {
  id: Scalars['ObjectID']['input'];
  input: ReservationInput;
};


export type MutationupdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationupdateTagArgs = {
  id: Scalars['ObjectID']['input'];
  input: TagInput;
};


export type MutationupdateUserArgs = {
  input: UpdateUserInput;
  role_id: Scalars['ObjectID']['input'];
};


export type MutationupdateWalletArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateWalletInput;
};


export type MutationuploadRawMaterialReceivedArgs = {
  input: UploadRawMaterialReceivedInput;
};


export type MutationvoidReceiptArgs = {
  id: Scalars['ObjectID']['input'];
  message: Scalars['String']['input'];
};

export type NOTIFICATION_KIND =
  | 'assistance'
  | 'payway_order_failure';

export type Notification = {
  _device?: Maybe<Device>;
  _id: Scalars['ObjectID']['output'];
  _location: Location;
  _staff?: Maybe<Role>;
  _temp_order?: Maybe<TempOrder>;
  _venue: Venue;
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  device?: Maybe<Scalars['ObjectID']['output']>;
  /** Absent on notifications created before kinds were introduced (assistance) */
  kind?: Maybe<NOTIFICATION_KIND>;
  location: Scalars['ObjectID']['output'];
  staff?: Maybe<Scalars['ObjectID']['output']>;
  temp_order?: Maybe<Scalars['ObjectID']['output']>;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type NotificationEvent = {
  id: Scalars['ObjectID']['output'];
  payload?: Maybe<Notification>;
  type: DATA_EVENT_TYPE;
};

export type OFFER_CONFIGS_TYPE =
  | 'categories'
  | 'item_types'
  | 'items'
  | 'receipts';

export type OPS_PAGE =
  | 'kds'
  | 'locations'
  | 'orders'
  | 'reservation'
  | 'till';

export type ORDER_CHANGELOG_SCOPE =
  | 'items'
  | 'order';

export type ORDER_CHANGELOG_TYPE =
  | 'added_item'
  | 'auto_accepted_order'
  | 'cancelled_item'
  | 'cancelled_order_moved'
  | 'cancelled_order_no_items'
  | 'cancelled_order_split'
  | 'card_surcharge_applied'
  | 'card_surcharge_removed'
  | 'card_surcharge_updated'
  | 'change_discount'
  | 'change_item_quantity'
  | 'customer_accepted_prep_time_updates'
  | 'customer_added'
  | 'customer_rejected_prep_time_updates'
  | 'customer_removed'
  | 'discount_applied'
  | 'discount_removed'
  | 'discount_updated'
  | 'move_item_some'
  | 'move_item_whole'
  | 'offer_applied'
  | 'offer_removed'
  | 'offer_updated'
  | 'order_moved'
  | 'service_charge_applied'
  | 'service_charge_bd_applied'
  | 'service_charge_bd_removed'
  | 'service_charge_bd_updated'
  | 'service_charge_removed'
  | 'service_charge_updated'
  | 'split_item_some'
  | 'split_item_whole'
  | 'tax_applied'
  | 'tax_removed'
  | 'tax_updated'
  | 'update_order_prep_time'
  | 'vat_applied'
  | 'vat_removed'
  | 'vat_updated'
  | 'wallet_payment_added'
  | 'wallet_payment_removed'
  | 'wallet_payment_updated';

export type ORDER_CHANGELOG_VALUE_TYPE =
  | 'amount'
  | 'percentage'
  | 'rate';

export type ORDER_ITEM_STATUS =
  | 'delivered'
  | 'preparing';

export type ORDER_SOURCE =
  | 'qr'
  | 'till';

export type ORDER_STATUS =
  | 'placed'
  | 'preparing'
  | 'processed';

export type Offer = {
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  configs: Array<OfferConfig>;
  created_at: Scalars['DateTime']['output'];
  is_deactivated: Scalars['Boolean']['output'];
  is_offering_higher_value: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type OfferConfig = {
  _categories: Array<Category>;
  _items: Array<Item>;
  categories: Array<Scalars['ObjectID']['output']>;
  discount_type: DISCOUNT_TYPE;
  discount_value: Scalars['Float']['output'];
  item_types: Array<Scalars['String']['output']>;
  items: Array<Scalars['ObjectID']['output']>;
  type: OFFER_CONFIGS_TYPE;
};

export type OfferConfigInput = {
  categories?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  discount_type: DISCOUNT_TYPE;
  discount_value: Scalars['Float']['input'];
  item_types?: InputMaybe<Array<Scalars['String']['input']>>;
  items?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  type: OFFER_CONFIGS_TYPE;
};

export type OfferInput = {
  configs: Array<OfferConfigInput>;
  is_deactivated: Scalars['Boolean']['input'];
  is_offering_higher_value: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type OfflineClearLocationArgs = {
  id: Scalars['ObjectID']['input'];
};

export type OfflineCreatePosOrderArgs = {
  offlineInput: CreatePosOrderOfflineInput;
};

export type OfflineEditOrdersCompositionArgs = {
  orders: Array<OrderCompositionInput>;
};

export type OfflineMoveItemsFromOldLocationToNewLocationArgs = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  newLocationId: Scalars['ObjectID']['input'];
  /** Ids for the orders and their items created per status by a partial move. */
  newOrderIds?: InputMaybe<Array<MovedOrderIdInput>>;
  oldLocationId: Scalars['ObjectID']['input'];
  partialOrders: Array<OrderWithSplittedItemsInput>;
  wholeOrders: Array<Scalars['ObjectID']['input']>;
};

export type OfflineMutationInput = {
  clearLocation?: InputMaybe<OfflineClearLocationArgs>;
  client_mutation_id: Scalars['String']['input'];
  createPosOrder?: InputMaybe<OfflineCreatePosOrderArgs>;
  editOrdersComposition?: InputMaybe<OfflineEditOrdersCompositionArgs>;
  kind: OfflineMutationKind;
  moveItemsFromOldLocationToNewLocation?: InputMaybe<OfflineMoveItemsFromOldLocationToNewLocationArgs>;
  payForLocation?: InputMaybe<OfflinePayForLocationArgs>;
  payForOrder?: InputMaybe<OfflinePayForOrderArgs>;
  updateLocation?: InputMaybe<OfflineUpdateLocationArgs>;
  updateOrderMetadata?: InputMaybe<OfflineUpdateOrderMetadataArgs>;
};

export type OfflineMutationKind =
  | 'clearLocation'
  | 'createPosOrder'
  | 'editOrdersComposition'
  | 'moveItemsFromOldLocationToNewLocation'
  | 'payForLocation'
  | 'payForOrder'
  | 'updateLocation'
  | 'updateOrderMetadata';

export type OfflineMutationResult = {
  client_mutation_id: Scalars['String']['output'];
  error_code?: Maybe<Scalars['String']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  status: OfflineMutationStatus;
};

export type OfflineMutationStatus =
  | 'ALREADY_APPLIED'
  | 'APPLIED'
  | 'FAILED';

export type OfflinePayForLocationArgs = {
  id: Scalars['ObjectID']['input'];
  offlineInput: PaymentInput;
  printerName?: InputMaybe<Scalars['String']['input']>;
};

export type OfflinePayForOrderArgs = {
  id: Scalars['ObjectID']['input'];
  input: PaymentInput;
  orderSnapshot?: InputMaybe<OrderSnapshotInput>;
  printerName?: InputMaybe<Scalars['String']['input']>;
  walletTransactionInput?: InputMaybe<WalletTransactionInput>;
};

export type OfflineUpdateLocationArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateLocationInput;
};

export type OfflineUpdateOrderMetadataArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateOrderMetadataInput;
};

export type Option = {
  _clone_from?: Maybe<Option>;
  _id: Scalars['ObjectID']['output'];
  _menu: Menu;
  _venue: Venue;
  clone_from?: Maybe<Scalars['ObjectID']['output']>;
  cost: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  is_template: Scalars['Boolean']['output'];
  listed_price: Scalars['Float']['output'];
  menu: Scalars['ObjectID']['output'];
  option_id: Scalars['String']['output'];
  original_price: Scalars['Float']['output'];
  original_price_addons: OriginalPriceAddons;
  recipe: Array<RecipeRawMaterialUsed>;
  title: Scalars['String']['output'];
  title_localized?: Maybe<ItemLocalizedText>;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type OptionGroup = {
  _clone_from?: Maybe<OptionGroup>;
  _id: Scalars['ObjectID']['output'];
  _menu: Menu;
  _venue: Venue;
  clone_from?: Maybe<Scalars['ObjectID']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  menu: Scalars['ObjectID']['output'];
  options: Array<OptionGroupOption>;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type OptionGroupOption = {
  _option: Option;
  option: Scalars['ObjectID']['output'];
  ordering_index: Scalars['Float']['output'];
};

export type OptionGroupOptionInput = {
  option: Scalars['ObjectID']['input'];
  ordering_index: Scalars['Float']['input'];
};

export type Order = {
  _cancelled_by?: Maybe<Role>;
  _changelogs: Array<OrderChangelog>;
  _current_location?: Maybe<Location>;
  _customer?: Maybe<Customer>;
  _device?: Maybe<Device>;
  _id: Scalars['ObjectID']['output'];
  _location: Location;
  _original_orders: Array<Order>;
  _paid_by?: Maybe<Role>;
  _prepared_by?: Maybe<Role>;
  _processed_by?: Maybe<Role>;
  _receipt?: Maybe<PrintLog>;
  _staff?: Maybe<Role>;
  _venue: Venue;
  adjustment_amount: Scalars['Float']['output'];
  cancelled_amount: Scalars['Float']['output'];
  cancelled_at?: Maybe<Scalars['DateTime']['output']>;
  cancelled_by?: Maybe<Scalars['ObjectID']['output']>;
  cancelled_items: Array<OrderItem>;
  cancelled_reason?: Maybe<Scalars['String']['output']>;
  card_surcharge_amount: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  currencies_configs: Scalars['JSON']['output'];
  current_location?: Maybe<Scalars['ObjectID']['output']>;
  customer?: Maybe<Scalars['ObjectID']['output']>;
  device?: Maybe<Scalars['ObjectID']['output']>;
  discount_amount: Scalars['Float']['output'];
  grand_total: Scalars['Float']['output'];
  gross_amount: Scalars['Float']['output'];
  headcount?: Maybe<Scalars['Int']['output']>;
  idempotency_key?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  is_bill_printed: Scalars['Boolean']['output'];
  is_cancelled: Scalars['Boolean']['output'];
  is_needing_payment_confirmation: Scalars['Boolean']['output'];
  is_needing_prep_time_acknowledgement?: Maybe<Scalars['Boolean']['output']>;
  is_needing_prep_time_confirmation: Scalars['Boolean']['output'];
  is_paid: Scalars['Boolean']['output'];
  is_request_payment_confirmation: Scalars['Boolean']['output'];
  items: Array<OrderItem>;
  items_count: Scalars['Int']['output'];
  items_count_by_types?: Maybe<Scalars['JSON']['output']>;
  location: Scalars['ObjectID']['output'];
  max_prepare_time: Scalars['Float']['output'];
  net_amount: Scalars['Float']['output'];
  non_sales_credit_amount?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offer_amount: Scalars['Float']['output'];
  original_orders: Array<Scalars['ObjectID']['output']>;
  paid_at?: Maybe<Scalars['DateTime']['output']>;
  paid_by?: Maybe<Scalars['ObjectID']['output']>;
  prep_time: Scalars['Float']['output'];
  prepared_at?: Maybe<Scalars['DateTime']['output']>;
  prepared_by?: Maybe<Scalars['ObjectID']['output']>;
  prepped_count: Scalars['Int']['output'];
  processed_at?: Maybe<Scalars['DateTime']['output']>;
  processed_by?: Maybe<Scalars['ObjectID']['output']>;
  receipt?: Maybe<Scalars['ObjectID']['output']>;
  service_charge_amount: Scalars['Float']['output'];
  service_charge_bd_amount?: Maybe<Scalars['Float']['output']>;
  source: ORDER_SOURCE;
  staff?: Maybe<Scalars['ObjectID']['output']>;
  status: ORDER_STATUS;
  subtotal: Scalars['Float']['output'];
  tax_amount?: Maybe<Scalars['Float']['output']>;
  temp_index?: Maybe<Scalars['String']['output']>;
  ticket_linebreaks?: Maybe<Array<Scalars['Int']['output']>>;
  updated_at: Scalars['DateTime']['output'];
  vat_amount: Scalars['Float']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type OrderChangelog = {
  _user?: Maybe<Role>;
  action_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<OrderChangelogMetadata>;
  new_value?: Maybe<Scalars['Float']['output']>;
  old_value?: Maybe<Scalars['Float']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  type: ORDER_CHANGELOG_TYPE;
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<Scalars['ObjectID']['output']>;
};

export type OrderChangelogAffectedItem = {
  amount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  order_item_id: Scalars['ObjectID']['output'];
  previous_amount?: Maybe<Scalars['Float']['output']>;
};

export type OrderChangelogMetadata = {
  affected_items: Array<OrderChangelogAffectedItem>;
  amount?: Maybe<Scalars['Float']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  previous_amount?: Maybe<Scalars['Float']['output']>;
  previous_value?: Maybe<Scalars['Float']['output']>;
  previous_value_type?: Maybe<ORDER_CHANGELOG_VALUE_TYPE>;
  scope: ORDER_CHANGELOG_SCOPE;
  subject?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_type?: Maybe<ORDER_CHANGELOG_VALUE_TYPE>;
};

export type OrderCompositionInput = {
  expected_updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ObjectID']['input'];
  input: EditOrderCompositionInput;
};

export type OrderDetails = {
  adjustment_amount: Scalars['Float']['output'];
  cancelled_amount: Scalars['Float']['output'];
  cancelled_reason?: Maybe<Scalars['String']['output']>;
  card_surcharge_amount: Scalars['Float']['output'];
  created_by_name?: Maybe<Scalars['String']['output']>;
  customers_names: Array<Scalars['String']['output']>;
  discount_amount: Scalars['Float']['output'];
  estimated_rounding_amount: Scalars['Float']['output'];
  grand_total: Scalars['Float']['output'];
  gross_amount: Scalars['Float']['output'];
  headcount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  is_cancelled: Scalars['Boolean']['output'];
  is_paid: Scalars['Boolean']['output'];
  kpay_payment_types: Array<Scalars['String']['output']>;
  kpay_refs: Array<Scalars['String']['output']>;
  location_name: Scalars['String']['output'];
  locations_groups_tags: Array<Scalars['ObjectID']['output']>;
  net_amount: Scalars['Float']['output'];
  offer_amount: Scalars['Float']['output'];
  offers_names: Array<Scalars['String']['output']>;
  order_created_at: Scalars['DateTime']['output'];
  order_source: Scalars['String']['output'];
  paid_by_name?: Maybe<Scalars['String']['output']>;
  payment_types: Array<PrintLogPaymentRecord>;
  payway_refs: Array<Scalars['String']['output']>;
  receipt_created_at?: Maybe<Scalars['DateTime']['output']>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  service_charge_amount: Scalars['Float']['output'];
  service_charge_bd_amount?: Maybe<Scalars['Float']['output']>;
  status: ORDER_STATUS;
  subtotal: Scalars['Float']['output'];
  tax_amount: Scalars['Float']['output'];
  vat_amount: Scalars['Float']['output'];
  wallet_name?: Maybe<Scalars['String']['output']>;
  wallet_payment_type?: Maybe<Scalars['String']['output']>;
  wallet_transaction_amount?: Maybe<Scalars['Float']['output']>;
};

export type OrderEvent = {
  id: Scalars['ObjectID']['output'];
  payload?: Maybe<Order>;
  type: DATA_EVENT_TYPE;
};

export type OrderItem = {
  _cancelled_by?: Maybe<Role>;
  _category: Category;
  _id: Scalars['ObjectID']['output'];
  _item: Item;
  _printer_tag?: Maybe<Tag>;
  cancelled_amount: Scalars['Float']['output'];
  cancelled_at?: Maybe<Scalars['DateTime']['output']>;
  cancelled_by?: Maybe<Scalars['ObjectID']['output']>;
  cancelled_reason?: Maybe<Scalars['String']['output']>;
  category: Scalars['ObjectID']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  cost: Scalars['Float']['output'];
  course_index?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  delivered_count: Scalars['Int']['output'];
  extra_quantity: Scalars['Int']['output'];
  gross_amount: Scalars['Float']['output'];
  is_hide_from_receipt: Scalars['Boolean']['output'];
  is_master?: Maybe<Scalars['Boolean']['output']>;
  is_open_item: Scalars['Boolean']['output'];
  is_paid: Scalars['Boolean']['output'];
  item: Scalars['ObjectID']['output'];
  item_id: Scalars['String']['output'];
  /** Server timestamp when this item was accepted for preparation. */
  kds_accepted_at?: Maybe<Scalars['DateTime']['output']>;
  /** Server timestamp when this item was put on hold. */
  kds_held_at?: Maybe<Scalars['DateTime']['output']>;
  /** Total preparation time excluded by completed holds, in milliseconds. */
  kds_held_ms?: Maybe<Scalars['Float']['output']>;
  listed_price: Scalars['Float']['output'];
  master_parent?: Maybe<Scalars['ObjectID']['output']>;
  minimum_required_price: Scalars['Float']['output'];
  net_amount: Scalars['Float']['output'];
  no_service_charge: Scalars['Boolean']['output'];
  no_vat: Scalars['Boolean']['output'];
  non_sales_credit_amount?: Maybe<Scalars['Float']['output']>;
  options: Array<OrderItemOption>;
  original_price: Scalars['Float']['output'];
  original_price_addons: OriginalPriceAddons;
  prep_time: Scalars['Float']['output'];
  printer_tag?: Maybe<Scalars['ObjectID']['output']>;
  quantity: Scalars['Int']['output'];
  recipe: Array<ConsumedRecipeRawMaterialUsed>;
  serving_quantity: Scalars['Int']['output'];
  status: ORDER_ITEM_STATUS;
  subtotal: Scalars['Float']['output'];
  subtotal_addons: OrderItemSubtotalAddOns;
  title: Scalars['String']['output'];
  title_localized?: Maybe<ItemLocalizedText>;
  type: Scalars['String']['output'];
  unit_price: Scalars['Float']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OrderItemOption = {
  _id: Scalars['ObjectID']['output'];
  _option: Option;
  cancelled_amount: Scalars['Float']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  cost: Scalars['Float']['output'];
  gross_amount: Scalars['Float']['output'];
  is_hide_from_receipt: Scalars['Boolean']['output'];
  listed_price: Scalars['Float']['output'];
  net_amount: Scalars['Float']['output'];
  non_sales_credit_amount?: Maybe<Scalars['Float']['output']>;
  option: Scalars['ObjectID']['output'];
  option_id: Scalars['String']['output'];
  original_price: Scalars['Float']['output'];
  original_price_addons: OriginalPriceAddons;
  quantity: Scalars['Int']['output'];
  recipe: Array<ConsumedRecipeRawMaterialUsed>;
  serving_quantity: Scalars['Int']['output'];
  subtotal: Scalars['Float']['output'];
  subtotal_addons: OrderItemSubtotalAddOns;
  title: Scalars['String']['output'];
  title_localized?: Maybe<ItemLocalizedText>;
  uid: Scalars['String']['output'];
};

export type OrderItemSubtotalAddOns = {
  adjustment: OrderItemSubtotalAddOnsAdjustment;
  card_surcharge: OrderItemSubtotalAddOnsCardSurcharge;
  discount: OrderItemSubtotalAddOnsDiscount;
  offer: OrderItemSubtotalAddOnsOffer;
  service_charge: OrderItemSubtotalAddOnsServiceCharge;
  service_charge_bd?: Maybe<OrderItemSubtotalAddOnsServiceCharge>;
  tax?: Maybe<OrderItemSubtotalAddOnsTax>;
  vat: OrderItemSubtotalAddOnsVat;
};

export type OrderItemSubtotalAddOnsAdjustment = {
  amount: Scalars['Float']['output'];
};

export type OrderItemSubtotalAddOnsCardSurcharge = {
  amount: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
};

export type OrderItemSubtotalAddOnsDiscount = {
  amount: Scalars['Float']['output'];
  is_divided: Scalars['Boolean']['output'];
  type: DISCOUNT_TYPE;
  value: Scalars['Float']['output'];
};

export type OrderItemSubtotalAddOnsOffer = {
  amount: Scalars['Float']['output'];
  is_custom_value?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type OrderItemSubtotalAddOnsServiceCharge = {
  amount: Scalars['Float']['output'];
  is_included: Scalars['Boolean']['output'];
  percentage: Scalars['Float']['output'];
};

export type OrderItemSubtotalAddOnsTax = {
  amount: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
};

export type OrderItemSubtotalAddOnsVat = {
  amount: Scalars['Float']['output'];
  is_included: Scalars['Boolean']['output'];
  percentage: Scalars['Float']['output'];
};

export type OrderRecipeRawMaterialUsedInput = {
  consumed_quantity: Scalars['Float']['input'];
  consumed_unit_of_measurement: Scalars['ObjectID']['input'];
  raw_material: Scalars['ObjectID']['input'];
  unit_of_measurement: Scalars['ObjectID']['input'];
};

export type OrderSnapshotInput = {
  expected_updated_at: Scalars['DateTime']['input'];
  order_id: Scalars['ObjectID']['input'];
};

export type OrderWithSplittedItemsInput = {
  items: Array<OrderWithSplittedItemsItemInput>;
  orderId: Scalars['ObjectID']['input'];
};

export type OrderWithSplittedItemsItemInput = {
  _id: Scalars['ObjectID']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrdersPaginatedResponse = {
  items: Array<Order>;
  total: Scalars['Int']['output'];
};

export type OriginalPriceAddons = {
  service_charge: OriginalPriceAddonsData;
  service_charge_bd?: Maybe<OriginalPriceAddonsData>;
  vat: OriginalPriceAddonsData;
};

export type OriginalPriceAddonsData = {
  amount: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
};

export type OriginalPriceAddonsDataInput = {
  amount: Scalars['Float']['input'];
  percentage: Scalars['Float']['input'];
};

export type OriginalPriceAddonsInput = {
  service_charge: OriginalPriceAddonsDataInput;
  service_charge_bd?: InputMaybe<OriginalPriceAddonsDataInput>;
  vat: OriginalPriceAddonsDataInput;
};

export type PAYWAY_FAILURE_REASON =
  | 'checkout_not_completed'
  | 'payment_failed'
  | 'postback_not_received'
  | 'processing_failed'
  | 'status_unknown';

export type PRINT_EVENT_TYPE =
  | 'cancelled_order'
  | 'checklist'
  | 'custom'
  | 'kitchen_message'
  | 'move_ticket'
  | 'receipt'
  | 'report'
  | 'ticket';

export type PayForLocationResult = {
  cloudbedsError?: Maybe<Scalars['String']['output']>;
  /** The receipt this payment created, or the one an idempotent retry matched. */
  receiptId?: Maybe<Scalars['ObjectID']['output']>;
  roomMasterError?: Maybe<Scalars['String']['output']>;
};

export type PayForOrderResult = {
  cloudbedsError?: Maybe<Scalars['String']['output']>;
  /** The receipt this payment created, or the one an idempotent retry matched. */
  receiptId?: Maybe<Scalars['ObjectID']['output']>;
  roomMasterError?: Maybe<Scalars['String']['output']>;
};

export type PaymentInput = {
  cash_received: Array<CreateOrderPaymentCashRecordInput>;
  cash_returned: Array<CreateOrderPaymentCashRecordInput>;
  cloudbeds_payment?: InputMaybe<CloudbedsPaymentInput>;
  idempotency_key: Scalars['String']['input'];
  isInternalReceipt: Scalars['Boolean']['input'];
  payment_types: Array<CreateOrderPaymentRecordInput>;
  room_master_reference?: InputMaybe<CreateOrderPaymentRoomMasterInput>;
  temp_receipt_number?: InputMaybe<Scalars['String']['input']>;
  tips: Array<CreateOrderPaymentRecordInput>;
};

export type PaymentTypeAcceptEvent = {
  id: Scalars['ObjectID']['output'];
};

export type PaymentsDetailsPerReceipt = {
  adjustment_amount: Scalars['Float']['output'];
  cancelled_amount: Scalars['Float']['output'];
  card_surcharge_amount: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  customers_names: Array<Scalars['String']['output']>;
  discount_amount: Scalars['Float']['output'];
  gross_amount: Scalars['Float']['output'];
  headcount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  kpay_payment_types: Array<Scalars['String']['output']>;
  kpay_refs: Array<Scalars['String']['output']>;
  location_name: Scalars['String']['output'];
  location_room_number?: Maybe<Scalars['String']['output']>;
  locations_groups_tags: Array<Scalars['ObjectID']['output']>;
  net_amount: Scalars['Float']['output'];
  offer_amount: Scalars['Float']['output'];
  offers_names: Array<Scalars['String']['output']>;
  orders_indexes: Array<Scalars['Int']['output']>;
  paid_by_name?: Maybe<Scalars['String']['output']>;
  payment_types: Array<PrintLogPaymentRecord>;
  payway_refs: Array<Scalars['String']['output']>;
  receipt_number: Scalars['String']['output'];
  rounding_difference_amount: Scalars['Float']['output'];
  service_charge_amount: Scalars['Float']['output'];
  service_charge_bd_amount?: Maybe<Scalars['Float']['output']>;
  status: RECEIPT_STATUS;
  subtotal: Scalars['Float']['output'];
  tax_amount: Scalars['Float']['output'];
  tips: Array<PrintLogPaymentRecord>;
  vat_amount: Scalars['Float']['output'];
  wallet_name?: Maybe<Scalars['String']['output']>;
  wallet_payment_type?: Maybe<Scalars['String']['output']>;
  wallet_transaction_amount?: Maybe<Scalars['Float']['output']>;
};

export type PaymentsSummary = {
  averageHeadcountPerReceipt: Scalars['Float']['output'];
  averagePaymentPerHeadcount: Scalars['Float']['output'];
  averagePaymentPerReceipt: Scalars['Float']['output'];
  byPaymentTypes: Scalars['JSON']['output'];
  byReceiptTypes: PaymentsSummaryByReceiptTypes;
  byWalletPaymentTypes: Scalars['JSON']['output'];
  headcount: Scalars['Float']['output'];
  kpayPaymentTypesBreakdown: Scalars['JSON']['output'];
  paymentsReceived: Scalars['Float']['output'];
  receiptsCount: PaymentsSummaryReceiptsCount;
  receiptsCountByKpayPaymentTypes: Scalars['JSON']['output'];
  receiptsCountByPaymentTypes: Scalars['JSON']['output'];
  receiptsCountByWalletPaymentTypes: Scalars['JSON']['output'];
  roundingDifference: Scalars['Float']['output'];
  tipsByPaymentTypes: Scalars['JSON']['output'];
  tipsReceived: Scalars['Float']['output'];
};

export type PaymentsSummaryByLocation = {
  _location: Location;
  location: Scalars['ObjectID']['output'];
  paymentsSummary: PaymentsSummary;
};

export type PaymentsSummaryByLocationGroupTag = {
  _tag: Tag;
  paymentsSummary: PaymentsSummary;
  tag: Scalars['ObjectID']['output'];
};

export type PaymentsSummaryByLocations = {
  byLocationGroupTags: Array<PaymentsSummaryByLocationGroupTag>;
  byLocations: Array<PaymentsSummaryByLocation>;
};

export type PaymentsSummaryByReceiptTypes = {
  external: PaymentsSummaryByReceiptTypesBreakdown;
  internal: PaymentsSummaryByReceiptTypesBreakdown;
  total: PaymentsSummaryByReceiptTypesBreakdown;
};

export type PaymentsSummaryByReceiptTypesBreakdown = {
  count: Scalars['Float']['output'];
  paymentsReceived: Scalars['Float']['output'];
};

export type PaymentsSummaryPerDay = {
  date: Scalars['String']['output'];
  endOfDay: Scalars['String']['output'];
  paymentsSummary: PaymentsSummary;
  startOfDay: Scalars['String']['output'];
};

export type PaymentsSummaryReceiptsCount = {
  nonVoid: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  void: Scalars['Float']['output'];
};

export type PreSignedUrlResponse = {
  publicUrl: Scalars['URL']['output'];
  uploadUrl: Scalars['URL']['output'];
};

export type PrintEvent = {
  contents: Scalars['String']['output'];
  itemType?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ObjectID']['output']>;
  print_event_id?: Maybe<Scalars['String']['output']>;
  printer_name?: Maybe<Scalars['String']['output']>;
  stationIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  tagId?: Maybe<Scalars['ObjectID']['output']>;
  type: PRINT_EVENT_TYPE;
  venueId: Scalars['ObjectID']['output'];
};

export type PrintLog = {
  _id: Scalars['ObjectID']['output'];
  _location: Location;
  _orders: Array<Order>;
  _venue: Venue;
  _wallet_transaction?: Maybe<WalletTransaction>;
  cash_received: Array<PrintLogCashPaymentRecord>;
  cash_returned: Array<PrintLogCashPaymentRecord>;
  cloudbeds_reference?: Maybe<PrintLogCloudbedsRef>;
  created_at: Scalars['DateTime']['output'];
  idempotency_key?: Maybe<Scalars['String']['output']>;
  is_void: Scalars['Boolean']['output'];
  location: Scalars['ObjectID']['output'];
  payment_types: Array<PrintLogPaymentRecord>;
  receipt_number: Scalars['String']['output'];
  room_master_reference?: Maybe<PrintLogRoomMasterRef>;
  rounding_difference_amount: Scalars['Float']['output'];
  temp_receipt_number?: Maybe<Scalars['String']['output']>;
  tips: Array<PrintLogPaymentRecord>;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
  wallet_transaction?: Maybe<Scalars['ObjectID']['output']>;
};

export type PrintLogCashPaymentRecord = {
  amount: Scalars['Float']['output'];
  code: Scalars['String']['output'];
};

export type PrintLogCloudbedsRef = {
  reservation_id: Scalars['String']['output'];
  sold_product_id: Scalars['String']['output'];
};

export type PrintLogPaymentRecord = {
  amount: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  kpay_data?: Maybe<Scalars['JSON']['output']>;
  payment_type: Scalars['String']['output'];
  payway_data?: Maybe<Scalars['JSON']['output']>;
};

export type PrintLogRoomMasterRef = {
  folio_id: Scalars['String']['output'];
  folio_number: Scalars['String']['output'];
  room_number: Scalars['String']['output'];
};

export type PrintLogsPaginatedResponse = {
  items: Array<PrintLog>;
  total: Scalars['Int']['output'];
};

export type PublishPrintEventInput = {
  contents: Scalars['String']['input'];
  itemType?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ObjectID']['input']>;
  printer_name?: InputMaybe<Scalars['String']['input']>;
  stationIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  tagId?: InputMaybe<Scalars['ObjectID']['input']>;
  type: PRINT_EVENT_TYPE;
  venueId: Scalars['ObjectID']['input'];
};

export type Query = {
  /**
   * PayWay checkouts waiting on the customer or PayWay: their cached order has
   * not expired and no outcome is recorded yet. Newest first, at most 200.
   */
  adminPaywayCheckoutsInProgress: Array<AdminPaywayCheckout>;
  /**
   * Staff across venues, newest first, without super_admins (those are listed
   * per venue by `adminVenue`). `username_prefix` is case-sensitive. `page`
   * starts at 1.
   */
  adminStaff: AdminStaffPage;
  /** Failed or abandoned PayWay checkouts (temp orders), newest first. */
  adminTempOrders: AdminTempOrderPage;
  adminVenue: AdminVenueDetail;
  /**
   * Venues, newest first unless `sort` says otherwise. `search` matches the
   * start of the name, ignoring case. `page` starts at 1.
   */
  adminVenues: AdminVenuePage;
  getAccountingJournals: Array<AccountingJournal>;
  getActiveMenu: Menu;
  getActiveMenuCategories: Array<Category>;
  getActiveMenuItem: Item;
  getActiveMenuItemsPos: Array<Item>;
  getActiveMenuItemsQr: ActiveMenuItemsQrResults;
  getAiConfig: AiConfig;
  getApiKeys: Array<ApiKey>;
  getCategories: Array<Category>;
  getCloudbedsConnectUrl: Scalars['URL']['output'];
  getCloudbedsReservations: CloudbedsReservationResponse;
  getCurrentCustomer?: Maybe<Customer>;
  getCurrentCustomerOrders: Array<Order>;
  getCurrentCustomerQrCode: CustomerQrCode;
  getCurrentDevice: Device;
  getCurrentLocation: Location;
  getCurrentVenue: Venue;
  getCurrentVenueStaffs: Array<Role>;
  getCustomReports: Array<CustomReport>;
  getCustomerById: Customer;
  getCustomerByQrToken: Customer;
  getCustomerByUid: Customer;
  getCustomerOrders: OrdersPaginatedResponse;
  getCustomers: GetCustomersResponse;
  getDownloadableLocationBill: Scalars['String']['output'];
  getDownloadableOrderBill: Scalars['String']['output'];
  getDownloadableReceipt: Scalars['String']['output'];
  getInventoryTransactionsSummary: InventoryTransactionsSummary;
  getItem: Item;
  getItemTagsByCategory: Array<Scalars['ObjectID']['output']>;
  getItems: GetItemsResults;
  getLocationById: Location;
  getMaintenanceMode: MaintenanceMode;
  getMaintenanceStatus: MaintenanceMode;
  getMenus: Array<Menu>;
  getOfferById: Offer;
  getOfferOrders: OrdersPaginatedResponse;
  getOffers: Array<Offer>;
  getOperationalGeolocations: Array<Geolocation>;
  getOperationalLocations: Array<Location>;
  getOperationalNotifications: Array<Notification>;
  getOperationalOrders: Array<Order>;
  getOption: Option;
  getOptionGroups: Array<OptionGroup>;
  getOptions: GetOptionsResults;
  getOrderById: Order;
  getOrderByPayWayRef: Order;
  getOrders: OrdersPaginatedResponse;
  getOrdersDetails: Array<OrderDetails>;
  getPaymentsDetails: Array<PaymentsDetailsPerReceipt>;
  getPaymentsSummaryByLocations: PaymentsSummaryByLocations;
  getPaymentsSummaryDaily: Array<PaymentsSummaryPerDay>;
  getPaymentsSummaryOverall: PaymentsSummary;
  getPrintLogs: PrintLogsPaginatedResponse;
  getPrintableReportsItems?: Maybe<Scalars['String']['output']>;
  getPrintableReportsOverall?: Maybe<Scalars['String']['output']>;
  getRawMaterialCategories: Array<RawMaterialCategory>;
  getRawMaterialReceivers: Array<RawMaterialReceiver>;
  getRawMaterialSuppliers: Array<RawMaterialSupplier>;
  getRawMaterialTransactions: RawMaterialTransactionsPaginatedResponse;
  getRawMaterialUnitsOfMeasurement: Array<RawMaterialUnitOfMeasurement>;
  getRawMaterials: Array<RawMaterial>;
  getReceiptsSummaryByCustomer: CustomerReceiptsSummary;
  getReservations: Array<Reservation>;
  getRoles: Array<Role>;
  getSalesDetails: Array<SalesDetailsPerItem>;
  getSalesDetailsByCustomer: Array<SalesDetailsPerItem>;
  getSalesSummaryByCategories: SalesSummaryByCategories;
  getSalesSummaryByCustomer: SalesSummary;
  getSalesSummaryByItems: SalesSummaryByItems;
  getSalesSummaryByItemsByCustomer: SalesSummaryByItems;
  getSalesSummaryByLocations: SalesSummaryByLocations;
  getSalesSummaryByOffer: SalesSummary;
  getSalesSummaryByOptions: SalesSummaryByOptions;
  getSalesSummaryByOptionsPerItem: SalesSummaryByOptionsPerItem;
  getSalesSummaryByStaffs: Array<SalesSummaryByStaff>;
  getSalesSummaryCustomReports: SalesSummaryCustomReports;
  getSalesSummaryDaily: Array<SalesSummaryPerDay>;
  getSalesSummaryOverall: SalesSummary;
  getTags: Array<Tag>;
  getUserRoleById: Role;
  getVenueReceiptConfig: VenueReceiptConfig;
  getVoidsDetails: Array<VoidsDetailsPerItem>;
  getVoidsSummary: VoidsSummary;
  getWalletById: Wallet;
  getWalletStats: GetWalletStatsResponse;
  getWalletTransactions: GetWalletTransactionsResponse;
  getWallets: GetWalletsResponse;
  ping: SystemStatus;
  /** Current server timestamp for synchronizing venue clients. */
  serverTime: Scalars['DateTime']['output'];
};


export type QueryadminStaffArgs = {
  filter?: InputMaybe<AdminStaffFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryadminTempOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryadminVenueArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryadminVenuesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ADMIN_VENUE_SORT>;
};


export type QuerygetActiveMenuItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerygetActiveMenuItemsPosArgs = {
  categoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  ids?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetActiveMenuItemsQrArgs = {
  categoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetCategoriesArgs = {
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  menuId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type QuerygetCloudbedsReservationsArgs = {
  roomName: Scalars['String']['input'];
};


export type QuerygetCustomerByIdArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerygetCustomerByQrTokenArgs = {
  token: Scalars['String']['input'];
};


export type QuerygetCustomerByUidArgs = {
  uid: Scalars['String']['input'];
};


export type QuerygetCustomerOrdersArgs = {
  date?: InputMaybe<DateInput>;
  from: Scalars['Int']['input'];
  id: Scalars['ObjectID']['input'];
  items?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  size: Scalars['Int']['input'];
};


export type QuerygetCustomersArgs = {
  from: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
};


export type QuerygetDownloadableLocationBillArgs = {
  locationId: Scalars['ObjectID']['input'];
};


export type QuerygetDownloadableOrderBillArgs = {
  orderId: Scalars['ObjectID']['input'];
};


export type QuerygetDownloadableReceiptArgs = {
  receiptId: Scalars['ObjectID']['input'];
};


export type QuerygetInventoryTransactionsSummaryArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerygetItemTagsByCategoryArgs = {
  categoryId: Scalars['ObjectID']['input'];
};


export type QuerygetItemsArgs = {
  categoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  isMaster?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['ObjectID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerygetLocationByIdArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerygetOfferByIdArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerygetOfferOrdersArgs = {
  date?: InputMaybe<DateInput>;
  from: Scalars['Int']['input'];
  id: Scalars['ObjectID']['input'];
  size: Scalars['Int']['input'];
};


export type QuerygetOperationalOrdersArgs = {
  status?: InputMaybe<ORDER_STATUS>;
};


export type QuerygetOptionArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerygetOptionGroupsArgs = {
  itemId?: InputMaybe<Scalars['ObjectID']['input']>;
  menuId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type QuerygetOptionsArgs = {
  categoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  isExactName?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['ObjectID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['ObjectID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerygetOrderByIdArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerygetOrderByPayWayRefArgs = {
  ref: Scalars['String']['input'];
};


export type QuerygetOrdersArgs = {
  date?: InputMaybe<DateInput>;
  from: Scalars['Int']['input'];
  indices?: InputMaybe<Array<Scalars['Int']['input']>>;
  size: Scalars['Int']['input'];
};


export type QuerygetOrdersDetailsArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetPaymentsDetailsArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetPaymentsSummaryByLocationsArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetPaymentsSummaryDailyArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetPaymentsSummaryOverallArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetPrintLogsArgs = {
  date?: InputMaybe<DateInput>;
  from: Scalars['Int']['input'];
  orderIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
  receiptNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  size: Scalars['Int']['input'];
};


export type QuerygetPrintableReportsItemsArgs = {
  download: Scalars['Boolean']['input'];
  from: Scalars['DateTime']['input'];
  onlyItemsWithSales: Scalars['Boolean']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetPrintableReportsOverallArgs = {
  download: Scalars['Boolean']['input'];
  from: Scalars['DateTime']['input'];
  onlyItemsWithSales: Scalars['Boolean']['input'];
  selectedLocationGroupTags?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  selectedLocations?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  selectedPaymentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetRawMaterialTransactionsArgs = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};


export type QuerygetReceiptsSummaryByCustomerArgs = {
  from: Scalars['DateTime']['input'];
  id: Scalars['ObjectID']['input'];
  to: Scalars['DateTime']['input'];
};


export type QuerygetReservationsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QuerygetRolesArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetSalesDetailsArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetSalesDetailsByCustomerArgs = {
  from: Scalars['DateTime']['input'];
  id: Scalars['ObjectID']['input'];
  to: Scalars['DateTime']['input'];
};


export type QuerygetSalesSummaryByCategoriesArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetSalesSummaryByCustomerArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerygetSalesSummaryByItemsArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetSalesSummaryByItemsByCustomerArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ObjectID']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QuerygetSalesSummaryByLocationsArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetSalesSummaryByOfferArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerygetSalesSummaryByOptionsArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetSalesSummaryByOptionsPerItemArgs = {
  from: Scalars['DateTime']['input'];
  itemId: Scalars['ObjectID']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetSalesSummaryByStaffsArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetSalesSummaryCustomReportsArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetSalesSummaryDailyArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetSalesSummaryOverallArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetTagsArgs = {
  type?: InputMaybe<TAG_TYPE>;
};


export type QuerygetUserRoleByIdArgs = {
  role_id: Scalars['ObjectID']['input'];
};


export type QuerygetVoidsDetailsArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetVoidsSummaryArgs = {
  from: Scalars['DateTime']['input'];
  shift?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QuerygetWalletByIdArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerygetWalletStatsArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerygetWalletTransactionsArgs = {
  from: Scalars['Int']['input'];
  id: Scalars['ObjectID']['input'];
  size: Scalars['Int']['input'];
};


export type QuerygetWalletsArgs = {
  from: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
};

export type RECEIPT_STATUS =
  | 'NON_VOID'
  | 'VOID';

export type ROLE_PERMISSIONS =
  | 'ACCESS_MENU_MANAGEMENT'
  | 'ACCESS_REPORTS'
  | 'AUTO_LOGOUT'
  | 'CANCEL_ITEM'
  | 'CANCEL_ORDER_AFTER_BILL_PRINTED'
  | 'CANCEL_ORDER_AFTER_PAYMENT'
  | 'CANCEL_ORDER_BEFORE_BILL_PRINTED'
  | 'CANCEL_ORDER_BEFORE_PAYMENT'
  | 'CANCEL_RECEIPT'
  | 'CHANGE_OPS_PRINTER'
  | 'CREATE_ORDER'
  | 'EDIT_LISTED_ITEM_PRICE'
  | 'EDIT_MENU_MANAGEMENT'
  | 'EDIT_ORDER_AFTER_BILL_PRINTED'
  | 'EDIT_ORDER_AFTER_PAYMENT'
  | 'EDIT_ORDER_BEFORE_BILL_PRINTED'
  | 'EDIT_ORDER_BEFORE_PAYMENT'
  | 'EDIT_ORDER_TIMESTAMP'
  | 'EDIT_RECEIPT_TIMESTAMP'
  | 'OPEN_CASHDRAWER'
  | 'TOGGLE_ITEM_AVAILABILITY'
  | 'VIEW_ORDER';

export type ROLE_TYPE =
  | 'admin'
  | 'junior_staff'
  | 'manager'
  | 'staff'
  | 'super_admin'
  | 'supervisor';

export type RawMaterial = {
  _category?: Maybe<Category>;
  _id: Scalars['ObjectID']['output'];
  _supplier?: Maybe<RawMaterialSupplier>;
  _total_balance_value: Scalars['Float']['output'];
  _unit_of_measurement?: Maybe<RawMaterialUnitOfMeasurement>;
  _venue?: Maybe<Venue>;
  category: Scalars['ObjectID']['output'];
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiration_notification_threshold: Scalars['Float']['output'];
  is_enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  raw_price: Scalars['Float']['output'];
  replenishment_tolerance: Scalars['Float']['output'];
  required_in_stock_amount: Scalars['Float']['output'];
  shelf_life: Scalars['Float']['output'];
  storage_location?: Maybe<Scalars['String']['output']>;
  supplier: Scalars['ObjectID']['output'];
  total_adjustment_quantity: Scalars['Float']['output'];
  total_balance_quantity: Scalars['Float']['output'];
  total_consumed_quantity: Scalars['Float']['output'];
  total_defect_quantity: Scalars['Float']['output'];
  total_expired_quantity: Scalars['Float']['output'];
  total_received_quantity: Scalars['Float']['output'];
  total_starting_quantity?: Maybe<Scalars['Float']['output']>;
  total_transfer_out_quantity?: Maybe<Scalars['Float']['output']>;
  total_wastage_quantity: Scalars['Float']['output'];
  unit_of_measurement: Scalars['ObjectID']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type RawMaterialBalanceInput = {
  _id: Scalars['ObjectID']['input'];
  adjustment_quantity: Scalars['Float']['input'];
  consumed_quantity: Scalars['Float']['input'];
  defect_quantity: Scalars['Float']['input'];
  expired_quantity: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  starting_quantity?: InputMaybe<Scalars['Float']['input']>;
  transfer_out_quantity?: InputMaybe<Scalars['Float']['input']>;
  wastage_quantity: Scalars['Float']['input'];
};

export type RawMaterialCategory = {
  _id: Scalars['ObjectID']['output'];
  _venue?: Maybe<Venue>;
  name: Scalars['String']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type RawMaterialReceived = {
  _id: Scalars['ObjectID']['output'];
  _raw_material: RawMaterial;
  _receiver: Role;
  _supplier: RawMaterialSupplier;
  _transfer_out_receiver?: Maybe<RawMaterialReceiver>;
  _venue: Venue;
  adjustment_quantity: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  defect_quantity: Scalars['Float']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  expired_quantity: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  raw_material: Scalars['ObjectID']['output'];
  raw_price: Scalars['Float']['output'];
  received_unit_of_measurement: Scalars['ObjectID']['output'];
  receiver: Scalars['ObjectID']['output'];
  starting_quantity?: Maybe<Scalars['Float']['output']>;
  supplier: Scalars['ObjectID']['output'];
  /** Starting plus received quantity multiplied by the price in the received UoM. */
  total_cost: Scalars['Float']['output'];
  transaction_date: Scalars['DateTime']['output'];
  transfer_out_quantity?: Maybe<Scalars['Float']['output']>;
  transfer_out_receiver?: Maybe<Scalars['ObjectID']['output']>;
  unit_of_measurement_metadata: RawMaterialReceivedUnitOfMeasurement;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
  wastage_quantity: Scalars['Float']['output'];
};

export type RawMaterialReceivedUnitOfMeasurement = {
  _id: Scalars['ObjectID']['output'];
  sub_units: Array<RawMaterialSupplierUnitOfMeasurementSubUnit>;
  title: Scalars['String']['output'];
};

export type RawMaterialReceiver = {
  _id: Scalars['ObjectID']['output'];
  _venue?: Maybe<Venue>;
  code: Scalars['String']['output'];
  contact_person: Scalars['String']['output'];
  country_of_origin: Scalars['String']['output'];
  description: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type RawMaterialSupplier = {
  _id: Scalars['ObjectID']['output'];
  _venue?: Maybe<Venue>;
  code: Scalars['String']['output'];
  contact_person: Scalars['String']['output'];
  country_of_origin: Scalars['String']['output'];
  description: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type RawMaterialSupplierUnitOfMeasurementSubUnit = {
  _id: Scalars['ObjectID']['output'];
  created_at: Scalars['DateTime']['output'];
  rate: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type RawMaterialTransactionsPaginatedResponse = {
  rawMaterialReceived: Array<RawMaterialReceived>;
  rowCount: Scalars['Float']['output'];
};

export type RawMaterialUnitOfMeasurement = {
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  created_at: Scalars['DateTime']['output'];
  sub_units: Array<RawMaterialSupplierUnitOfMeasurementSubUnit>;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type RawMaterialUnitOfMeasurementInput = {
  _id: Scalars['ObjectID']['input'];
  sub_units: Array<RawMaterialUnitOfMeasurementSubUnitInput>;
  title: Scalars['String']['input'];
};

export type RawMaterialUnitOfMeasurementSubUnitInput = {
  _id: Scalars['ObjectID']['input'];
  rate: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type RecipeRawMaterialUsed = {
  _raw_material: RawMaterial;
  _unit_of_measurement: Scalars['ObjectID']['output'];
  consumed_quantity: Scalars['Float']['output'];
  consumed_unit_of_measurement: Scalars['ObjectID']['output'];
  /** Latest raw-material transaction cost per received unit. */
  cost_per_uom: Scalars['Float']['output'];
  /** Recipe consumption normalized to the received unit. */
  normalized_consumed_quantity: Scalars['Float']['output'];
  raw_material: Scalars['ObjectID']['output'];
  /** Title of the unit used for cost_per_uom. */
  received_uom_title: Scalars['String']['output'];
  /** Calculated cost for this recipe line. */
  total_cost: Scalars['Float']['output'];
  unit_of_measurement: Scalars['ObjectID']['output'];
};

export type RecipeRawMaterialUsedInput = {
  consumed_quantity: Scalars['Float']['input'];
  consumed_unit_of_measurement: Scalars['ObjectID']['input'];
  raw_material: Scalars['ObjectID']['input'];
  unit_of_measurement: Scalars['ObjectID']['input'];
};

export type RefreshTokenPayload = {
  token: Scalars['String']['output'];
};

export type ReportsAvailabilityWindows = {
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportsAvailabilityWindowsInput = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type RepostReceiptToCloudbedsResult = {
  cloudbedsError?: Maybe<Scalars['String']['output']>;
  printLog: PrintLog;
};

export type RepostReceiptToRoomMasterResult = {
  printLog: PrintLog;
  roomMasterError?: Maybe<Scalars['String']['output']>;
};

export type Reservation = {
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  contact: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  number_of_people: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type ReservationInput = {
  contact: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  number_of_people: Scalars['Int']['input'];
};

export type RestHealthChecks = {
  mongo: ServiceStatus;
  redis_command: ServiceStatus;
  redis_expire_subscriber: ServiceStatus;
};

export type RestHealthStatus = {
  checks: RestHealthChecks;
  ok: Scalars['Boolean']['output'];
};

export type Role = {
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  permissions: Array<ROLE_PERMISSIONS>;
  position?: Maybe<Scalars['Int']['output']>;
  type: ROLE_TYPE;
  updated_at: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
  venue: Scalars['ObjectID']['output'];
  venue_issued_id?: Maybe<Scalars['String']['output']>;
};

export type RoomMasterResponse = {
  Balance?: Maybe<Scalars['String']['output']>;
  BalanceDue?: Maybe<Scalars['String']['output']>;
  BookingId?: Maybe<Scalars['String']['output']>;
  CreditLimit?: Maybe<Scalars['String']['output']>;
  FolioList: Array<FolioList>;
  FolioNumber: Scalars['String']['output'];
  GroupId?: Maybe<Scalars['String']['output']>;
  GuestName?: Maybe<Scalars['String']['output']>;
  PropertyId: Scalars['String']['output'];
  RateCode?: Maybe<Scalars['String']['output']>;
  RoomId?: Maybe<Scalars['String']['output']>;
  RoomName?: Maybe<Scalars['String']['output']>;
  RoomNumber: Scalars['String']['output'];
  RoomType?: Maybe<Scalars['String']['output']>;
  Type: Scalars['String']['output'];
  status?: Maybe<RoomMasterStatus>;
};

export type RoomMasterStatus = {
  errorException?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errorThrown?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  messagetype?: Maybe<Scalars['String']['output']>;
  postingId?: Maybe<Scalars['String']['output']>;
  propertyid: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  traceid: Scalars['String']['output'];
};

export type SYSTEM_HEALTH_SUBSCRIPTION_EVENT_TYPE =
  | 'init'
  | 'new_version_available'
  | 'shutdown';

export type SalesDetailsPerItem = {
  adjustment_amount: Scalars['Float']['output'];
  cancelled_amount: Scalars['Float']['output'];
  cancelled_reason?: Maybe<Scalars['String']['output']>;
  card_surcharge_amount: Scalars['Float']['output'];
  category_title?: Maybe<Scalars['String']['output']>;
  /** Total cost for this row's quantity. */
  cost: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by_name?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  discount_amount: Scalars['Float']['output'];
  gross_amount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  is_cancelled: Scalars['Boolean']['output'];
  is_paid: Scalars['Boolean']['output'];
  item_id: Scalars['String']['output'];
  item_tags: Array<Scalars['String']['output']>;
  item_title: Scalars['String']['output'];
  item_type: Scalars['String']['output'];
  kpay_payment_types: Array<Scalars['String']['output']>;
  kpay_ref?: Maybe<Scalars['String']['output']>;
  location_name: Scalars['String']['output'];
  location_room_number?: Maybe<Scalars['String']['output']>;
  locations_groups_tags: Array<Scalars['ObjectID']['output']>;
  master_item_title?: Maybe<Scalars['String']['output']>;
  net_amount: Scalars['Float']['output'];
  offer_amount: Scalars['Float']['output'];
  offer_name?: Maybe<Scalars['String']['output']>;
  order_index: Scalars['Int']['output'];
  order_source: Scalars['String']['output'];
  original_price: Scalars['Float']['output'];
  paid_by_name?: Maybe<Scalars['String']['output']>;
  payment_types: Array<Scalars['String']['output']>;
  payway_ref?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  receipt_number?: Maybe<Scalars['String']['output']>;
  report_tags: Array<Scalars['String']['output']>;
  service_charge_amount: SalesDetailsPerItemAddOns;
  service_charge_bd_amount?: Maybe<SalesDetailsPerItemAddOns>;
  status: ORDER_STATUS;
  subtotal: Scalars['Float']['output'];
  tax_amount: Scalars['Float']['output'];
  /** Cost per sold item captured on the order. */
  unit_cost: Scalars['Float']['output'];
  vat_amount: SalesDetailsPerItemAddOns;
  wallet_name?: Maybe<Scalars['String']['output']>;
  wallet_payment_type?: Maybe<Scalars['String']['output']>;
};

export type SalesDetailsPerItemAddOns = {
  amount: Scalars['Float']['output'];
  is_included: Scalars['Boolean']['output'];
};

export type SalesSummary = {
  adjustment: SalesSummaryBreakdown;
  averageGrossAmountPerHeadcount?: Maybe<SalesSummaryBreakdown>;
  averageGrossAmountPerOrder: SalesSummaryBreakdown;
  cancelledValue: SalesSummaryBreakdown;
  cardSurcharge: SalesSummaryBreakdown;
  discount: SalesSummaryBreakdown;
  grossSales: SalesSummaryBreakdown;
  grossSalesByPaidStatus?: Maybe<SalesSummaryGrossSalesByPaidStatus>;
  headcount?: Maybe<SalesSummaryBreakdown>;
  netSales: SalesSummaryBreakdown;
  offer: SalesSummaryBreakdown;
  ordersCount: SalesSummaryBreakdown;
  serviceCharge: SalesSummaryBreakdown;
  serviceChargeBd: SalesSummaryBreakdown;
  subtotal: SalesSummaryBreakdown;
  tax: SalesSummaryBreakdown;
  vat: SalesSummaryBreakdown;
};

export type SalesSummaryBreakdown = {
  qr: Scalars['Float']['output'];
  till: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type SalesSummaryByCategories = {
  byCategories: Array<SalesSummaryByCategory>;
  count: Scalars['Float']['output'];
  grossSales: Scalars['Float']['output'];
};

export type SalesSummaryByCategory = {
  _category: Category;
  byItems: Array<SalesSummaryByItem>;
  cancelledValue: Scalars['Float']['output'];
  cardSurcharge: Scalars['Float']['output'];
  category: Scalars['ObjectID']['output'];
  count: Scalars['Float']['output'];
  discount: Scalars['Float']['output'];
  grossSales: Scalars['Float']['output'];
  netSales: Scalars['Float']['output'];
  offer: Scalars['Float']['output'];
  serviceCharge: Scalars['Float']['output'];
  serviceChargeBd: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
};

export type SalesSummaryByItem = {
  _item: Item;
  adjustment: Scalars['Float']['output'];
  /** Quantity-weighted average unit cost for the selected period. */
  averageUnitCost: Scalars['Float']['output'];
  cancelledValue: Scalars['Float']['output'];
  cardSurcharge: Scalars['Float']['output'];
  cost?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Float']['output'];
  discount: Scalars['Float']['output'];
  grossSales: Scalars['Float']['output'];
  item: Scalars['ObjectID']['output'];
  itemId: Scalars['String']['output'];
  netSales: Scalars['Float']['output'];
  offer: Scalars['Float']['output'];
  serviceCharge: Scalars['Float']['output'];
  serviceChargeBd: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  /** Total cost of goods for the selected period. */
  totalCost: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
};

export type SalesSummaryByItems = {
  byItems: Array<SalesSummaryByItem>;
  cancelled: SalesSummaryByItemsCancelled;
  count: SalesSummaryByItemsOverallBreakdown;
  grossSales: SalesSummaryByItemsOverallBreakdown;
};

export type SalesSummaryByItemsCancelled = {
  count: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type SalesSummaryByItemsOverallBreakdown = {
  byTypes: Scalars['JSON']['output'];
  total: Scalars['Float']['output'];
};

export type SalesSummaryByLocation = {
  _location: Location;
  location: Scalars['ObjectID']['output'];
  salesSummary: SalesSummary;
};

export type SalesSummaryByLocationGroupTag = {
  _tag: Tag;
  salesSummary: SalesSummary;
  tag: Scalars['ObjectID']['output'];
};

export type SalesSummaryByLocations = {
  byLocationGroupTags: Array<SalesSummaryByLocationGroupTag>;
  byLocations: Array<SalesSummaryByLocation>;
};

export type SalesSummaryByOption = {
  _option: Option;
  adjustment: Scalars['Float']['output'];
  cancelledValue: Scalars['Float']['output'];
  cardSurcharge: Scalars['Float']['output'];
  cost?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Float']['output'];
  discount: Scalars['Float']['output'];
  grossSales: Scalars['Float']['output'];
  itemId: Scalars['String']['output'];
  netSales: Scalars['Float']['output'];
  offer: Scalars['Float']['output'];
  option: Scalars['ObjectID']['output'];
  serviceCharge: Scalars['Float']['output'];
  serviceChargeBd: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
};

export type SalesSummaryByOptionPerItem = {
  _option: Option;
  count: Scalars['Float']['output'];
  option: Scalars['ObjectID']['output'];
};

export type SalesSummaryByOptions = {
  byOptions: Array<SalesSummaryByOption>;
  cancelled: SalesSummaryByOptionsCancelled;
  count: SalesSummaryByOptionsOverallBreakdown;
  grossSales: SalesSummaryByOptionsOverallBreakdown;
};

export type SalesSummaryByOptionsCancelled = {
  count: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type SalesSummaryByOptionsOverallBreakdown = {
  total: Scalars['Float']['output'];
};

export type SalesSummaryByOptionsPerItem = {
  byOptions: Array<SalesSummaryByOptionPerItem>;
  count: SalesSummaryByOptionsPerItemOverallBreakdown;
};

export type SalesSummaryByOptionsPerItemOverallBreakdown = {
  total: Scalars['Float']['output'];
};

export type SalesSummaryByStaff = {
  _staff: Role;
  salesSummary: SalesSummary;
  staff: Scalars['ObjectID']['output'];
};

export type SalesSummaryCustom = {
  _id: Scalars['String']['output'];
  adjustment: Scalars['Float']['output'];
  cancelledValue: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
  discount: Scalars['Float']['output'];
  grossSales: Scalars['Float']['output'];
  netSales: Scalars['Float']['output'];
  offer: Scalars['Float']['output'];
  serviceCharge: Scalars['Float']['output'];
  serviceChargeBd: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
};

export type SalesSummaryCustomReports = {
  byCategories: Array<SalesSummaryByCategory>;
  byItemTypes: Array<SalesSummaryCustom>;
  byItems: Array<SalesSummaryByItem>;
  byLocationGroupTags: Array<SalesSummaryCustom>;
  byLocations: Array<SalesSummaryCustom>;
  byOffers: Array<SalesSummaryCustom>;
  byOptions: Array<SalesSummaryByOption>;
  byPaymentTypes: Array<SalesSummaryCustom>;
};

export type SalesSummaryGrossSalesByPaidStatus = {
  paid: Scalars['Float']['output'];
  unpaid: Scalars['Float']['output'];
};

export type SalesSummaryPerDay = {
  date: Scalars['String']['output'];
  endOfDay: Scalars['String']['output'];
  salesSummary: SalesSummary;
  startOfDay: Scalars['String']['output'];
};

export type ServiceStatus = {
  error?: Maybe<Scalars['String']['output']>;
  latency_ms?: Maybe<Scalars['Int']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Subscription = {
  subscribeToCurrentDevice: DeviceEvent;
  subscribeToCurrentVenue: VenueEvent;
  subscribeToDeviceOrders: DeviceOrderEvent;
  subscribeToLocation: LocationEvent;
  subscribeToLocationLock: LocationLockEvent;
  subscribeToMenu: MenuEvent;
  subscribeToOrder: OrderEvent;
  subscribeToOrderPaymentTypeAcceptEvent: PaymentTypeAcceptEvent;
  subscribeToPrintEvent: PrintEvent;
  subscribeToSystemHealth: SystemHealthEvent;
  subscribeToVenueLocations: LocationEvent;
  subscribeToVenueNotifications: NotificationEvent;
  subscribeToVenueOrders: OrderEvent;
};


export type SubscriptionsubscribeToLocationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type SubscriptionsubscribeToLocationLockArgs = {
  locationId: Scalars['ObjectID']['input'];
};


export type SubscriptionsubscribeToMenuArgs = {
  id: Scalars['ObjectID']['input'];
};


export type SubscriptionsubscribeToOrderArgs = {
  orderId?: InputMaybe<Scalars['ObjectID']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionsubscribeToOrderPaymentTypeAcceptEventArgs = {
  id: Scalars['ObjectID']['input'];
};


export type SubscriptionsubscribeToSystemHealthArgs = {
  type?: InputMaybe<SYSTEM_HEALTH_SUBSCRIPTION_EVENT_TYPE>;
};

export type SubtotalAddOnsInput = {
  adjustment: CreateOrderItemSubtotalAddOnsAdjustmentInput;
  card_surcharge: CreateOrderItemSubtotalAddOnsCardSurchargeInput;
  discount: CreateOrderItemSubtotalAddOnsDiscountInput;
  offer: CreateOrderItemSubtotalAddOnsOfferInput;
  service_charge: CreateOrderItemSubtotalAddOnsServiceChargeInput;
  service_charge_bd?: InputMaybe<CreateOrderItemSubtotalAddOnsServiceChargeInput>;
  tax?: InputMaybe<CreateOrderItemSubtotalAddOnsCardSurchargeInput>;
  vat: CreateOrderItemSubtotalAddOnsVatInput;
};

export type SystemHealthEvent = {
  type: SYSTEM_HEALTH_SUBSCRIPTION_EVENT_TYPE;
};

export type SystemStatus = {
  checked_at: Scalars['DateTime']['output'];
  duration_ms: Scalars['Int']['output'];
  env?: Maybe<Scalars['String']['output']>;
  graphql_operations: GraphQLOperationsHealthStatus;
  graphql_subscriptions: GraphQLSubscriptionsHealthStatus;
  rest: RestHealthStatus;
  version?: Maybe<Scalars['String']['output']>;
};

export type TAG_TYPE =
  | 'location_group'
  | 'menu_item_display'
  | 'menu_item_report'
  | 'printer';

export type TableConfigValues = {
  fields: Array<CUSTOM_REPORT_VALUE_FIELD>;
  item: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: CUSTOM_REPORT_VALUE_TYPE;
};

export type TableConfigValuesInput = {
  fields: Array<CUSTOM_REPORT_VALUE_FIELD>;
  item: Scalars['String']['input'];
  label: Scalars['String']['input'];
  type: CUSTOM_REPORT_VALUE_TYPE;
};

export type TableConfigs = {
  title: Scalars['String']['output'];
  values: Array<TableConfigValues>;
};

export type Tag = {
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  created_at: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  label_localized?: Maybe<ItemLocalizedText>;
  ordering_index?: Maybe<Scalars['Int']['output']>;
  type: TAG_TYPE;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type TagInput = {
  label: Scalars['String']['input'];
  label_localized?: InputMaybe<ItemLocalizedTextInput>;
  ordering_index?: InputMaybe<Scalars['Int']['input']>;
  type: TAG_TYPE;
};

export type TempOrder = {
  _id: Scalars['ObjectID']['output'];
  _is_payment_approved: Scalars['Boolean']['output'];
  /** Index of the already-created order this checkout was paying for; null when the checkout was for a new order */
  _order_index?: Maybe<Scalars['Int']['output']>;
  /** Amount PayWay reports for the transaction, or the order total when PayWay reports none */
  _payment_amount?: Maybe<Scalars['Float']['output']>;
  _payment_currency?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  failure_reason?: Maybe<PAYWAY_FAILURE_REASON>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  payway_ref?: Maybe<Scalars['String']['output']>;
  payway_verification_data?: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

/** Only the provided fields are changed. */
export type UpdateAiConfigInput = {
  api_key?: InputMaybe<Scalars['String']['input']>;
  base_url?: InputMaybe<Scalars['String']['input']>;
  model_text?: InputMaybe<Scalars['String']['input']>;
  model_vision?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApiKeyInput = {
  name: Scalars['String']['input'];
};

export type UpdateCategoryInput = {
  availability?: InputMaybe<AvailabilityInput>;
  clone_from?: InputMaybe<Scalars['ObjectID']['input']>;
  is_template?: InputMaybe<Scalars['Boolean']['input']>;
  menu?: InputMaybe<Scalars['ObjectID']['input']>;
  ordering_index?: InputMaybe<Scalars['Int']['input']>;
  till_card_color?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_localized?: InputMaybe<ItemLocalizedTextInput>;
};

export type UpdateCurrentDeviceInput = {
  fcm_token?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurrentVenueAddOnsInput = {
  service_charge?: InputMaybe<UpdateCurrentVenueServiceChargeInput>;
  service_charge_bd?: InputMaybe<UpdateCurrentVenueServiceChargeBdInput>;
  vat?: InputMaybe<UpdateCurrentVenueVatInput>;
};

export type UpdateCurrentVenueAvailablePrinterInput = {
  name: Scalars['String']['input'];
};

export type UpdateCurrentVenueCurrenciesConfigInput = {
  code: Scalars['String']['input'];
  is_deactivated: Scalars['Boolean']['input'];
  is_primary_currency: Scalars['Boolean']['input'];
  is_secondary_currency: Scalars['Boolean']['input'];
  previous_rate?: InputMaybe<Scalars['Float']['input']>;
  rate: Scalars['Float']['input'];
};

export type UpdateCurrentVenueCustomPaymentTypeInput = {
  is_deactivated: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateCurrentVenueCustomPrintingFieldInput = {
  label: Scalars['String']['input'];
};

export type UpdateCurrentVenueInput = {
  additional_digital_menu_languages?: InputMaybe<Array<DIGITAL_MENU_LANGUAGE>>;
  address?: InputMaybe<Scalars['String']['input']>;
  allow_add_items_to_paid_orders?: InputMaybe<Scalars['Boolean']['input']>;
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  auto_print_checklist?: InputMaybe<Scalars['Boolean']['input']>;
  available_printers?: InputMaybe<Array<UpdateCurrentVenueAvailablePrinterInput>>;
  banner_img?: InputMaybe<Scalars['URL']['input']>;
  bill_footer?: InputMaybe<Scalars['String']['input']>;
  cancelled_reason_options?: InputMaybe<Array<Scalars['String']['input']>>;
  card_surcharge?: InputMaybe<Scalars['Float']['input']>;
  currencies_configs?: InputMaybe<Array<UpdateCurrentVenueCurrenciesConfigInput>>;
  custom_note_instructions?: InputMaybe<Scalars['String']['input']>;
  custom_payment_types?: InputMaybe<Array<UpdateCurrentVenueCustomPaymentTypeInput>>;
  custom_printing_fields?: InputMaybe<Array<UpdateCurrentVenueCustomPrintingFieldInput>>;
  default_ops_page?: InputMaybe<OPS_PAGE>;
  default_service_charge_type?: InputMaybe<DEFAULT_SERVICE_CHARGE_TYPE>;
  description?: InputMaybe<Scalars['String']['input']>;
  inventory_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_accounting_journal_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_cloudbeds_integration_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_cost_management_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_custom_report_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_management_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_digital_menu_additional_language_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_digital_menu_user_login_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_digital_menu_user_sign_up_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_grouping_option_on_print_ticket?: InputMaybe<Scalars['Boolean']['input']>;
  is_include_total_qty_in_receipt?: InputMaybe<Scalars['Boolean']['input']>;
  is_internal_receipt_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_inventory_management_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_item_tags_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_kds_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_kpay_integration_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_language_localization_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_location_lock_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_offers_crud_for_super_admin_only?: InputMaybe<Scalars['Boolean']['input']>;
  is_offline_mode_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_ordering_requires_customer?: InputMaybe<Scalars['Boolean']['input']>;
  is_ordering_requires_headcount?: InputMaybe<Scalars['Boolean']['input']>;
  is_ordering_requires_note?: InputMaybe<Scalars['Boolean']['input']>;
  is_ordering_requires_staff_accept?: InputMaybe<Scalars['Boolean']['input']>;
  is_payment_confirmation_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_payment_rounding_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_payway_integration_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_print_ticket_by_item?: InputMaybe<Scalars['Boolean']['input']>;
  is_print_ticket_by_option?: InputMaybe<Scalars['Boolean']['input']>;
  is_qr_ordering_only?: InputMaybe<Scalars['Boolean']['input']>;
  is_report_tags_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_reports_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_required_headcount_before_payment?: InputMaybe<Scalars['Boolean']['input']>;
  is_reservation_management_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_room_master_integration_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_till_send_and_pay_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_till_send_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_wallet_management_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_work_ticket_remove_order_number?: InputMaybe<Scalars['Boolean']['input']>;
  is_work_ticket_remove_price?: InputMaybe<Scalars['Boolean']['input']>;
  item_types?: InputMaybe<Array<Scalars['String']['input']>>;
  logo?: InputMaybe<Scalars['URL']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  only_one_order_per_location?: InputMaybe<Scalars['Boolean']['input']>;
  operational_data_refetch_interval?: InputMaybe<Scalars['Int']['input']>;
  ops_page_font_size?: InputMaybe<Scalars['Float']['input']>;
  order_notification_dings?: InputMaybe<Scalars['Int']['input']>;
  preset_messages?: InputMaybe<Array<Scalars['String']['input']>>;
  print_content_padding?: InputMaybe<Array<Scalars['Float']['input']>>;
  print_font_sizes?: InputMaybe<UpdateCurrentVenuePrintFontSizesInput>;
  receipt_config?: InputMaybe<UpdateVenueReceiptConfigInput>;
  reports_availability_windows?: InputMaybe<Array<ReportsAvailabilityWindowsInput>>;
  reports_display_figure?: InputMaybe<VENUE_REPORTS_DISPLAY_FIGURE>;
  room_master_property_id?: InputMaybe<Scalars['String']['input']>;
  shifts?: InputMaybe<Array<UpdateCurrentVenueShiftInput>>;
  should_clear_location_after_payment?: InputMaybe<Scalars['Boolean']['input']>;
  stations?: InputMaybe<Array<UpdateCurrentVenueStationInput>>;
  tax?: InputMaybe<Scalars['Float']['input']>;
  theme?: InputMaybe<UpdateCurrentVenueThemeInput>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_limit?: InputMaybe<Scalars['Int']['input']>;
  vat_tin?: InputMaybe<Scalars['String']['input']>;
  wallet_payment_labels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCurrentVenuePrintFontSizesInput = {
  receipt: Scalars['Float']['input'];
  reports: Scalars['Float']['input'];
  ticket: Scalars['Float']['input'];
};

export type UpdateCurrentVenueServiceChargeBdInput = {
  is_service_charge_bd_buried: Scalars['Boolean']['input'];
  service_charge_bd: Scalars['Float']['input'];
};

export type UpdateCurrentVenueServiceChargeInput = {
  is_service_charge_buried: Scalars['Boolean']['input'];
  service_charge: Scalars['Float']['input'];
};

export type UpdateCurrentVenueShiftInput = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type UpdateCurrentVenueStationInput = {
  _id: Scalars['ObjectID']['input'];
  is_cashdrawer_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_group_printer_tags_on_one_ticket?: InputMaybe<Scalars['Boolean']['input']>;
  locations_of_interest: Array<Scalars['String']['input']>;
  printer_name: Scalars['String']['input'];
  printer_tags_of_interest: Array<Scalars['ObjectID']['input']>;
  station_name: Scalars['String']['input'];
  types_of_interest: Array<Scalars['String']['input']>;
};

export type UpdateCurrentVenueThemeInput = {
  primary_color: Scalars['HexColorCode']['input'];
  primary_text_color: Scalars['HexColorCode']['input'];
};

export type UpdateCurrentVenueVatInput = {
  is_vat_buried: Scalars['Boolean']['input'];
  vat: Scalars['Float']['input'];
};

export type UpdateCustomReportInput = {
  _id: Scalars['ObjectID']['input'];
  display_type?: InputMaybe<CUSTOM_REPORT_DISPLAY_TYPE>;
  doughnut_configs?: InputMaybe<CustomReportDoughnutInput>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  table_configs?: InputMaybe<CustomReportTableConfigInput>;
};

export type UpdateItemInput = {
  availability?: InputMaybe<AvailabilityInput>;
  banner_img?: InputMaybe<Scalars['URL']['input']>;
  category?: InputMaybe<Scalars['ObjectID']['input']>;
  clone_from?: InputMaybe<Scalars['ObjectID']['input']>;
  controlled_quantity?: InputMaybe<Scalars['Int']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_localized?: InputMaybe<ItemLocalizedTextInput>;
  extra_quantity?: InputMaybe<Scalars['Int']['input']>;
  is_cost_automatically_calculated?: InputMaybe<Scalars['Boolean']['input']>;
  is_hide_from_receipt?: InputMaybe<Scalars['Boolean']['input']>;
  is_master?: InputMaybe<Scalars['Boolean']['input']>;
  is_open_item?: InputMaybe<Scalars['Boolean']['input']>;
  is_pos_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_qr_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_quantity_controlled?: InputMaybe<Scalars['Boolean']['input']>;
  is_template?: InputMaybe<Scalars['Boolean']['input']>;
  item_id?: InputMaybe<Scalars['String']['input']>;
  item_tags?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  listed_price?: InputMaybe<Scalars['Float']['input']>;
  master_items?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  menu?: InputMaybe<Scalars['ObjectID']['input']>;
  minimum_required_price?: InputMaybe<Scalars['Float']['input']>;
  no_service_charge?: InputMaybe<Scalars['Boolean']['input']>;
  no_vat?: InputMaybe<Scalars['Boolean']['input']>;
  option_groups?: InputMaybe<Array<ItemOptionGroupInput>>;
  options?: InputMaybe<Array<ItemOptionInput>>;
  ordering_index?: InputMaybe<Scalars['Int']['input']>;
  original_price?: InputMaybe<Scalars['Float']['input']>;
  original_price_addons?: InputMaybe<OriginalPriceAddonsInput>;
  prep_time?: InputMaybe<Scalars['Float']['input']>;
  printer_tag?: InputMaybe<Scalars['ObjectID']['input']>;
  recipe?: InputMaybe<Array<RecipeRawMaterialUsedInput>>;
  report_tags?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  till_card_color?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_localized?: InputMaybe<ItemLocalizedTextInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLocationHiddenItemsConfigsInput = {
  categories: Array<Scalars['ObjectID']['input']>;
  is_categories_hide_on_pos: Scalars['Boolean']['input'];
  is_categories_hide_on_qr: Scalars['Boolean']['input'];
  is_item_types_hide_on_pos: Scalars['Boolean']['input'];
  is_item_types_hide_on_qr: Scalars['Boolean']['input'];
  is_items_hide_on_pos: Scalars['Boolean']['input'];
  is_items_hide_on_qr: Scalars['Boolean']['input'];
  item_types: Array<Scalars['String']['input']>;
  items: Array<Scalars['ObjectID']['input']>;
};

export type UpdateLocationInput = {
  current_headcount?: InputMaybe<Scalars['Float']['input']>;
  default_order_note?: InputMaybe<Scalars['String']['input']>;
  hidden_items_configs?: InputMaybe<UpdateLocationHiddenItemsConfigsInput>;
  is_pay_later_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  is_pay_now_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  locations_groups_tags?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  no_service_charge?: InputMaybe<Scalars['Boolean']['input']>;
  no_vat?: InputMaybe<Scalars['Boolean']['input']>;
  payment_types?: InputMaybe<Array<Scalars['String']['input']>>;
  room_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LOCATION_STATUS>;
  type?: InputMaybe<LOCATION_TYPE>;
};

export type UpdateMenuInput = {
  banner_img?: InputMaybe<Scalars['URL']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOptionGroupInput = {
  clone_from?: InputMaybe<Scalars['ObjectID']['input']>;
  deleted_at?: InputMaybe<Scalars['DateTime']['input']>;
  menu?: InputMaybe<Scalars['ObjectID']['input']>;
  options?: InputMaybe<Array<OptionGroupOptionInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOptionInput = {
  clone_from?: InputMaybe<Scalars['ObjectID']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  deleted_at?: InputMaybe<Scalars['DateTime']['input']>;
  is_template?: InputMaybe<Scalars['Boolean']['input']>;
  listed_price?: InputMaybe<Scalars['Float']['input']>;
  menu?: InputMaybe<Scalars['ObjectID']['input']>;
  option_id?: InputMaybe<Scalars['String']['input']>;
  original_price?: InputMaybe<Scalars['Float']['input']>;
  original_price_addons?: InputMaybe<OriginalPriceAddonsInput>;
  recipe?: InputMaybe<Array<RecipeRawMaterialUsedInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_localized?: InputMaybe<ItemLocalizedTextInput>;
};

export type UpdateOrderItemFieldPatchInput = {
  _id: Scalars['ObjectID']['input'];
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  delivered_count?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ORDER_ITEM_STATUS>;
};

export type UpdateOrderItemFieldsInput = {
  items: Array<UpdateOrderItemFieldPatchInput>;
};

export type UpdateOrderItemInput = {
  _id: Scalars['ObjectID']['input'];
  cancelled_amount: Scalars['Float']['input'];
  cancelled_reason?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['ObjectID']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  cost: Scalars['Float']['input'];
  course_index?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  delivered_count: Scalars['Int']['input'];
  extra_quantity: Scalars['Int']['input'];
  gross_amount: Scalars['Float']['input'];
  inventory_deduction_category?: InputMaybe<INVENTORY_DEDUCTION_CATEGORY>;
  is_hide_from_receipt: Scalars['Boolean']['input'];
  is_master?: InputMaybe<Scalars['Boolean']['input']>;
  is_open_item: Scalars['Boolean']['input'];
  is_paid: Scalars['Boolean']['input'];
  item: Scalars['ObjectID']['input'];
  item_id: Scalars['String']['input'];
  listed_price: Scalars['Float']['input'];
  master_parent?: InputMaybe<Scalars['ObjectID']['input']>;
  minimum_required_price: Scalars['Float']['input'];
  net_amount: Scalars['Float']['input'];
  no_service_charge: Scalars['Boolean']['input'];
  no_vat: Scalars['Boolean']['input'];
  non_sales_credit_amount?: InputMaybe<Scalars['Float']['input']>;
  options: Array<CreateOrderItemOptionInput>;
  original_price: Scalars['Float']['input'];
  original_price_addons: OriginalPriceAddonsInput;
  prep_time: Scalars['Float']['input'];
  printer_tag?: InputMaybe<Scalars['ObjectID']['input']>;
  quantity: Scalars['Int']['input'];
  recipe: Array<OrderRecipeRawMaterialUsedInput>;
  serving_quantity: Scalars['Int']['input'];
  status: ORDER_ITEM_STATUS;
  subtotal: Scalars['Float']['input'];
  subtotal_addons: SubtotalAddOnsInput;
  title: Scalars['String']['input'];
  title_localized?: InputMaybe<ItemLocalizedTextInput>;
  type: Scalars['String']['input'];
  unit_price: Scalars['Float']['input'];
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateOrderMetadataInput = {
  action_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ObjectID']['input']>;
  headcount?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePrintLogDiscountInput = {
  type: DISCOUNT_TYPE;
  value: Scalars['Float']['input'];
};

export type UpdatePrintLogInput = {
  action_id?: InputMaybe<Scalars['String']['input']>;
  adjustment_amount?: InputMaybe<Scalars['Float']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  discount?: InputMaybe<UpdatePrintLogDiscountInput>;
  location?: InputMaybe<Scalars['ObjectID']['input']>;
  offerId?: InputMaybe<Scalars['ObjectID']['input']>;
  payment_types?: InputMaybe<Array<UpdatePrintLogPaymentTypeInput>>;
  receipt_number?: InputMaybe<Scalars['String']['input']>;
  service_charge?: InputMaybe<Scalars['Float']['input']>;
  tips?: InputMaybe<Array<UpdatePrintLogTipInput>>;
  vat?: InputMaybe<Scalars['Float']['input']>;
  walletTransactionInput?: InputMaybe<UpdatePrintLogWalletTransactionInput>;
};

export type UpdatePrintLogPaymentTypeInput = {
  amount: Scalars['Float']['input'];
  code: Scalars['String']['input'];
  payment_type: Scalars['String']['input'];
};

export type UpdatePrintLogTipInput = {
  amount: Scalars['Float']['input'];
  code: Scalars['String']['input'];
  payment_type: Scalars['String']['input'];
};

export type UpdatePrintLogWalletTransactionInput = {
  amount: Scalars['Float']['input'];
  payment_type?: InputMaybe<Scalars['String']['input']>;
  wallet?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdateRawMaterialCategoryInput = {
  _id: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateRawMaterialInput = {
  _id: Scalars['ObjectID']['input'];
  category: Scalars['ObjectID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiration_notification_threshold: Scalars['Float']['input'];
  is_enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  raw_price: Scalars['Float']['input'];
  replenishment_tolerance: Scalars['Float']['input'];
  required_in_stock_amount: Scalars['Float']['input'];
  shelf_life: Scalars['Float']['input'];
  storage_location?: InputMaybe<Scalars['String']['input']>;
  supplier: Scalars['ObjectID']['input'];
  unit_of_measurement: Scalars['ObjectID']['input'];
};

export type UpdateRawMaterialReceivedInput = {
  _id: Scalars['ObjectID']['input'];
  adjustment_quantity: Scalars['Float']['input'];
  defect_quantity: Scalars['Float']['input'];
  expired_quantity: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  raw_material: Scalars['ObjectID']['input'];
  raw_price: Scalars['Float']['input'];
  received_unit_of_measurement: Scalars['String']['input'];
  starting_quantity?: InputMaybe<Scalars['Float']['input']>;
  supplier: Scalars['ObjectID']['input'];
  transaction_date?: InputMaybe<Scalars['DateTime']['input']>;
  transfer_out_quantity?: InputMaybe<Scalars['Float']['input']>;
  transfer_out_receiver?: InputMaybe<Scalars['ObjectID']['input']>;
  unit_of_measurement_metadata: RawMaterialUnitOfMeasurementInput;
  wastage_quantity: Scalars['Float']['input'];
};

export type UpdateRawMaterialReceiverInput = {
  _id: Scalars['ObjectID']['input'];
  code: Scalars['String']['input'];
  contact_person: Scalars['String']['input'];
  country_of_origin: Scalars['String']['input'];
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
};

export type UpdateRawMaterialStatusInput = {
  _id: Scalars['ObjectID']['input'];
  is_enabled: Scalars['Boolean']['input'];
};

export type UpdateRawMaterialSupplierInput = {
  _id: Scalars['ObjectID']['input'];
  code: Scalars['String']['input'];
  contact_person: Scalars['String']['input'];
  country_of_origin: Scalars['String']['input'];
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
};

export type UpdateRawMaterialUnitOfMeasurementInput = {
  _id: Scalars['ObjectID']['input'];
  sub_units: Array<RawMaterialUnitOfMeasurementSubUnitInput>;
  title: Scalars['String']['input'];
};

export type UpdateRoleInput = {
  _id: Scalars['ObjectID']['input'];
  permissions: Array<ROLE_PERMISSIONS>;
  type: ROLE_TYPE;
  username: Scalars['String']['input'];
};

export type UpdateUserInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  venue_issued_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVenueReceiptConfigInput = {
  current_date?: InputMaybe<Scalars['String']['input']>;
  current_date_internal?: InputMaybe<Scalars['String']['input']>;
  current_number?: InputMaybe<Scalars['Int']['input']>;
  current_number_internal?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  suffix_digit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VENUE_RECEIPT_CONFIG_TYPE>;
};

export type UpdateWalletInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UploadRawMaterialReceivedInput = {
  raw_material_balance: Array<RawMaterialBalanceInput>;
  raw_material_received: Array<CreateRawMaterialReceivedInput>;
};

export type VENUE_RECEIPT_CONFIG_TYPE =
  | 'CUSTOM'
  | 'DEFAULT';

export type VENUE_REPORTS_DISPLAY_FIGURE =
  | 'GROSS_SALES'
  | 'GROSS_SALES_AND_ROUNDING'
  | 'GROSS_SALES_AND_TIPS'
  | 'GROSS_SALES_AND_TIPS_AND_ROUNDING';

export type Venue = {
  _id: Scalars['ObjectID']['output'];
  _roles: Array<Role>;
  additional_digital_menu_languages: Array<DIGITAL_MENU_LANGUAGE>;
  address: Scalars['String']['output'];
  allow_add_items_to_paid_orders?: Maybe<Scalars['Boolean']['output']>;
  allow_comments: Scalars['Boolean']['output'];
  auto_print_checklist: Scalars['Boolean']['output'];
  available_printers: Array<VenueAvailablePrinter>;
  banner_img: Scalars['URL']['output'];
  bill_footer?: Maybe<Scalars['String']['output']>;
  cancelled_reason_options: Array<Scalars['String']['output']>;
  card_surcharge: Scalars['Float']['output'];
  cloudbeds_integration_info?: Maybe<CloudbedsIntegrationInfo>;
  created_at: Scalars['DateTime']['output'];
  currencies_configs: Array<VenueCurrenciesConfigs>;
  custom_note_instructions?: Maybe<Scalars['String']['output']>;
  custom_payment_types: Array<VenueCustomPaymentTypes>;
  custom_printing_fields: Array<VenueCustomPrintingField>;
  default_ops_page: OPS_PAGE;
  default_service_charge_type: DEFAULT_SERVICE_CHARGE_TYPE;
  description: Scalars['String']['output'];
  fcm_tokens: Array<Scalars['String']['output']>;
  inventory_start_date?: Maybe<Scalars['DateTime']['output']>;
  is_accounting_journal_enabled: Scalars['Boolean']['output'];
  is_cloudbeds_integration_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_cost_management_enabled: Scalars['Boolean']['output'];
  is_custom_report_enabled: Scalars['Boolean']['output'];
  is_customer_management_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_digital_menu_additional_language_enabled: Scalars['Boolean']['output'];
  is_digital_menu_user_login_enabled: Scalars['Boolean']['output'];
  is_digital_menu_user_sign_up_enabled: Scalars['Boolean']['output'];
  is_grouping_option_on_print_ticket: Scalars['Boolean']['output'];
  is_include_total_qty_in_receipt?: Maybe<Scalars['Boolean']['output']>;
  is_internal_receipt_enabled: Scalars['Boolean']['output'];
  is_inventory_management_enabled: Scalars['Boolean']['output'];
  is_item_tags_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_kds_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_kpay_integration_enabled: Scalars['Boolean']['output'];
  is_language_localization_enabled: Scalars['Boolean']['output'];
  is_location_lock_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_offers_crud_for_super_admin_only?: Maybe<Scalars['Boolean']['output']>;
  is_offline_mode_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_ordering_requires_customer: Scalars['Boolean']['output'];
  is_ordering_requires_headcount: Scalars['Boolean']['output'];
  is_ordering_requires_note: Scalars['Boolean']['output'];
  is_ordering_requires_staff_accept?: Maybe<Scalars['Boolean']['output']>;
  is_payment_confirmation_enabled: Scalars['Boolean']['output'];
  is_payment_rounding_enabled: Scalars['Boolean']['output'];
  is_payway_integration_enabled: Scalars['Boolean']['output'];
  is_print_ticket_by_item: Scalars['Boolean']['output'];
  is_print_ticket_by_option: Scalars['Boolean']['output'];
  is_qr_ordering_only: Scalars['Boolean']['output'];
  is_report_tags_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_reports_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_required_headcount_before_payment: Scalars['Boolean']['output'];
  is_reservation_management_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_room_master_integration_enabled: Scalars['Boolean']['output'];
  is_self_served: Scalars['Boolean']['output'];
  is_service_charge_bd_buried?: Maybe<Scalars['Boolean']['output']>;
  is_service_charge_buried: Scalars['Boolean']['output'];
  is_till_send_and_pay_enabled: Scalars['Boolean']['output'];
  is_till_send_enabled: Scalars['Boolean']['output'];
  is_vat_buried: Scalars['Boolean']['output'];
  is_wallet_management_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_work_ticket_remove_order_number: Scalars['Boolean']['output'];
  is_work_ticket_remove_price: Scalars['Boolean']['output'];
  item_types: Array<Scalars['String']['output']>;
  logo: Scalars['URL']['output'];
  name: Scalars['String']['output'];
  only_one_order_per_location?: Maybe<Scalars['Boolean']['output']>;
  operational_data_refetch_interval: Scalars['Int']['output'];
  ops_page_font_size: Scalars['Float']['output'];
  order_notification_dings: Scalars['Int']['output'];
  preset_messages: Array<Scalars['String']['output']>;
  print_content_padding: Array<Scalars['Float']['output']>;
  print_font_sizes: VenuePrintFontSizes;
  receipt_config: VenueReceiptConfig;
  reports_availability_windows?: Maybe<Array<ReportsAvailabilityWindows>>;
  reports_display_figure: VENUE_REPORTS_DISPLAY_FIGURE;
  room_master_property_id?: Maybe<Scalars['String']['output']>;
  service_charge: Scalars['Float']['output'];
  service_charge_bd?: Maybe<Scalars['Float']['output']>;
  shifts: Array<VenueShifts>;
  should_clear_location_after_payment?: Maybe<Scalars['Boolean']['output']>;
  stations: Array<VenueStation>;
  tax?: Maybe<Scalars['Float']['output']>;
  theme: VenueTheme;
  timezone: Scalars['TimeZone']['output'];
  updated_at: Scalars['DateTime']['output'];
  user_limit: Scalars['Int']['output'];
  vat: Scalars['Float']['output'];
  vat_tin?: Maybe<Scalars['String']['output']>;
  wallet_payment_labels?: Maybe<Array<Scalars['String']['output']>>;
};

export type VenueAvailablePrinter = {
  name: Scalars['String']['output'];
};

export type VenueCurrenciesConfigs = {
  code: Scalars['String']['output'];
  is_deactivated: Scalars['Boolean']['output'];
  is_primary_currency: Scalars['Boolean']['output'];
  is_secondary_currency: Scalars['Boolean']['output'];
  previous_rate?: Maybe<Scalars['Float']['output']>;
  rate: Scalars['Float']['output'];
};

export type VenueCustomPaymentTypes = {
  is_deactivated: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VenueCustomPrintingField = {
  label: Scalars['String']['output'];
};

export type VenueEvent = {
  id: Scalars['ObjectID']['output'];
  payload?: Maybe<Venue>;
  type: DATA_EVENT_TYPE;
};

export type VenuePrintFontSizes = {
  receipt: Scalars['Float']['output'];
  reports: Scalars['Float']['output'];
  ticket: Scalars['Float']['output'];
};

export type VenuePrinter = {
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  available_printers: Array<VenueAvailablePrinter>;
  created_at: Scalars['DateTime']['output'];
  stations: Array<VenueStation>;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type VenueReceiptConfig = {
  _id: Scalars['ObjectID']['output'];
  created_at: Scalars['DateTime']['output'];
  /** formatted as `YYMMDD`, used for DEFAULT type, resets daily */
  current_date?: Maybe<Scalars['String']['output']>;
  /** formatted as `YYMMDD`, used for DEFAULT type, resets daily */
  current_date_internal?: Maybe<Scalars['String']['output']>;
  current_number: Scalars['Int']['output'];
  current_number_internal: Scalars['Int']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  suffix_digit?: Maybe<Scalars['Int']['output']>;
  type: VENUE_RECEIPT_CONFIG_TYPE;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type VenueShifts = {
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type VenueStation = {
  _id: Scalars['ObjectID']['output'];
  _printer_tags_of_interest: Array<Tag>;
  is_cashdrawer_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_group_printer_tags_on_one_ticket?: Maybe<Scalars['Boolean']['output']>;
  locations_of_interest: Array<Scalars['String']['output']>;
  printer_name: Scalars['String']['output'];
  printer_tags_of_interest: Array<Scalars['ObjectID']['output']>;
  station_name: Scalars['String']['output'];
  types_of_interest: Array<Scalars['String']['output']>;
};

export type VenueTheme = {
  primary_color: Scalars['HexColorCode']['output'];
  primary_text_color: Scalars['HexColorCode']['output'];
};

export type VoidReceiptResult = {
  cloudbedsError?: Maybe<Scalars['String']['output']>;
  printLog: PrintLog;
  roomMasterError?: Maybe<Scalars['String']['output']>;
};

export type VoidsDetailsPerItem = {
  cancelled_at: Scalars['DateTime']['output'];
  cancelled_by_name?: Maybe<Scalars['String']['output']>;
  category_title?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  digital_payment_ref?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is_paid: Scalars['Boolean']['output'];
  item_id: Scalars['String']['output'];
  item_title: Scalars['String']['output'];
  item_type: Scalars['String']['output'];
  location_name: Scalars['String']['output'];
  location_room_number?: Maybe<Scalars['String']['output']>;
  locations_groups_tags: Array<Scalars['ObjectID']['output']>;
  master_item_title?: Maybe<Scalars['String']['output']>;
  order_index: Scalars['Int']['output'];
  order_source: Scalars['String']['output'];
  payment_types: Array<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  receipt_number?: Maybe<Scalars['String']['output']>;
  shift?: Maybe<Scalars['String']['output']>;
  status: ORDER_STATUS;
  unit_price: Scalars['Float']['output'];
  void_amount: Scalars['Float']['output'];
  void_reason?: Maybe<Scalars['String']['output']>;
  wallet_name?: Maybe<Scalars['String']['output']>;
  wallet_payment_type?: Maybe<Scalars['String']['output']>;
};

export type VoidsSummary = {
  voidedAmount: Scalars['Float']['output'];
  voidedCount: Scalars['Float']['output'];
};

export type WALLET_TRANSACTION_TYPE =
  | 'credit'
  | 'debit'
  | 'refund'
  | 'void';

export type Wallet = {
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  balance: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  is_sales_credit: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
};

export type WalletTransaction = {
  _id: Scalars['ObjectID']['output'];
  _venue: Venue;
  _wallet: Wallet;
  amount: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  ending_balance: Scalars['Float']['output'];
  payment_type?: Maybe<Scalars['String']['output']>;
  starting_balance: Scalars['Float']['output'];
  type: WALLET_TRANSACTION_TYPE;
  updated_at: Scalars['DateTime']['output'];
  venue: Scalars['ObjectID']['output'];
  wallet: Scalars['ObjectID']['output'];
};

export type WalletTransactionInput = {
  amount: Scalars['Float']['input'];
  payment_type: Scalars['String']['input'];
  wallet: Scalars['ObjectID']['input'];
};

export type UpdateCurrentDeviceMutationVariables = Exact<{
  input: UpdateCurrentDeviceInput;
}>;


export type UpdateCurrentDeviceMutation = { updateCurrentDevice: { _id: string } };

export type CategoryFragmentFragment = { _id: string, created_at: string, updated_at: string, title: string, is_template: boolean, clone_from?: string | null, ordering_index: number, _qr_items_count: number, title_localized?: { cn?: string | null, kh?: string | null } | null, availability?: { days?: Array<number> | null, times?: Array<{ from: string, to: string }> | null } | null };

export type DeviceFragmentFragment = { _id: string, created_at: string, updated_at: string, fcm_tokens: Array<string>, _active_orders: Array<{ _id: string, created_at: string, updated_at: string, index?: number | null, prepared_at?: string | null, processed_at?: string | null, paid_at?: string | null, cancelled_at?: string | null, customer?: string | null, venue: string, status: ORDER_STATUS, is_paid: boolean, staff?: string | null, original_orders: Array<string>, cancelled_reason?: string | null, source: ORDER_SOURCE, device?: string | null, prep_time: number, currencies_configs: Record<string, unknown>, location: string, current_location?: string | null, max_prepare_time: number, items_count: number, items_count_by_types?: Record<string, unknown> | null, prepped_count: number, subtotal: number, offer_amount: number, discount_amount: number, net_amount: number, vat_amount: number, service_charge_amount: number, service_charge_bd_amount?: number | null, adjustment_amount: number, grand_total: number, gross_amount: number, cancelled_amount: number, receipt?: string | null, is_needing_prep_time_confirmation: boolean, is_needing_prep_time_acknowledgement?: boolean | null, note?: string | null, is_cancelled: boolean, is_bill_printed: boolean, is_needing_payment_confirmation: boolean, is_request_payment_confirmation: boolean, _location: { _id: string, name: string } }> };

export type ItemFragmentFragment = { _id: string, created_at: string, updated_at: string, item_id: string, cost: number, title: string, description?: string | null, banner_img?: string | null, is_qr_enabled: boolean, is_pos_enabled: boolean, no_vat: boolean, no_service_charge: boolean, is_open_item: boolean, is_hide_from_receipt: boolean, type: string, prep_time: number, is_template: boolean, clone_from?: string | null, ordering_index: number, extra_quantity: number, printer_tag?: string | null, original_price: number, minimum_required_price: number, listed_price: number, category: string, menu: string, venue: string, is_master?: boolean | null, master_items?: Array<string> | null, item_tags?: Array<string> | null, is_quantity_controlled?: boolean | null, controlled_quantity?: number | null, till_card_color?: string | null, title_localized?: { cn?: string | null, kh?: string | null } | null, description_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }>, options: Array<{ ordering_index: number, is_hide_from_receipt: boolean, _option: { _id: string, created_at: string, updated_at: string, option_id: string, cost: number, title: string, is_template: boolean, clone_from?: string | null, original_price: number, listed_price: number, menu: string, venue: string, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }> } }>, option_groups: Array<{ is_required: boolean, minimum_select: number, maximum_select: number, ordering_index: number, options: Array<{ ordering_index: number, is_auto_select: boolean, is_hide_from_receipt: boolean, _option: { _id: string, created_at: string, updated_at: string, option_id: string, cost: number, title: string, is_template: boolean, clone_from?: string | null, original_price: number, listed_price: number, menu: string, venue: string, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }> } }>, _option_group: { _id: string, title: string, clone_from?: string | null, options: Array<{ ordering_index: number, _option: { _id: string, created_at: string, updated_at: string, option_id: string, cost: number, title: string, is_template: boolean, clone_from?: string | null, original_price: number, listed_price: number, menu: string, venue: string, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }> } }> } }>, availability?: { days?: Array<number> | null, times?: Array<{ from: string, to: string }> | null } | null };

export type LocationSubscriptionSummaryFragment = { _id: string, updated_at: string, no_vat: boolean, no_service_charge: boolean };

export type LocationFragmentFragment = { _id: string, created_at: string, updated_at: string, venue: string, name: string, type: LOCATION_TYPE, payment_types: Array<string>, status: LOCATION_STATUS, hash: string, no_vat: boolean, no_service_charge: boolean, is_pay_later_allowed: boolean, is_pay_now_allowed: boolean, locations_groups_tags: Array<string>, room_number?: string | null, default_order_note?: string | null, hidden_items_configs: { items: Array<string>, item_types: Array<string>, categories: Array<string>, is_items_hide_on_qr: boolean, is_categories_hide_on_qr: boolean, is_item_types_hide_on_qr: boolean } };

export type MenuFragmentFragment = { _id: string, created_at: string, updated_at: string, name: string, description?: string | null, banner_img?: string | null };

export type OrderSubscriptionSummaryFragment = { _id: string, device?: string | null, location: string, updated_at: string, index?: number | null, status: ORDER_STATUS, prep_time: number, is_paid: boolean, is_cancelled: boolean, is_needing_payment_confirmation: boolean, is_request_payment_confirmation: boolean, is_needing_prep_time_confirmation: boolean, is_needing_prep_time_acknowledgement?: boolean | null };

export type OrderFragmentFragment = { _id: string, created_at: string, updated_at: string, index?: number | null, prepared_at?: string | null, processed_at?: string | null, paid_at?: string | null, cancelled_at?: string | null, prepared_by?: string | null, processed_by?: string | null, paid_by?: string | null, cancelled_by?: string | null, customer?: string | null, venue: string, status: ORDER_STATUS, is_paid: boolean, staff?: string | null, original_orders: Array<string>, cancelled_reason?: string | null, source: ORDER_SOURCE, device?: string | null, prep_time: number, currencies_configs: Record<string, unknown>, location: string, current_location?: string | null, max_prepare_time: number, items_count: number, items_count_by_types?: Record<string, unknown> | null, prepped_count: number, subtotal: number, offer_amount: number, discount_amount: number, net_amount: number, vat_amount: number, service_charge_amount: number, service_charge_bd_amount?: number | null, tax_amount?: number | null, adjustment_amount: number, grand_total: number, gross_amount: number, cancelled_amount: number, receipt?: string | null, is_needing_prep_time_confirmation: boolean, is_needing_prep_time_acknowledgement?: boolean | null, note?: string | null, is_cancelled: boolean, is_bill_printed: boolean, is_needing_payment_confirmation: boolean, is_request_payment_confirmation: boolean, items: Array<{ _id: string, category: string, item: string, item_id: string, cost: number, title: string, original_price: number, minimum_required_price: number, unit_price: number, listed_price: number, quantity: number, extra_quantity: number, serving_quantity: number, comments?: string | null, cancelled_reason?: string | null, type: string, delivered_count: number, status: ORDER_ITEM_STATUS, prep_time: number, printer_tag?: string | null, subtotal: number, net_amount: number, gross_amount: number, cancelled_amount: number, no_vat: boolean, no_service_charge: boolean, is_open_item: boolean, is_hide_from_receipt: boolean, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }>, options: Array<{ _id: string, option: string, option_id: string, quantity: number, serving_quantity: number, cost: number, uid: string, title: string, original_price: number, listed_price: number, subtotal: number, is_hide_from_receipt: boolean, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number } }, subtotal_addons: { offer: { metadata?: Record<string, unknown> | null, amount: number }, discount: { is_divided: boolean, type: DISCOUNT_TYPE, value: number, amount: number }, vat: { is_included: boolean, percentage: number, amount: number }, service_charge: { is_included: boolean, percentage: number, amount: number }, service_charge_bd?: { is_included: boolean, percentage: number, amount: number } | null, adjustment: { amount: number }, tax?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }> }>, subtotal_addons: { offer: { metadata?: Record<string, unknown> | null, amount: number }, discount: { is_divided: boolean, type: DISCOUNT_TYPE, value: number, amount: number }, vat: { is_included: boolean, percentage: number, amount: number }, service_charge: { is_included: boolean, percentage: number, amount: number }, service_charge_bd?: { is_included: boolean, percentage: number, amount: number } | null, adjustment: { amount: number }, tax?: { percentage: number, amount: number } | null } }>, _location: { _id: string, name: string, type: LOCATION_TYPE, hash: string }, _customer?: { _id: string, first_name: string, last_name: string } | null, _receipt?: { _id: string, created_at: string, updated_at: string, payment_types: Array<{ payment_type: string, code: string, amount: number }> } | null };

export type VenueSubscriptionSummaryFragment = { _id: string, updated_at: string, vat: number, service_charge: number, service_charge_bd?: number | null, default_service_charge_type: DEFAULT_SERVICE_CHARGE_TYPE, tax?: number | null };

export type VenueFragmentFragment = { _id: string, created_at: string, updated_at: string, name: string, description: string, address: string, timezone: string, logo: string, banner_img: string, is_self_served: boolean, allow_comments: boolean, item_types: Array<string>, cancelled_reason_options: Array<string>, auto_print_checklist: boolean, fcm_tokens: Array<string>, is_service_charge_buried: boolean, service_charge: number, service_charge_bd?: number | null, is_service_charge_bd_buried?: boolean | null, is_vat_buried: boolean, vat: number, is_digital_menu_user_login_enabled: boolean, is_digital_menu_user_sign_up_enabled: boolean, is_ordering_requires_customer: boolean, is_qr_ordering_only: boolean, default_service_charge_type: DEFAULT_SERVICE_CHARGE_TYPE, custom_note_instructions?: string | null, is_ordering_requires_note: boolean, order_notification_dings: number, is_payway_integration_enabled: boolean, is_internal_receipt_enabled: boolean, is_language_localization_enabled: boolean, is_digital_menu_additional_language_enabled: boolean, additional_digital_menu_languages: Array<DIGITAL_MENU_LANGUAGE>, is_required_headcount_before_payment: boolean, is_payment_confirmation_enabled: boolean, is_payment_rounding_enabled: boolean, user_limit: number, tax?: number | null, custom_payment_types: Array<{ label: string, value: string, is_deactivated: boolean }>, shifts: Array<{ title: string, startTime: string, endTime: string }>, currencies_configs: Array<{ code: string, rate: number, previous_rate?: number | null, is_primary_currency: boolean, is_secondary_currency: boolean, is_deactivated: boolean }>, theme: { primary_color: string, primary_text_color: string } };

export type CheckoutWithPayWayMutationVariables = Exact<{
  input: CheckoutWithPayWayInput;
}>;


export type CheckoutWithPayWayMutation = { checkoutWithPayWay: { qr_string?: string | null, checkout_qr_url?: string | null, abapay_deeplink?: string | null, payway_ref: string } };

export type GetCurrentCustomerOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCustomerOrdersQuery = { getCurrentCustomerOrders: Array<{ _id: string, created_at: string, updated_at: string, index?: number | null, prepared_at?: string | null, processed_at?: string | null, paid_at?: string | null, cancelled_at?: string | null, prepared_by?: string | null, processed_by?: string | null, paid_by?: string | null, cancelled_by?: string | null, customer?: string | null, venue: string, status: ORDER_STATUS, is_paid: boolean, staff?: string | null, original_orders: Array<string>, cancelled_reason?: string | null, source: ORDER_SOURCE, device?: string | null, prep_time: number, currencies_configs: Record<string, unknown>, location: string, current_location?: string | null, max_prepare_time: number, items_count: number, items_count_by_types?: Record<string, unknown> | null, prepped_count: number, subtotal: number, offer_amount: number, discount_amount: number, net_amount: number, vat_amount: number, service_charge_amount: number, service_charge_bd_amount?: number | null, tax_amount?: number | null, adjustment_amount: number, grand_total: number, gross_amount: number, cancelled_amount: number, receipt?: string | null, is_needing_prep_time_confirmation: boolean, is_needing_prep_time_acknowledgement?: boolean | null, note?: string | null, is_cancelled: boolean, is_bill_printed: boolean, is_needing_payment_confirmation: boolean, is_request_payment_confirmation: boolean, items: Array<{ _id: string, category: string, item: string, item_id: string, cost: number, title: string, original_price: number, minimum_required_price: number, unit_price: number, listed_price: number, quantity: number, extra_quantity: number, serving_quantity: number, comments?: string | null, cancelled_reason?: string | null, type: string, delivered_count: number, status: ORDER_ITEM_STATUS, prep_time: number, printer_tag?: string | null, subtotal: number, net_amount: number, gross_amount: number, cancelled_amount: number, no_vat: boolean, no_service_charge: boolean, is_open_item: boolean, is_hide_from_receipt: boolean, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }>, options: Array<{ _id: string, option: string, option_id: string, quantity: number, serving_quantity: number, cost: number, uid: string, title: string, original_price: number, listed_price: number, subtotal: number, is_hide_from_receipt: boolean, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number } }, subtotal_addons: { offer: { metadata?: Record<string, unknown> | null, amount: number }, discount: { is_divided: boolean, type: DISCOUNT_TYPE, value: number, amount: number }, vat: { is_included: boolean, percentage: number, amount: number }, service_charge: { is_included: boolean, percentage: number, amount: number }, service_charge_bd?: { is_included: boolean, percentage: number, amount: number } | null, adjustment: { amount: number }, tax?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }> }>, subtotal_addons: { offer: { metadata?: Record<string, unknown> | null, amount: number }, discount: { is_divided: boolean, type: DISCOUNT_TYPE, value: number, amount: number }, vat: { is_included: boolean, percentage: number, amount: number }, service_charge: { is_included: boolean, percentage: number, amount: number }, service_charge_bd?: { is_included: boolean, percentage: number, amount: number } | null, adjustment: { amount: number }, tax?: { percentage: number, amount: number } | null } }>, _location: { _id: string, name: string, type: LOCATION_TYPE, hash: string }, _customer?: { _id: string, first_name: string, last_name: string } | null, _receipt?: { _id: string, created_at: string, updated_at: string, payment_types: Array<{ payment_type: string, code: string, amount: number }> } | null }> };

export type GetCurrentCustomerQrCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCustomerQrCodeQuery = { getCurrentCustomerQrCode: { token: string, image: string, expires_at: string } };

export type CustomerSessionFragmentFragment = { _id: string, first_name: string, last_name: string, email?: string | null, phone_number?: string | null, username?: string | null };

export type GetCurrentCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCustomerQuery = { getCurrentCustomer?: { _id: string, first_name: string, last_name: string, email?: string | null, phone_number?: string | null, username?: string | null } | null };

export type CustomerLoginMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type CustomerLoginMutation = { customerLogin: { token: string, customer: { _id: string, first_name: string, last_name: string, email?: string | null, phone_number?: string | null, username?: string | null } } };

export type CustomerSignUpMutationVariables = Exact<{
  input: CustomerSignUpInput;
}>;


export type CustomerSignUpMutation = { customerSignUp: { token: string, customer: { _id: string, first_name: string, last_name: string, email?: string | null, phone_number?: string | null, username?: string | null } } };

export type GetActiveMenuCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveMenuCategoriesQuery = { getActiveMenuCategories: Array<{ _id: string, created_at: string, updated_at: string, title: string, is_template: boolean, clone_from?: string | null, ordering_index: number, _qr_items_count: number, title_localized?: { cn?: string | null, kh?: string | null } | null, availability?: { days?: Array<number> | null, times?: Array<{ from: string, to: string }> | null } | null }> };

export type GetActiveMenuItemQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type GetActiveMenuItemQuery = { getActiveMenuItem: { _id: string, created_at: string, updated_at: string, item_id: string, cost: number, title: string, description?: string | null, banner_img?: string | null, is_qr_enabled: boolean, is_pos_enabled: boolean, no_vat: boolean, no_service_charge: boolean, is_open_item: boolean, is_hide_from_receipt: boolean, type: string, prep_time: number, is_template: boolean, clone_from?: string | null, ordering_index: number, extra_quantity: number, printer_tag?: string | null, original_price: number, minimum_required_price: number, listed_price: number, category: string, menu: string, venue: string, is_master?: boolean | null, master_items?: Array<string> | null, item_tags?: Array<string> | null, is_quantity_controlled?: boolean | null, controlled_quantity?: number | null, till_card_color?: string | null, title_localized?: { cn?: string | null, kh?: string | null } | null, description_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }>, options: Array<{ ordering_index: number, is_hide_from_receipt: boolean, _option: { _id: string, created_at: string, updated_at: string, option_id: string, cost: number, title: string, is_template: boolean, clone_from?: string | null, original_price: number, listed_price: number, menu: string, venue: string, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }> } }>, option_groups: Array<{ is_required: boolean, minimum_select: number, maximum_select: number, ordering_index: number, options: Array<{ ordering_index: number, is_auto_select: boolean, is_hide_from_receipt: boolean, _option: { _id: string, created_at: string, updated_at: string, option_id: string, cost: number, title: string, is_template: boolean, clone_from?: string | null, original_price: number, listed_price: number, menu: string, venue: string, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }> } }>, _option_group: { _id: string, title: string, clone_from?: string | null, options: Array<{ ordering_index: number, _option: { _id: string, created_at: string, updated_at: string, option_id: string, cost: number, title: string, is_template: boolean, clone_from?: string | null, original_price: number, listed_price: number, menu: string, venue: string, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }> } }> } }>, availability?: { days?: Array<number> | null, times?: Array<{ from: string, to: string }> | null } | null } };

export type GetActiveMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveMenuQuery = { getActiveMenu: { _id: string, created_at: string, updated_at: string, name: string, description?: string | null, banner_img?: string | null } };

export type GetCurrentDeviceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentDeviceQuery = { getCurrentDevice: { _id: string, created_at: string, updated_at: string, fcm_tokens: Array<string>, _active_orders: Array<{ _id: string, created_at: string, updated_at: string, index?: number | null, prepared_at?: string | null, processed_at?: string | null, paid_at?: string | null, cancelled_at?: string | null, customer?: string | null, venue: string, status: ORDER_STATUS, is_paid: boolean, staff?: string | null, original_orders: Array<string>, cancelled_reason?: string | null, source: ORDER_SOURCE, device?: string | null, prep_time: number, currencies_configs: Record<string, unknown>, location: string, current_location?: string | null, max_prepare_time: number, items_count: number, items_count_by_types?: Record<string, unknown> | null, prepped_count: number, subtotal: number, offer_amount: number, discount_amount: number, net_amount: number, vat_amount: number, service_charge_amount: number, service_charge_bd_amount?: number | null, adjustment_amount: number, grand_total: number, gross_amount: number, cancelled_amount: number, receipt?: string | null, is_needing_prep_time_confirmation: boolean, is_needing_prep_time_acknowledgement?: boolean | null, note?: string | null, is_cancelled: boolean, is_bill_printed: boolean, is_needing_payment_confirmation: boolean, is_request_payment_confirmation: boolean, _location: { _id: string, name: string } }> } };

export type CreateNewDeviceMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateNewDeviceMutation = { createNewDevice: { _id: string, created_at: string, updated_at: string, fcm_tokens: Array<string>, _active_orders: Array<{ _id: string, created_at: string, updated_at: string, index?: number | null, prepared_at?: string | null, processed_at?: string | null, paid_at?: string | null, cancelled_at?: string | null, customer?: string | null, venue: string, status: ORDER_STATUS, is_paid: boolean, staff?: string | null, original_orders: Array<string>, cancelled_reason?: string | null, source: ORDER_SOURCE, device?: string | null, prep_time: number, currencies_configs: Record<string, unknown>, location: string, current_location?: string | null, max_prepare_time: number, items_count: number, items_count_by_types?: Record<string, unknown> | null, prepped_count: number, subtotal: number, offer_amount: number, discount_amount: number, net_amount: number, vat_amount: number, service_charge_amount: number, service_charge_bd_amount?: number | null, adjustment_amount: number, grand_total: number, gross_amount: number, cancelled_amount: number, receipt?: string | null, is_needing_prep_time_confirmation: boolean, is_needing_prep_time_acknowledgement?: boolean | null, note?: string | null, is_cancelled: boolean, is_bill_printed: boolean, is_needing_payment_confirmation: boolean, is_request_payment_confirmation: boolean, _location: { _id: string, name: string } }> } };

export type GetCurrentLocationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentLocationQuery = { getCurrentLocation: { _id: string, created_at: string, updated_at: string, venue: string, name: string, type: LOCATION_TYPE, payment_types: Array<string>, status: LOCATION_STATUS, hash: string, no_vat: boolean, no_service_charge: boolean, is_pay_later_allowed: boolean, is_pay_now_allowed: boolean, locations_groups_tags: Array<string>, room_number?: string | null, default_order_note?: string | null, hidden_items_configs: { items: Array<string>, item_types: Array<string>, categories: Array<string>, is_items_hide_on_qr: boolean, is_categories_hide_on_qr: boolean, is_item_types_hide_on_qr: boolean } } };

export type GetCurrentVenueQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentVenueQuery = { getCurrentVenue: { _id: string, created_at: string, updated_at: string, name: string, description: string, address: string, timezone: string, logo: string, banner_img: string, is_self_served: boolean, allow_comments: boolean, item_types: Array<string>, cancelled_reason_options: Array<string>, auto_print_checklist: boolean, fcm_tokens: Array<string>, is_service_charge_buried: boolean, service_charge: number, service_charge_bd?: number | null, is_service_charge_bd_buried?: boolean | null, is_vat_buried: boolean, vat: number, is_digital_menu_user_login_enabled: boolean, is_digital_menu_user_sign_up_enabled: boolean, is_ordering_requires_customer: boolean, is_qr_ordering_only: boolean, default_service_charge_type: DEFAULT_SERVICE_CHARGE_TYPE, custom_note_instructions?: string | null, is_ordering_requires_note: boolean, order_notification_dings: number, is_payway_integration_enabled: boolean, is_internal_receipt_enabled: boolean, is_language_localization_enabled: boolean, is_digital_menu_additional_language_enabled: boolean, additional_digital_menu_languages: Array<DIGITAL_MENU_LANGUAGE>, is_required_headcount_before_payment: boolean, is_payment_confirmation_enabled: boolean, is_payment_rounding_enabled: boolean, user_limit: number, tax?: number | null, custom_payment_types: Array<{ label: string, value: string, is_deactivated: boolean }>, shifts: Array<{ title: string, startTime: string, endTime: string }>, currencies_configs: Array<{ code: string, rate: number, previous_rate?: number | null, is_primary_currency: boolean, is_secondary_currency: boolean, is_deactivated: boolean }>, theme: { primary_color: string, primary_text_color: string } } };

export type GetMaintenanceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaintenanceStatusQuery = { getMaintenanceStatus: { enabled: boolean, message?: string | null } };

export type GetOrderByPayWayRefQueryVariables = Exact<{
  ref: Scalars['String']['input'];
}>;


export type GetOrderByPayWayRefQuery = { getOrderByPayWayRef: { _id: string, created_at: string, updated_at: string, index?: number | null, prepared_at?: string | null, processed_at?: string | null, paid_at?: string | null, cancelled_at?: string | null, prepared_by?: string | null, processed_by?: string | null, paid_by?: string | null, cancelled_by?: string | null, customer?: string | null, venue: string, status: ORDER_STATUS, is_paid: boolean, staff?: string | null, original_orders: Array<string>, cancelled_reason?: string | null, source: ORDER_SOURCE, device?: string | null, prep_time: number, currencies_configs: Record<string, unknown>, location: string, current_location?: string | null, max_prepare_time: number, items_count: number, items_count_by_types?: Record<string, unknown> | null, prepped_count: number, subtotal: number, offer_amount: number, discount_amount: number, net_amount: number, vat_amount: number, service_charge_amount: number, service_charge_bd_amount?: number | null, tax_amount?: number | null, adjustment_amount: number, grand_total: number, gross_amount: number, cancelled_amount: number, receipt?: string | null, is_needing_prep_time_confirmation: boolean, is_needing_prep_time_acknowledgement?: boolean | null, note?: string | null, is_cancelled: boolean, is_bill_printed: boolean, is_needing_payment_confirmation: boolean, is_request_payment_confirmation: boolean, items: Array<{ _id: string, category: string, item: string, item_id: string, cost: number, title: string, original_price: number, minimum_required_price: number, unit_price: number, listed_price: number, quantity: number, extra_quantity: number, serving_quantity: number, comments?: string | null, cancelled_reason?: string | null, type: string, delivered_count: number, status: ORDER_ITEM_STATUS, prep_time: number, printer_tag?: string | null, subtotal: number, net_amount: number, gross_amount: number, cancelled_amount: number, no_vat: boolean, no_service_charge: boolean, is_open_item: boolean, is_hide_from_receipt: boolean, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }>, options: Array<{ _id: string, option: string, option_id: string, quantity: number, serving_quantity: number, cost: number, uid: string, title: string, original_price: number, listed_price: number, subtotal: number, is_hide_from_receipt: boolean, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number } }, subtotal_addons: { offer: { metadata?: Record<string, unknown> | null, amount: number }, discount: { is_divided: boolean, type: DISCOUNT_TYPE, value: number, amount: number }, vat: { is_included: boolean, percentage: number, amount: number }, service_charge: { is_included: boolean, percentage: number, amount: number }, service_charge_bd?: { is_included: boolean, percentage: number, amount: number } | null, adjustment: { amount: number }, tax?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }> }>, subtotal_addons: { offer: { metadata?: Record<string, unknown> | null, amount: number }, discount: { is_divided: boolean, type: DISCOUNT_TYPE, value: number, amount: number }, vat: { is_included: boolean, percentage: number, amount: number }, service_charge: { is_included: boolean, percentage: number, amount: number }, service_charge_bd?: { is_included: boolean, percentage: number, amount: number } | null, adjustment: { amount: number }, tax?: { percentage: number, amount: number } | null } }>, _location: { _id: string, name: string, type: LOCATION_TYPE, hash: string }, _customer?: { _id: string, first_name: string, last_name: string } | null, _receipt?: { _id: string, created_at: string, updated_at: string, payment_types: Array<{ payment_type: string, code: string, amount: number }> } | null } };

export type GetOrderByIdQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type GetOrderByIdQuery = { getOrderById: { _id: string, created_at: string, updated_at: string, index?: number | null, prepared_at?: string | null, processed_at?: string | null, paid_at?: string | null, cancelled_at?: string | null, prepared_by?: string | null, processed_by?: string | null, paid_by?: string | null, cancelled_by?: string | null, customer?: string | null, venue: string, status: ORDER_STATUS, is_paid: boolean, staff?: string | null, original_orders: Array<string>, cancelled_reason?: string | null, source: ORDER_SOURCE, device?: string | null, prep_time: number, currencies_configs: Record<string, unknown>, location: string, current_location?: string | null, max_prepare_time: number, items_count: number, items_count_by_types?: Record<string, unknown> | null, prepped_count: number, subtotal: number, offer_amount: number, discount_amount: number, net_amount: number, vat_amount: number, service_charge_amount: number, service_charge_bd_amount?: number | null, tax_amount?: number | null, adjustment_amount: number, grand_total: number, gross_amount: number, cancelled_amount: number, receipt?: string | null, is_needing_prep_time_confirmation: boolean, is_needing_prep_time_acknowledgement?: boolean | null, note?: string | null, is_cancelled: boolean, is_bill_printed: boolean, is_needing_payment_confirmation: boolean, is_request_payment_confirmation: boolean, items: Array<{ _id: string, category: string, item: string, item_id: string, cost: number, title: string, original_price: number, minimum_required_price: number, unit_price: number, listed_price: number, quantity: number, extra_quantity: number, serving_quantity: number, comments?: string | null, cancelled_reason?: string | null, type: string, delivered_count: number, status: ORDER_ITEM_STATUS, prep_time: number, printer_tag?: string | null, subtotal: number, net_amount: number, gross_amount: number, cancelled_amount: number, no_vat: boolean, no_service_charge: boolean, is_open_item: boolean, is_hide_from_receipt: boolean, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }>, options: Array<{ _id: string, option: string, option_id: string, quantity: number, serving_quantity: number, cost: number, uid: string, title: string, original_price: number, listed_price: number, subtotal: number, is_hide_from_receipt: boolean, title_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number } }, subtotal_addons: { offer: { metadata?: Record<string, unknown> | null, amount: number }, discount: { is_divided: boolean, type: DISCOUNT_TYPE, value: number, amount: number }, vat: { is_included: boolean, percentage: number, amount: number }, service_charge: { is_included: boolean, percentage: number, amount: number }, service_charge_bd?: { is_included: boolean, percentage: number, amount: number } | null, adjustment: { amount: number }, tax?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }> }>, subtotal_addons: { offer: { metadata?: Record<string, unknown> | null, amount: number }, discount: { is_divided: boolean, type: DISCOUNT_TYPE, value: number, amount: number }, vat: { is_included: boolean, percentage: number, amount: number }, service_charge: { is_included: boolean, percentage: number, amount: number }, service_charge_bd?: { is_included: boolean, percentage: number, amount: number } | null, adjustment: { amount: number }, tax?: { percentage: number, amount: number } | null } }>, _location: { _id: string, name: string, type: LOCATION_TYPE, hash: string }, _customer?: { _id: string, first_name: string, last_name: string } | null, _receipt?: { _id: string, created_at: string, updated_at: string, payment_types: Array<{ payment_type: string, code: string, amount: number }> } | null } };

export type CreateQrNotificationMutationVariables = Exact<{
  input: CreateQrNotificationInput;
}>;


export type CreateQrNotificationMutation = { createQrNotification: { _id: string, created_at: string, updated_at: string, content?: string | null } };

export type SubscribeToCurrentDeviceSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToCurrentDeviceSubscription = { subscribeToCurrentDevice: { type: DATA_EVENT_TYPE, id: string } };

export type SubscribeToMenuSubscriptionVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type SubscribeToMenuSubscription = { subscribeToMenu: { type: DATA_EVENT_TYPE, id: string, payload: { menu?: { _id: string } | null, category?: { _id: string } | null, item?: { _id: string } | null } } };

export type SubscribeToCurrentVenueSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToCurrentVenueSubscription = { subscribeToCurrentVenue: { type: DATA_EVENT_TYPE, id: string, payload?: { _id: string, updated_at: string, vat: number, service_charge: number, service_charge_bd?: number | null, default_service_charge_type: DEFAULT_SERVICE_CHARGE_TYPE, tax?: number | null } | null } };

export type SubscribeToDeviceOrdersSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToDeviceOrdersSubscription = { subscribeToDeviceOrders: { type: DEVICE_ORDER_EVENT_TYPE, id: string, payload?: { _id: string, device?: string | null, location: string, updated_at: string, index?: number | null, status: ORDER_STATUS, prep_time: number, is_paid: boolean, is_cancelled: boolean, is_needing_payment_confirmation: boolean, is_request_payment_confirmation: boolean, is_needing_prep_time_confirmation: boolean, is_needing_prep_time_acknowledgement?: boolean | null } | null } };

export type SubscribeToLocationSubscriptionVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type SubscribeToLocationSubscription = { subscribeToLocation: { type: DATA_EVENT_TYPE, id: string, payload?: { _id: string, updated_at: string, no_vat: boolean, no_service_charge: boolean } | null } };

export type SubscribeToOrderPaymentTypeAcceptEventSubscriptionVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type SubscribeToOrderPaymentTypeAcceptEventSubscription = { subscribeToOrderPaymentTypeAcceptEvent: { id: string } };

export type SubscribeToOrderSubscriptionVariables = Exact<{
  orderId?: InputMaybe<Scalars['ObjectID']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubscribeToOrderSubscription = { subscribeToOrder: { type: DATA_EVENT_TYPE, id: string, payload?: { _id: string, device?: string | null, location: string, updated_at: string, index?: number | null, status: ORDER_STATUS, prep_time: number, is_paid: boolean, is_cancelled: boolean, is_needing_payment_confirmation: boolean, is_request_payment_confirmation: boolean, is_needing_prep_time_confirmation: boolean, is_needing_prep_time_acknowledgement?: boolean | null } | null } };

export type SubscribeToSystemHealthSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToSystemHealthSubscription = { subscribeToSystemHealth: { type: SYSTEM_HEALTH_SUBSCRIPTION_EVENT_TYPE } };

export type CreateQrOrderMutationVariables = Exact<{
  input: CreateQrOrderInput;
}>;


export type CreateQrOrderMutation = { createQrOrder: { _id: string, is_needing_payment_confirmation: boolean, is_request_payment_confirmation: boolean } };

export type GetCustomerByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetCustomerByUidQuery = { getCustomerByUid: { _id: string, uid?: string | null, first_name: string, last_name: string, phone_number?: string | null } };

export type GetActiveMenuItemsQrQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetActiveMenuItemsQrQuery = { getActiveMenuItemsQr: { total: number, items: Array<{ _id: string, created_at: string, updated_at: string, item_id: string, cost: number, title: string, description?: string | null, banner_img?: string | null, is_qr_enabled: boolean, is_pos_enabled: boolean, no_vat: boolean, no_service_charge: boolean, is_open_item: boolean, is_hide_from_receipt: boolean, type: string, prep_time: number, is_template: boolean, clone_from?: string | null, ordering_index: number, extra_quantity: number, item_tags?: Array<string> | null, printer_tag?: string | null, original_price: number, minimum_required_price: number, listed_price: number, category: string, menu: string, venue: string, is_quantity_controlled?: boolean | null, controlled_quantity?: number | null, title_localized?: { cn?: string | null, kh?: string | null } | null, description_localized?: { cn?: string | null, kh?: string | null } | null, original_price_addons: { vat: { percentage: number, amount: number }, service_charge: { percentage: number, amount: number }, service_charge_bd?: { percentage: number, amount: number } | null }, recipe: Array<{ raw_material: string, unit_of_measurement: string, consumed_unit_of_measurement: string, consumed_quantity: number }>, options: Array<{ ordering_index: number, is_hide_from_receipt: boolean }>, option_groups: Array<{ is_required: boolean, minimum_select: number, maximum_select: number, ordering_index: number, options: Array<{ ordering_index: number, is_hide_from_receipt: boolean }> }>, availability?: { days?: Array<number> | null, times?: Array<{ from: string, to: string }> | null } | null }> } };

export type GetItemTagsByCategoryQueryVariables = Exact<{
  categoryId: Scalars['ObjectID']['input'];
}>;


export type GetItemTagsByCategoryQuery = { getItemTagsByCategory: Array<string> };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { getTags: Array<{ _id: string, created_at: string, updated_at: string, label: string, type: TAG_TYPE, ordering_index?: number | null, label_localized?: { cn?: string | null, kh?: string | null } | null }> };

export type ConfirmPaymentTypeForOrderMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type ConfirmPaymentTypeForOrderMutation = { confirmPaymentTypeForOrder: { _id: string } };

export type ConfirmPrepTimeForOrderMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
  isAccepted: Scalars['Boolean']['input'];
}>;


export type ConfirmPrepTimeForOrderMutation = { confirmPrepTimeForOrder: { _id: string, is_needing_prep_time_confirmation: boolean } };

export type DismissPrepTimeUpdateForOrderMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type DismissPrepTimeUpdateForOrderMutation = { dismissPrepTimeUpdateForOrder: { _id: string, is_needing_prep_time_acknowledgement?: boolean | null } };

export const CategoryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}},{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"_qr_items_count"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"times"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]} as unknown as DocumentNode<CategoryFragmentFragment, unknown>;
export const DeviceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeviceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Device"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"fcm_tokens"}},{"kind":"Field","name":{"kind":"Name","value":"_active_orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"prepared_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"staff"}},{"kind":"Field","name":{"kind":"Name","value":"original_orders"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"currencies_configs"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"current_location"}},{"kind":"Field","name":{"kind":"Name","value":"max_prepare_time"}},{"kind":"Field","name":{"kind":"Name","value":"items_count"}},{"kind":"Field","name":{"kind":"Name","value":"items_count_by_types"}},{"kind":"Field","name":{"kind":"Name","value":"prepped_count"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"offer_amount"}},{"kind":"Field","name":{"kind":"Name","value":"discount_amount"}},{"kind":"Field","name":{"kind":"Name","value":"net_amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd_amount"}},{"kind":"Field","name":{"kind":"Name","value":"adjustment_amount"}},{"kind":"Field","name":{"kind":"Name","value":"grand_total"}},{"kind":"Field","name":{"kind":"Name","value":"gross_amount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_amount"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_acknowledgement"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"is_cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"is_bill_printed"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_request_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DeviceFragmentFragment, unknown>;
export const ItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"banner_img"}},{"kind":"Field","name":{"kind":"Name","value":"is_qr_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_pos_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"no_vat"}},{"kind":"Field","name":{"kind":"Name","value":"no_service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"is_open_item"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}},{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"extra_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"printer_tag"}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_required_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"menu"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}},{"kind":"Field","name":{"kind":"Name","value":"_option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"option_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"menu"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"option_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_required"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_select"}},{"kind":"Field","name":{"kind":"Name","value":"maximum_select"}},{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"is_auto_select"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}},{"kind":"Field","name":{"kind":"Name","value":"_option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"option_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"menu"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_option_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"_option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"option_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"menu"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_master"}},{"kind":"Field","name":{"kind":"Name","value":"master_items"}},{"kind":"Field","name":{"kind":"Name","value":"item_tags"}},{"kind":"Field","name":{"kind":"Name","value":"is_quantity_controlled"}},{"kind":"Field","name":{"kind":"Name","value":"controlled_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"till_card_color"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"times"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]} as unknown as DocumentNode<ItemFragmentFragment, unknown>;
export const LocationSubscriptionSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationSubscriptionSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"no_vat"}},{"kind":"Field","name":{"kind":"Name","value":"no_service_charge"}}]}}]} as unknown as DocumentNode<LocationSubscriptionSummaryFragment, unknown>;
export const LocationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"payment_types"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"no_vat"}},{"kind":"Field","name":{"kind":"Name","value":"no_service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"is_pay_later_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"is_pay_now_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"locations_groups_tags"}},{"kind":"Field","name":{"kind":"Name","value":"room_number"}},{"kind":"Field","name":{"kind":"Name","value":"default_order_note"}},{"kind":"Field","name":{"kind":"Name","value":"hidden_items_configs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"item_types"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"is_items_hide_on_qr"}},{"kind":"Field","name":{"kind":"Name","value":"is_categories_hide_on_qr"}},{"kind":"Field","name":{"kind":"Name","value":"is_item_types_hide_on_qr"}}]}}]}}]} as unknown as DocumentNode<LocationFragmentFragment, unknown>;
export const MenuFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Menu"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"banner_img"}}]}}]} as unknown as DocumentNode<MenuFragmentFragment, unknown>;
export const OrderSubscriptionSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderSubscriptionSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"is_cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_request_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_acknowledgement"}}]}}]} as unknown as DocumentNode<OrderSubscriptionSummaryFragment, unknown>;
export const OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"prepared_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"prepared_by"}},{"kind":"Field","name":{"kind":"Name","value":"processed_by"}},{"kind":"Field","name":{"kind":"Name","value":"paid_by"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_by"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"staff"}},{"kind":"Field","name":{"kind":"Name","value":"original_orders"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"currencies_configs"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"current_location"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"item"}},{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_required_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit_price"}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"extra_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"serving_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"option"}},{"kind":"Field","name":{"kind":"Name","value":"option_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"serving_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_divided"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjustment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"delivered_count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"printer_tag"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_divided"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjustment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"net_amount"}},{"kind":"Field","name":{"kind":"Name","value":"gross_amount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_amount"}},{"kind":"Field","name":{"kind":"Name","value":"no_vat"}},{"kind":"Field","name":{"kind":"Name","value":"no_service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"is_open_item"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_prepare_time"}},{"kind":"Field","name":{"kind":"Name","value":"items_count"}},{"kind":"Field","name":{"kind":"Name","value":"items_count_by_types"}},{"kind":"Field","name":{"kind":"Name","value":"prepped_count"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"offer_amount"}},{"kind":"Field","name":{"kind":"Name","value":"discount_amount"}},{"kind":"Field","name":{"kind":"Name","value":"net_amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd_amount"}},{"kind":"Field","name":{"kind":"Name","value":"tax_amount"}},{"kind":"Field","name":{"kind":"Name","value":"adjustment_amount"}},{"kind":"Field","name":{"kind":"Name","value":"grand_total"}},{"kind":"Field","name":{"kind":"Name","value":"gross_amount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_amount"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_acknowledgement"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"is_cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"is_bill_printed"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_request_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"payment_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<OrderFragmentFragment, unknown>;
export const VenueSubscriptionSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VenueSubscriptionSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Venue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"}},{"kind":"Field","name":{"kind":"Name","value":"default_service_charge_type"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}}]} as unknown as DocumentNode<VenueSubscriptionSummaryFragment, unknown>;
export const VenueFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VenueFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Venue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"banner_img"}},{"kind":"Field","name":{"kind":"Name","value":"is_self_served"}},{"kind":"Field","name":{"kind":"Name","value":"allow_comments"}},{"kind":"Field","name":{"kind":"Name","value":"item_types"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason_options"}},{"kind":"Field","name":{"kind":"Name","value":"custom_payment_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"is_deactivated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auto_print_checklist"}},{"kind":"Field","name":{"kind":"Name","value":"currencies_configs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"previous_rate"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary_currency"}},{"kind":"Field","name":{"kind":"Name","value":"is_secondary_currency"}},{"kind":"Field","name":{"kind":"Name","value":"is_deactivated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fcm_tokens"}},{"kind":"Field","name":{"kind":"Name","value":"is_service_charge_buried"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"}},{"kind":"Field","name":{"kind":"Name","value":"is_service_charge_bd_buried"}},{"kind":"Field","name":{"kind":"Name","value":"is_vat_buried"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary_color"}},{"kind":"Field","name":{"kind":"Name","value":"primary_text_color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_digital_menu_user_login_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_digital_menu_user_sign_up_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_ordering_requires_customer"}},{"kind":"Field","name":{"kind":"Name","value":"is_qr_ordering_only"}},{"kind":"Field","name":{"kind":"Name","value":"default_service_charge_type"}},{"kind":"Field","name":{"kind":"Name","value":"custom_note_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"is_ordering_requires_note"}},{"kind":"Field","name":{"kind":"Name","value":"order_notification_dings"}},{"kind":"Field","name":{"kind":"Name","value":"is_payway_integration_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_internal_receipt_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_language_localization_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_digital_menu_additional_language_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"additional_digital_menu_languages"}},{"kind":"Field","name":{"kind":"Name","value":"is_required_headcount_before_payment"}},{"kind":"Field","name":{"kind":"Name","value":"is_payment_confirmation_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_payment_rounding_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"user_limit"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}}]} as unknown as DocumentNode<VenueFragmentFragment, unknown>;
export const CustomerSessionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerSessionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]} as unknown as DocumentNode<CustomerSessionFragmentFragment, unknown>;
export const UpdateCurrentDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCurrentDevice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCurrentDeviceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCurrentDevice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<UpdateCurrentDeviceMutation, UpdateCurrentDeviceMutationVariables>;
export const CheckoutWithPayWayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutWithPayWay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutWithPayWayInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutWithPayWay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qr_string"}},{"kind":"Field","name":{"kind":"Name","value":"checkout_qr_url"}},{"kind":"Field","name":{"kind":"Name","value":"abapay_deeplink"}},{"kind":"Field","name":{"kind":"Name","value":"payway_ref"}}]}}]}}]} as unknown as DocumentNode<CheckoutWithPayWayMutation, CheckoutWithPayWayMutationVariables>;
export const GetCurrentCustomerOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentCustomerOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentCustomerOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"prepared_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"prepared_by"}},{"kind":"Field","name":{"kind":"Name","value":"processed_by"}},{"kind":"Field","name":{"kind":"Name","value":"paid_by"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_by"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"staff"}},{"kind":"Field","name":{"kind":"Name","value":"original_orders"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"currencies_configs"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"current_location"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"item"}},{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_required_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit_price"}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"extra_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"serving_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"option"}},{"kind":"Field","name":{"kind":"Name","value":"option_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"serving_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_divided"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjustment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"delivered_count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"printer_tag"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_divided"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjustment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"net_amount"}},{"kind":"Field","name":{"kind":"Name","value":"gross_amount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_amount"}},{"kind":"Field","name":{"kind":"Name","value":"no_vat"}},{"kind":"Field","name":{"kind":"Name","value":"no_service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"is_open_item"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_prepare_time"}},{"kind":"Field","name":{"kind":"Name","value":"items_count"}},{"kind":"Field","name":{"kind":"Name","value":"items_count_by_types"}},{"kind":"Field","name":{"kind":"Name","value":"prepped_count"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"offer_amount"}},{"kind":"Field","name":{"kind":"Name","value":"discount_amount"}},{"kind":"Field","name":{"kind":"Name","value":"net_amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd_amount"}},{"kind":"Field","name":{"kind":"Name","value":"tax_amount"}},{"kind":"Field","name":{"kind":"Name","value":"adjustment_amount"}},{"kind":"Field","name":{"kind":"Name","value":"grand_total"}},{"kind":"Field","name":{"kind":"Name","value":"gross_amount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_amount"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_acknowledgement"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"is_cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"is_bill_printed"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_request_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"payment_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentCustomerOrdersQuery, GetCurrentCustomerOrdersQueryVariables>;
export const GetCurrentCustomerQrCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentCustomerQrCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentCustomerQrCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}}]}}]}}]} as unknown as DocumentNode<GetCurrentCustomerQrCodeQuery, GetCurrentCustomerQrCodeQueryVariables>;
export const GetCurrentCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerSessionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerSessionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]} as unknown as DocumentNode<GetCurrentCustomerQuery, GetCurrentCustomerQueryVariables>;
export const CustomerLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CustomerLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerSessionFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerSessionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]} as unknown as DocumentNode<CustomerLoginMutation, CustomerLoginMutationVariables>;
export const CustomerSignUpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CustomerSignUp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerSignUpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerSignUp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerSessionFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerSessionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]} as unknown as DocumentNode<CustomerSignUpMutation, CustomerSignUpMutationVariables>;
export const GetActiveMenuCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveMenuCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveMenuCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}},{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"_qr_items_count"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"times"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveMenuCategoriesQuery, GetActiveMenuCategoriesQueryVariables>;
export const GetActiveMenuItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveMenuItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveMenuItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"banner_img"}},{"kind":"Field","name":{"kind":"Name","value":"is_qr_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_pos_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"no_vat"}},{"kind":"Field","name":{"kind":"Name","value":"no_service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"is_open_item"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}},{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"extra_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"printer_tag"}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_required_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"menu"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}},{"kind":"Field","name":{"kind":"Name","value":"_option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"option_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"menu"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"option_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_required"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_select"}},{"kind":"Field","name":{"kind":"Name","value":"maximum_select"}},{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"is_auto_select"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}},{"kind":"Field","name":{"kind":"Name","value":"_option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"option_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"menu"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_option_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"_option"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"option_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"menu"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_master"}},{"kind":"Field","name":{"kind":"Name","value":"master_items"}},{"kind":"Field","name":{"kind":"Name","value":"item_tags"}},{"kind":"Field","name":{"kind":"Name","value":"is_quantity_controlled"}},{"kind":"Field","name":{"kind":"Name","value":"controlled_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"till_card_color"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"times"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveMenuItemQuery, GetActiveMenuItemQueryVariables>;
export const GetActiveMenuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveMenu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveMenu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Menu"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"banner_img"}}]}}]} as unknown as DocumentNode<GetActiveMenuQuery, GetActiveMenuQueryVariables>;
export const GetCurrentDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentDevice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentDevice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeviceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Device"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"fcm_tokens"}},{"kind":"Field","name":{"kind":"Name","value":"_active_orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"prepared_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"staff"}},{"kind":"Field","name":{"kind":"Name","value":"original_orders"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"currencies_configs"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"current_location"}},{"kind":"Field","name":{"kind":"Name","value":"max_prepare_time"}},{"kind":"Field","name":{"kind":"Name","value":"items_count"}},{"kind":"Field","name":{"kind":"Name","value":"items_count_by_types"}},{"kind":"Field","name":{"kind":"Name","value":"prepped_count"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"offer_amount"}},{"kind":"Field","name":{"kind":"Name","value":"discount_amount"}},{"kind":"Field","name":{"kind":"Name","value":"net_amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd_amount"}},{"kind":"Field","name":{"kind":"Name","value":"adjustment_amount"}},{"kind":"Field","name":{"kind":"Name","value":"grand_total"}},{"kind":"Field","name":{"kind":"Name","value":"gross_amount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_amount"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_acknowledgement"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"is_cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"is_bill_printed"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_request_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentDeviceQuery, GetCurrentDeviceQueryVariables>;
export const CreateNewDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewDevice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNewDevice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeviceFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeviceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Device"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"fcm_tokens"}},{"kind":"Field","name":{"kind":"Name","value":"_active_orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"prepared_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"staff"}},{"kind":"Field","name":{"kind":"Name","value":"original_orders"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"currencies_configs"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"current_location"}},{"kind":"Field","name":{"kind":"Name","value":"max_prepare_time"}},{"kind":"Field","name":{"kind":"Name","value":"items_count"}},{"kind":"Field","name":{"kind":"Name","value":"items_count_by_types"}},{"kind":"Field","name":{"kind":"Name","value":"prepped_count"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"offer_amount"}},{"kind":"Field","name":{"kind":"Name","value":"discount_amount"}},{"kind":"Field","name":{"kind":"Name","value":"net_amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd_amount"}},{"kind":"Field","name":{"kind":"Name","value":"adjustment_amount"}},{"kind":"Field","name":{"kind":"Name","value":"grand_total"}},{"kind":"Field","name":{"kind":"Name","value":"gross_amount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_amount"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_acknowledgement"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"is_cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"is_bill_printed"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_request_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateNewDeviceMutation, CreateNewDeviceMutationVariables>;
export const GetCurrentLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"payment_types"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"no_vat"}},{"kind":"Field","name":{"kind":"Name","value":"no_service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"is_pay_later_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"is_pay_now_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"locations_groups_tags"}},{"kind":"Field","name":{"kind":"Name","value":"room_number"}},{"kind":"Field","name":{"kind":"Name","value":"default_order_note"}},{"kind":"Field","name":{"kind":"Name","value":"hidden_items_configs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"item_types"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"is_items_hide_on_qr"}},{"kind":"Field","name":{"kind":"Name","value":"is_categories_hide_on_qr"}},{"kind":"Field","name":{"kind":"Name","value":"is_item_types_hide_on_qr"}}]}}]}}]} as unknown as DocumentNode<GetCurrentLocationQuery, GetCurrentLocationQueryVariables>;
export const GetCurrentVenueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentVenue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentVenue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VenueFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VenueFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Venue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"banner_img"}},{"kind":"Field","name":{"kind":"Name","value":"is_self_served"}},{"kind":"Field","name":{"kind":"Name","value":"allow_comments"}},{"kind":"Field","name":{"kind":"Name","value":"item_types"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason_options"}},{"kind":"Field","name":{"kind":"Name","value":"custom_payment_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"is_deactivated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auto_print_checklist"}},{"kind":"Field","name":{"kind":"Name","value":"currencies_configs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"previous_rate"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary_currency"}},{"kind":"Field","name":{"kind":"Name","value":"is_secondary_currency"}},{"kind":"Field","name":{"kind":"Name","value":"is_deactivated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fcm_tokens"}},{"kind":"Field","name":{"kind":"Name","value":"is_service_charge_buried"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"}},{"kind":"Field","name":{"kind":"Name","value":"is_service_charge_bd_buried"}},{"kind":"Field","name":{"kind":"Name","value":"is_vat_buried"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary_color"}},{"kind":"Field","name":{"kind":"Name","value":"primary_text_color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_digital_menu_user_login_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_digital_menu_user_sign_up_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_ordering_requires_customer"}},{"kind":"Field","name":{"kind":"Name","value":"is_qr_ordering_only"}},{"kind":"Field","name":{"kind":"Name","value":"default_service_charge_type"}},{"kind":"Field","name":{"kind":"Name","value":"custom_note_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"is_ordering_requires_note"}},{"kind":"Field","name":{"kind":"Name","value":"order_notification_dings"}},{"kind":"Field","name":{"kind":"Name","value":"is_payway_integration_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_internal_receipt_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_language_localization_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_digital_menu_additional_language_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"additional_digital_menu_languages"}},{"kind":"Field","name":{"kind":"Name","value":"is_required_headcount_before_payment"}},{"kind":"Field","name":{"kind":"Name","value":"is_payment_confirmation_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_payment_rounding_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"user_limit"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}}]} as unknown as DocumentNode<GetCurrentVenueQuery, GetCurrentVenueQueryVariables>;
export const GetMaintenanceStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMaintenanceStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMaintenanceStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<GetMaintenanceStatusQuery, GetMaintenanceStatusQueryVariables>;
export const GetOrderByPayWayRefDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderByPayWayRef"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ref"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderByPayWayRef"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ref"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ref"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"prepared_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"prepared_by"}},{"kind":"Field","name":{"kind":"Name","value":"processed_by"}},{"kind":"Field","name":{"kind":"Name","value":"paid_by"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_by"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"staff"}},{"kind":"Field","name":{"kind":"Name","value":"original_orders"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"currencies_configs"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"current_location"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"item"}},{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_required_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit_price"}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"extra_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"serving_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"option"}},{"kind":"Field","name":{"kind":"Name","value":"option_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"serving_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_divided"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjustment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"delivered_count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"printer_tag"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_divided"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjustment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"net_amount"}},{"kind":"Field","name":{"kind":"Name","value":"gross_amount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_amount"}},{"kind":"Field","name":{"kind":"Name","value":"no_vat"}},{"kind":"Field","name":{"kind":"Name","value":"no_service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"is_open_item"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_prepare_time"}},{"kind":"Field","name":{"kind":"Name","value":"items_count"}},{"kind":"Field","name":{"kind":"Name","value":"items_count_by_types"}},{"kind":"Field","name":{"kind":"Name","value":"prepped_count"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"offer_amount"}},{"kind":"Field","name":{"kind":"Name","value":"discount_amount"}},{"kind":"Field","name":{"kind":"Name","value":"net_amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd_amount"}},{"kind":"Field","name":{"kind":"Name","value":"tax_amount"}},{"kind":"Field","name":{"kind":"Name","value":"adjustment_amount"}},{"kind":"Field","name":{"kind":"Name","value":"grand_total"}},{"kind":"Field","name":{"kind":"Name","value":"gross_amount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_amount"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_acknowledgement"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"is_cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"is_bill_printed"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_request_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"payment_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderByPayWayRefQuery, GetOrderByPayWayRefQueryVariables>;
export const GetOrderByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"prepared_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed_at"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"prepared_by"}},{"kind":"Field","name":{"kind":"Name","value":"processed_by"}},{"kind":"Field","name":{"kind":"Name","value":"paid_by"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_by"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"staff"}},{"kind":"Field","name":{"kind":"Name","value":"original_orders"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"currencies_configs"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"current_location"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"item"}},{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_required_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit_price"}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"extra_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"serving_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_reason"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"option"}},{"kind":"Field","name":{"kind":"Name","value":"option_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"serving_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_divided"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjustment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"delivered_count"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"printer_tag"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_divided"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_included"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjustment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"net_amount"}},{"kind":"Field","name":{"kind":"Name","value":"gross_amount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_amount"}},{"kind":"Field","name":{"kind":"Name","value":"no_vat"}},{"kind":"Field","name":{"kind":"Name","value":"no_service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"is_open_item"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max_prepare_time"}},{"kind":"Field","name":{"kind":"Name","value":"items_count"}},{"kind":"Field","name":{"kind":"Name","value":"items_count_by_types"}},{"kind":"Field","name":{"kind":"Name","value":"prepped_count"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"offer_amount"}},{"kind":"Field","name":{"kind":"Name","value":"discount_amount"}},{"kind":"Field","name":{"kind":"Name","value":"net_amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_amount"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd_amount"}},{"kind":"Field","name":{"kind":"Name","value":"tax_amount"}},{"kind":"Field","name":{"kind":"Name","value":"adjustment_amount"}},{"kind":"Field","name":{"kind":"Name","value":"grand_total"}},{"kind":"Field","name":{"kind":"Name","value":"gross_amount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_amount"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_acknowledgement"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"is_cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"is_bill_printed"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_request_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"payment_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderByIdQuery, GetOrderByIdQueryVariables>;
export const CreateQrNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateQrNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateQrNotificationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createQrNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<CreateQrNotificationMutation, CreateQrNotificationMutationVariables>;
export const SubscribeToCurrentDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SubscribeToCurrentDevice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToCurrentDevice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SubscribeToCurrentDeviceSubscription, SubscribeToCurrentDeviceSubscriptionVariables>;
export const SubscribeToMenuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SubscribeToMenu"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToMenu"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubscribeToMenuSubscription, SubscribeToMenuSubscriptionVariables>;
export const SubscribeToCurrentVenueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SubscribeToCurrentVenue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToCurrentVenue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VenueSubscriptionSummary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VenueSubscriptionSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Venue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"}},{"kind":"Field","name":{"kind":"Name","value":"default_service_charge_type"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}}]} as unknown as DocumentNode<SubscribeToCurrentVenueSubscription, SubscribeToCurrentVenueSubscriptionVariables>;
export const SubscribeToDeviceOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SubscribeToDeviceOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToDeviceOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderSubscriptionSummary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderSubscriptionSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"is_cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_request_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_acknowledgement"}}]}}]} as unknown as DocumentNode<SubscribeToDeviceOrdersSubscription, SubscribeToDeviceOrdersSubscriptionVariables>;
export const SubscribeToLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SubscribeToLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationSubscriptionSummary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationSubscriptionSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"no_vat"}},{"kind":"Field","name":{"kind":"Name","value":"no_service_charge"}}]}}]} as unknown as DocumentNode<SubscribeToLocationSubscription, SubscribeToLocationSubscriptionVariables>;
export const SubscribeToOrderPaymentTypeAcceptEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SubscribeToOrderPaymentTypeAcceptEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToOrderPaymentTypeAcceptEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SubscribeToOrderPaymentTypeAcceptEventSubscription, SubscribeToOrderPaymentTypeAcceptEventSubscriptionVariables>;
export const SubscribeToOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SubscribeToOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ref"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ref"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ref"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderSubscriptionSummary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderSubscriptionSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"is_cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_request_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_acknowledgement"}}]}}]} as unknown as DocumentNode<SubscribeToOrderSubscription, SubscribeToOrderSubscriptionVariables>;
export const SubscribeToSystemHealthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SubscribeToSystemHealth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToSystemHealth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<SubscribeToSystemHealthSubscription, SubscribeToSystemHealthSubscriptionVariables>;
export const CreateQrOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateQrOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateQrOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createQrOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_payment_confirmation"}},{"kind":"Field","name":{"kind":"Name","value":"is_request_payment_confirmation"}}]}}]}}]} as unknown as DocumentNode<CreateQrOrderMutation, CreateQrOrderMutationVariables>;
export const GetCustomerByUidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomerByUid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomerByUid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}}]}}]}}]} as unknown as DocumentNode<GetCustomerByUidQuery, GetCustomerByUidQueryVariables>;
export const GetActiveMenuItemsQrDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveMenuItemsQr"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveMenuItemsQr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"tags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"banner_img"}},{"kind":"Field","name":{"kind":"Name","value":"is_qr_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_pos_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"no_vat"}},{"kind":"Field","name":{"kind":"Name","value":"no_service_charge"}},{"kind":"Field","name":{"kind":"Name","value":"is_open_item"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"prep_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"clone_from"}},{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"extra_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"item_tags"}},{"kind":"Field","name":{"kind":"Name","value":"printer_tag"}},{"kind":"Field","name":{"kind":"Name","value":"original_price"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_required_price"}},{"kind":"Field","name":{"kind":"Name","value":"original_price_addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_charge_bd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listed_price"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"menu"}},{"kind":"Field","name":{"kind":"Name","value":"venue"}},{"kind":"Field","name":{"kind":"Name","value":"recipe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw_material"}},{"kind":"Field","name":{"kind":"Name","value":"unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_unit_of_measurement"}},{"kind":"Field","name":{"kind":"Name","value":"consumed_quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"option_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_required"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_select"}},{"kind":"Field","name":{"kind":"Name","value":"maximum_select"}},{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}},{"kind":"Field","name":{"kind":"Name","value":"is_hide_from_receipt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_quantity_controlled"}},{"kind":"Field","name":{"kind":"Name","value":"controlled_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"times"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveMenuItemsQrQuery, GetActiveMenuItemsQrQueryVariables>;
export const GetItemTagsByCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetItemTagsByCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getItemTagsByCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}]}}]} as unknown as DocumentNode<GetItemTagsByCategoryQuery, GetItemTagsByCategoryQueryVariables>;
export const GetTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"menu_item_display"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_localized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cn"}},{"kind":"Field","name":{"kind":"Name","value":"kh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"ordering_index"}}]}}]}}]} as unknown as DocumentNode<GetTagsQuery, GetTagsQueryVariables>;
export const ConfirmPaymentTypeForOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmPaymentTypeForOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmPaymentTypeForOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<ConfirmPaymentTypeForOrderMutation, ConfirmPaymentTypeForOrderMutationVariables>;
export const ConfirmPrepTimeForOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmPrepTimeForOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isAccepted"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmPrepTimeForOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"isAccepted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isAccepted"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_confirmation"}}]}}]}}]} as unknown as DocumentNode<ConfirmPrepTimeForOrderMutation, ConfirmPrepTimeForOrderMutationVariables>;
export const DismissPrepTimeUpdateForOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissPrepTimeUpdateForOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissPrepTimeUpdateForOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_needing_prep_time_acknowledgement"}}]}}]}}]} as unknown as DocumentNode<DismissPrepTimeUpdateForOrderMutation, DismissPrepTimeUpdateForOrderMutationVariables>;